angular.module("commons").run(['$templateCache', function(a) { a.put('warning.tpl.html', '<div class="modal-header">\n' +
    '  <h4 class="modal-title">{{confirmCtrl.model.title}}</h4>\n' +
    '  <button type="button" data-ng-click="confirmCtrl.onCloseClick()" class="close" data-dismiss="modal" aria-hidden="true"><i class="material-icons">clear</i></button>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '\n' +
    '  <p class="bold font-16" data-ng-repeat="msg in confirmCtrl.model.msgCol">{{msg}}</p>\n' +
    '\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '  <button class="btn btn-blue" type="button" ng-click="confirmCtrl.onYesClick()">OK</button>\n' +
    '</div>');
	a.put('training_sync_response.tpl.html', '<div class="modal-header">\n' +
    '  <div ng-show="trainingSyncCtrl.model.otherHubValidationResponses.length != 0">\n' +
    '    <h4 class="modal-title" style="color: red">Cannot proceed the request</h4>\n' +
    '  </div>\n' +
    '  <div ng-show="trainingSyncCtrl.model.syncResponses.length != 0">\n' +
    '    <h4 class="modal-title">Other Hub Sync Completed.</h4>\n' +
    '  </div>\n' +
    '  <button type="button" class="close" data-dismiss="modal" data-ng-click="trainingSyncCtrl.closeMe()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '  </button>\n' +
    '</div>\n' +
    '<div class="modal-body margin-bottom-50 add-pattern">\n' +
    '  <div ng-show="trainingSyncCtrl.model.otherHubValidationResponses.length">\n' +
    '    <div class="col-md-12 header-container">\n' +
    '      <div class="add-pattern-wrapper">\n' +
    '        <div class="pattern-div-header">\n' +
    '          <div class="headers bold" style="width:50%; text-align: center">Hub</div>\n' +
    '          <div class="headers bold" style="width:50%; text-align: center">Validations</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-md-12 add-pattern-container">\n' +
    '\n' +
    '      <div class="add-pattern-wrapper" data-ng-repeat="response in trainingSyncCtrl.model.otherHubValidationResponses">\n' +
    '\n' +
    '        <div class="pattern-div-header row-content" ng-class="{\'alternate\':$index % 2 == 0}">\n' +
    '          <div class="headers bold" style="width:50%; text-align: center">{{response.tenant}}</div>\n' +
    '          <div class="headers bold" style="width:50%; text-align: center">{{response.validation}}</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="clearfix"></div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row" ng-show="trainingSyncCtrl.model.syncResponses.length">\n' +
    '\n' +
    '    <div class="col-md-12 header-container">\n' +
    '      <div class="add-pattern-wrapper">\n' +
    '        <div class="pattern-div-header">\n' +
    '          <div class="headers bold" style="width:50%; text-align: center">Hub</div>\n' +
    '          <div class="headers bold" style="width:50%; text-align: center">Sync Status</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-md-12 add-pattern-container">\n' +
    '\n' +
    '      <div class="add-pattern-wrapper" data-ng-repeat="response in trainingSyncCtrl.model.syncResponses">\n' +
    '\n' +
    '        <div class="pattern-div-header row-content" ng-class="{\'alternate\':$index % 2 == 0}">\n' +
    '          <div class="headers bold" style="width:50%; text-align: center">{{response.tenant}}</div>\n' +
    '          <div class="headers bold" style="width:50%; text-align: center">{{response.syncStatus}}</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="clearfix"></div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div ng-show="trainingSyncCtrl.model.syncResponses.length == 0 && trainingSyncCtrl.model.otherHubValidationResponses.length == 0">\n' +
    '    <div class="col-md-12 no-pairing">Training Sync Data not available</div>\n' +
    '\n' +
    '  </div>\n' +
    '</div>');
	a.put('training-stages-popup.tpl.html', '<div class="modal-header">\n' +
    '  <h4 class="modal-title">Training Stages</h4>\n' +
    '  <button type="button" class="close" data-dismiss="modal" data-ng-click="trainingStages.onCloseClick()" aria-hidden="true">\n' +
    '    <i class="material-icons">clear</i>\n' +
    '  </button>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-body margin-bottom-50 show-expiry" style="-webkit-user-select: text; user-select: text">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-12 header-container" data-ng-repeat="stage in trainingStages.model.crewTrainingStageDTOList track by $index">\n' +
    '      <div class="add-pattern-wrapper">\n' +
    '        <div class="pattern-div-header">\n' +
    '          <div class="headers bold" style="width:100%;text-align: left">\n' +
    '            Stage: {{stage.stageName}} (Sequence: {{stage.sequence}})\n' +
    '          </div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '        <!-- Table Headers -->\n' +
    '        <div class="pattern-div-header">\n' +
    '          <div class="headers bold" style="width:10%;text-align: center">#</div>\n' +
    '          <div class="headers bold" style="width:20%;text-align: center">Segment</div>\n' +
    '          <div class="headers bold" style="width:50%;text-align: center">Flight Date</div>\n' +
    '          <div class="headers bold" style="width:20%;text-align: center">Training Type</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '        <!-- Table Rows -->\n' +
    '        <div class="pattern-div-header row-content" data-ng-repeat="flight in stage.trainingFlightLegDTOList track by $index">\n' +
    '          <div class="headers" style="width:10%;text-align: center">{{flight.sequence}}</div>\n' +
    '          <div class="headers" style="width:20%;text-align: center">{{flight.origin}} / {{flight.destination}}</div>\n' +
    '          <div class="headers" style="width:50%;text-align: center">{{flight.estDepartureDateTime}}</div>\n' +
    '          <div class="headers" style="width:20%;text-align: center">{{flight.trainingType}}</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row" data-ng-if="trainingStages.model.crewTrainingStageViolatedSectorList && trainingStages.model.crewTrainingStageViolatedSectorList.length > 0">\n' +
    '    <div class="col-md-12 header-container">\n' +
    '      <div class="add-pattern-wrapper">\n' +
    '        <div class="pattern-div-header">\n' +
    '          <div class="headers bold" style="width:100%;text-align: left;color:red">Training Stage Discrepancy</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '        <!-- Table Headers -->\n' +
    '        <div class="pattern-div-header">\n' +
    '          <div class="headers bold" style="width:10%;text-align: center">#</div>\n' +
    '          <div class="headers bold" style="width:20%;text-align: center">Segment</div>\n' +
    '          <div class="headers bold" style="width:50%;text-align: center">Flight Date</div>\n' +
    '          <div class="headers bold" style="width:20%;text-align: center">Training Type</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '        <!-- Violation Rows -->\n' +
    '        <div class="pattern-div-header row-content" data-ng-repeat="violation in trainingStages.model.crewTrainingStageViolatedSectorList track by $index">\n' +
    '          <div class="headers" style="width:10%;text-align: center">{{$index + 1}}</div>\n' +
    '          <div class="headers" style="width:20%;text-align: center">{{violation.origin}} / {{violation.destination}}</div>\n' +
    '          <div class="headers" style="width:50%;text-align: center">{{violation.estDepartureDateTime}}</div>\n' +
    '          <div class="headers" style="width:20%;text-align: center">{{violation.trainingType}}</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>');
	a.put('tracking_flightFilter.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Filter Flight</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" data-ng-click="flightFilter.onClose()">\n' +
    '        <i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '    <div class="sel-date">{{crewFilter.model.selectedValues.day}}</div>\n' +
    '</div>\n' +
    '<div class="modal-body crew-filter">\n' +
    '    <div class="row">\n' +
    '        <div class="col-sm-12">\n' +
    '            <label class="label-top-0 margin-bottom-20"><b>Fleet Number/ Flight Registration Number</b></label>\n' +
    '            <advance-select-component input-mode="typehead" selected-values="flightFilter.model.selectedRegNumbers" selected-value-display-field="registrationName" date-source="flightFilter.model.allAircrafts" input-field-label=""></advance-select-component>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '        <div class="col-md-12">\n' +
    '            <button class="btn save-btn pull-right" data-ng-click="flightFilter.onFilterClick()">Filter</button>\n' +
    '            <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
	a.put('toastr-custome.tpl.html', '<div class="{{toastClass}} {{toastType}}" ng-click="tapToast()">\n' +
    '    <div ng-switch="" on="allowHtml">\n' +
    '        <div ng-switch-default="" ng-if="title" class="{{titleClass}}" aria-label="{{title}}">{{title}}</div>\n' +
    '        <div ng-switch-default="" class="{{messageClass}}" aria-label="{{message}}">{{message}}</div>\n' +
    '        <div ng-switch-when="true" ng-if="title" class="{{titleClass}}" ng-bind-html="title"></div>\n' +
    '        <div ng-switch-when="true" class="{{messageClass}}" ng-bind-html="message"></div>\n' +
    '    </div>\n' +
    '    <progress-bar ng-if="progressBar"></progress-bar>\n' +
    '</div>');
	a.put('sms.tpl.html', '<div class="modal-header">\n' +
    '  <h4 class="modal-title">Send SMS</h4>\n' +
    '  <button type="button" class="close" data-dismiss="modal" data-ng-click="sms.closeMe()" aria-hidden="true">\n' +
    '    <i class="material-icons">clear</i>\n' +
    '  </button>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-12 padding-0">\n' +
    '      <table class="table">\n' +
    '        <thead>\n' +
    '          <tr>\n' +
    '            <th class="td-vertical-align text-center">#</th>\n' +
    '            <th class="td-vertical-align text-center">\n' +
    '              <div>\n' +
    '                <input type="checkbox" id="test-{{crewDetail.crewProfileId}}" ng-click="sms.clickOnRow($event, $index, rowData, \'SELECT_ALL\')">\n' +
    '                <label class="checkbox" for="test-{{crewDetail.crewProfileId}}"></label>\n' +
    '              </div>\n' +
    '            </th>\n' +
    '            <th class="td-vertical-align text-center">Rank</th>\n' +
    '            <th class="td-vertical-align text-left">Name</th>\n' +
    '            <th class="td-vertical-align text-center">Contact No</th>\n' +
    '            <th class="td-vertical-align text-center">Sign In</th>\n' +
    '            <th class="td-vertical-align text-center">Sign Out</th>\n' +
    '          </tr>\n' +
    '        </thead>\n' +
    '        <tbody>\n' +
    '        <tr ng-if="sms.model.crewDetails.length == 0">\n' +
    '          <td colspan="4" align="center">No Records Found</td>\n' +
    '        </tr>\n' +
    '\n' +
    '        <tr data-ng-repeat="crewDetail in sms.model.crewDetails | filter: sms.predicate(sms.model.crewType) track by $index">\n' +
    '          <td class="td-vertical-align text-center">\n' +
    '            <div>{{$index+1}}</div>\n' +
    '          </td>\n' +
    '          <td class="td-vertical-align text-center">\n' +
    '            <div>\n' +
    '              <input type="checkbox" id="{{crewDetail.crewProfileId}}" ng-model="crewDetail.isChecked">\n' +
    '              <label class="checkbox" for="{{crewDetail.crewProfileId}}"></label>\n' +
    '            </div>\n' +
    '          </td>\n' +
    '          <td class="td-vertical-align text-center">\n' +
    '            <div>{{crewDetail.crewTypeCode}}</div>\n' +
    '          </td>\n' +
    '          <td class="td-vertical-align text-left">\n' +
    '            <div>{{crewDetail.crewName}}</div>\n' +
    '          </td>\n' +
    '          <td class="td-vertical-align text-center">\n' +
    '            <div>{{crewDetail.mobileNumber}}</div>\n' +
    '          </td>\n' +
    '          <td class="td-vertical-align text-center">\n' +
    '            <div>{{crewDetail.signInDate}} {{crewDetail.signInTime}}</div>\n' +
    '          </td>\n' +
    '          <td class="td-vertical-align text-center">\n' +
    '            <div>{{crewDetail.signOutDate}} {{crewDetail.signOutTime}}</div>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '        </tbody>\n' +
    '      </table>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<div class="col-md-12">\n' +
    '  <div class="col-md-3">\n' +
    '    <div class="group">\n' +
    '      <select-component component-name="Crew Type" label-field-name="crewTypeDescription" value-field-name="crewTypeCode" menu-data-source="sms.model.crewTypes" selected-value="sms.model.crewType" on-item-selected="sms.changeAny($event, \'crewType\')">\n' +
    '\n' +
    '      </select-component>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="col-md-1">\n' +
    '    <label>Message<span class="required-star">*</span></label>\n' +
    '  </div>\n' +
    '  <div class="col-md-8">\n' +
    '    <textarea data-ng-model="sms.model.request.message"></textarea>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '\n' +
    '<div class="row margin-bottom-20">\n' +
    '  <div class="col-md-2">\n' +
    '  </div>\n' +
    '  <div class="col-md-10">\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '<div class="modal-body send-sms">\n' +
    '\n' +
    '\n' +
    '  <div class="row margin-bottom-10">\n' +
    '    <div class="col-sm-2">\n' +
    '      <input type="checkbox" id="test11" ng-model="sms.model.request.isConfirm"><label for="test11" class="margin-top-10"></label>\n' +
    '    </div>\n' +
    '    <div class="col-sm-7">\n' +
    '      <label>This message should be confirmed with in : </label>\n' +
    '    </div>\n' +
    '    <div class="col-sm-3">\n' +
    '      <div class="group">\n' +
    '        <input type="text" name="no_of_house" data-ng-model="sms.model.request.no_of_house">\n' +
    '        <span class="bar"></span>\n' +
    '        <label>Hrs</label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row margin-bottom-10">\n' +
    '    <div class="col-md-12">\n' +
    '      <button class="btn btn-blue pull-right" type="button" data-ng-click="sms.onSendSms()">Send</button>\n' +
    '      <button class="btn btn-grey" type="button" data-ng-click="sms.closeMe()">Close</button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '</div>');
	a.put('show_violations.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Distribution Violation Reason</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="showViolations.onCloseClick()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-body margin-bottom-50 show-expiry">\n' +
    '    <div class="row" ng-show="showViolations.model.violations.length">\n' +
    '        <div class="col-md-12 header-container">\n' +
    '            <div class="add-pattern-wrapper">\n' +
    '                <div class="pattern-div-header">\n' +
    '                    <div class="headers bold" style="width:20%">Distribution Identifier</div>\n' +
    '                    <div class="headers bold" style="width:30%">Allowed no of days</div>\n' +
    '                    <div class="headers bold" style="width:25%">Allowed number of duties</div>\n' +
    '                    <div class="headers bold" style="width:25%">Assigned duties</div>\n' +
    '                    <div class="clearfix"></div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-md-12">\n' +
    '            <div class="add-pattern-wrapper" data-ng-repeat="violation in showViolations.model.violations track by $index">\n' +
    '                <div class="pattern-div-header row-content" ng-class="{\'alternate\':$index % 2 == 0}">\n' +
    '                    <div class="headers bold" style="width:20%">{{violation.distIdentifier}}&nbsp;</div>\n' +
    '                    <div class="headers bold" style="width:30%">{{violation.allowedDaysCount}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:25%">{{violation.allowedDutiesCount}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:25%">{{violation.currentDutiesCount}}&nbsp;</div>\n' +
    '                    <div class="clearfix"></div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
	a.put('show_training_automation_summary.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Training Schedule Automated Summary</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="trainingAutomationSummary.onCloseClick()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-body margin-bottom-50 show-expiry">\n' +
    '    <div class="row" ng-show="trainingAutomationSummary.model.trainingSummary.length">\n' +
    '        <div class="col-md-12 header-container">\n' +
    '            <div class="add-pattern-wrapper">\n' +
    '                <div class="pattern-div-header">\n' +
    '                    <div class="headers bold" style="width:8%">Training Category</div>\n' +
    '                    <div class="headers bold" style="width:8%">Training Program</div>\n' +
    '                    <div class="headers bold" style="width:10%">Total Number Of Slots</div>\n' +
    '                    <div class="headers bold" style="width:10%">Total Number Of Slots 100% Filled</div>\n' +
    '                    <div class="headers bold" style="width:10%">Total Number Of Slots Filled Above 50%</div>\n' +
    '                    <div class="headers bold" style="width:10%">Total Number Of Slots Filled Below 50%</div>\n' +
    '                    <div class="headers bold" style="width:10%">Vacant Slots</div>\n' +
    '                    <div class="headers bold" style="width:8%">Crew Type</div>\n' +
    '                    <div class="headers bold" style="width:10%">Total Number crew who need training</div>\n' +
    '                    <div class="headers bold" style="width:8%">Assigned</div>\n' +
    '                    <div class="headers bold" style="width:8%">Un-assigned</div>\n' +
    '                                  \n' +
    '                    <div class="clearfix"></div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-md-12">\n' +
    '            <div class="add-pattern-wrapper" data-ng-repeat="sum in trainingAutomationSummary.model.trainingSummary track by $index">\n' +
    '                <div class="pattern-div-header row-content" ng-class="{\'alternate\':$index % 2 == 0}">\n' +
    '                    <div class="headers bold" style="width:8%">{{sum.trainingCategory}}&nbsp;</div>\n' +
    '                    <div class="headers bold" style="width:8%">{{sum.trainingProgramCode}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:10%">{{sum.totalNoOfSlots}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:10%">{{sum.noOfSlotsTotallyFilled}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:10%">{{sum.noOfSlotsFilledAboveHalf}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:10%">{{sum.noOfSlotsFilledBelowHalf}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:10%">{{sum.noOfVacantSlot}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:8%">{{sum.crewTypeCode}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:10%">{{sum.totalNoOfExpiries}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:8%">{{sum.slotAssignedCrewCount}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:8%">{{sum.slotUnassignedCrewCount}}&nbsp;</div>\n' +
    '                    <div class="clearfix"></div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '    </div>   \n' +
    '</div>');
	a.put('show_expiry.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Expiry</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="expiry.closeMe()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-body margin-bottom-50 show-expiry">\n' +
    '    <div class="row" ng-show="::expiry.model.expiryData.length">\n' +
    '\n' +
    '        <div class="col-md-12 header-container">\n' +
    '            <div class="add-pattern-wrapper">\n' +
    '                <div class="pattern-div-header">\n' +
    '                    <div class="headers bold" style="width:20%">Code</div>\n' +
    '                    <div class="headers bold" style="width:30%">Validation no</div>\n' +
    '                    <div class="headers bold" style="width:25%">Date of Expiry</div>\n' +
    '                    <div class="headers bold" style="width:25%">Date of Warning</div>\n' +
    '                    <div class="clearfix"></div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-md-12">\n' +
    '\n' +
    '            <div class="add-pattern-wrapper" data-ng-repeat="exp in ::expiry.model.expiryData track by $index">\n' +
    '\n' +
    '                <div class="pattern-div-header row-content" ng-class="{\'alternate\':$index % 2 == 0}">\n' +
    '                    <div class="headers bold" style="width:20%">{{::exp.validationCode}}&nbsp;</div>\n' +
    '                    <div class="headers bold" style="width:30%">{{::exp.validationNumber}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:25%">{{::exp.dateOfExpiry}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:25%">{{::exp.warningDate}}&nbsp;</div>\n' +
    '                    <div class="clearfix"></div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div ng-show="historyCtrl.model.history.length == 0">\n' +
    '        <div class="col-md-12 no-pairing">Expiries not available</div>\n' +
    '\n' +
    '    </div>\n' +
    '</div>');
	a.put('sby_call_out.tpl.html', '<div class="modal-header">\n' +
    '  <h4 class="modal-title">{{sbyCallOutCtrl.model.title}}</h4>\n' +
    '  <button type="button" data-ng-click="sbyCallOutCtrl.onCloseClick()" class="close" data-dismiss="modal" aria-hidden="true"><i class="material-icons">clear</i></button>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '\n' +
    '  <div class="col-md-12 col-sm-3">\n' +
    '    <div class="group row">\n' +
    '      <div class="col-md-6">\n' +
    '      <input type="text" class="calID" jq-date-picker-options="" ng-model="sbyCallOutCtrl.model.date"> <span class="bar"></span> <label>Date Time(Local)<span class="required-star">*</span></label>\n' +
    '      </div>\n' +
    '      <div class="col-md-6">\n' +
    '      <input type="text" ng-model="sbyCallOutCtrl.model.time" ui-mask-placeholder="HH:MM" model-view-value="true" ui-mask="29:69" ui-mask-auto-complete="">\n' +
    '      <span class="bar"></span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div style="color: red">{{ sbyCallOutCtrl.model.error }}</div>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '  <button class="btn btn-blue" type="button" ng-click="sbyCallOutCtrl.onYesClick()">Yes</button>\n' +
    '  <button class="btn btn-grey" type="button" ng-click="sbyCallOutCtrl.onNoClick()">No</button>\n' +
    '</div>');
	a.put('roster-scoring-popup.tpl.html', '<div class="modal-header">\n' +
    '  <h4 class="modal-title">Roster Scoring Report</h4>\n' +
    '  <button type="button" class="close" data-dismiss="modal" data-ng-click="scoringPopup.onCloseClick()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '  </button>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-body margin-bottom-50 show-expiry" style="-webkit-user-select: text;\n' +
    '    -khtml-user-select: text;\n' +
    '    -moz-user-select: text;\n' +
    '    -o-user-select: text;\n' +
    '    user-select: text">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-12 header-container">\n' +
    '      <div class="add-pattern-wrapper">\n' +
    '        <div class="pattern-div-header">\n' +
    '          <div class="headers bold" style="width:40%;;padding: 5px">Rule Description</div>\n' +
    '          <div class="headers bold" style="width:15%;text-align: center;padding: 5px">Desirability</div>\n' +
    '          <div class="headers bold" style="width:15%;text-align: center;padding: 5px">Score</div>\n' +
    '          <div class="headers bold" style="width:15%;text-align: center;padding: 5px">Weighted Score</div>\n' +
    '          <div class="headers bold" style="width:15%;text-align: center;padding: 5px">Score Percentage</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-md-12">\n' +
    '      <div class="add-pattern-wrapper" data-ng-repeat="cr in scoringPopup.model.scores track by $index">\n' +
    '        <div class="pattern-div-header row-content">\n' +
    '          <div class="headers" style="width:40%;padding: 5px">{{cr.description}}&nbsp;</div>\n' +
    '          <div class="headers" style="width:15%;padding: 5px;text-align: center">{{cr.desirability}}&nbsp;</div>\n' +
    '          <div class="headers" style="width:15%;text-align: center;padding: 5px">{{cr.score | number : 4}}&nbsp;</div>\n' +
    '          <div class="headers" style="width:15%;text-align: center;padding: 5px">{{cr.wightedScore | number : 4}}&nbsp;</div>\n' +
    '          <div class="headers" style="width:15%;text-align: center;padding: 5px">{{cr.scorePercentage | number : 2}}&nbsp;</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="clearfix"></div>\n' +
    '    </div>\n' +
    '    <div class="col-md-12">\n' +
    '      <div class="add-pattern-wrapper">\n' +
    '        <div class="pattern-div-header row-content">\n' +
    '          <div class="headers" style="width:25%;;padding: 5px">&nbsp;</div>\n' +
    '          <div class="headers" style="width:15%;text-align: center;padding: 5px"><b>Total Desirability</b></div>\n' +
    '          <div class="headers" style="width:15%;text-align: center;padding: 5px"><b>{{scoringPopup.model.totalDesirability | number : 2}}&nbsp;</b></div>\n' +
    '          <div class="headers" style="width:15%;text-align: center;padding: 5px"><b>Total Weighted Score</b></div>\n' +
    '          <div class="headers" style="width:15%;text-align: center;padding: 5px"><b>{{scoringPopup.model.totScore | number : 4}}&nbsp;</b></div>\n' +
    '          <div class="headers" style="width:15%;text-align: center;padding: 5px"><b>{{scoringPopup.model.totalScorePercentage | number : 2}}&nbsp;</b></div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="clearfix"></div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>');
	a.put('reply.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Reply</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="reply.closeMe()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '<form name="reply.searchAny" novalidate="" ng-submit="reply.onSubmit()">\n' +
    '	<div class="modal-body reply row">\n' +
    '		<div class="col-md-12">\n' +
    '			<div class="group">\n' +
    '				<input type="text" ng-model="reply.model.sentBy" ng-disabled="true">\n' +
    '				<span class="bar"></span> <label>To</label>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '		<div class="clearfix"></div>\n' +
    '		<div class="col-md-12">\n' +
    '			<div class="group">\n' +
    '				<input type="text" ng-model="reply.model.request.title" required="">\n' +
    '				<span class="bar"></span> <label>Subject<span class="required-star">*</span></label>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '		<div class="col-md-12 margin-bottom-10">\n' +
    '			<div class="group">\n' +
    '				<div ng-if="reply.searchAny.$submitted && !!!reply.model.request.content" class="validation-error">Content is required.</div>\n' +
    '				<div ng-if="reply.searchAny.$submitted && (reply.model.request.content.length > reply.model.maxCharactersInMSG)" class="validation-error">Message Content Is Too Long.</div>\n' +
    '				<textarea ng-model="reply.model.request.content" required="" style="min-height: 100px !important"></textarea>\n' +
    '				<span class="bar"></span> <label>Message<span class="required-star">*</span></label>\n' +
    '				<!-- <div class="pull-right">\n' +
    '					<small>{{reply.model.request.content.length || 0}} /\n' +
    '						{{::reply.model.maxCharactersInMSG}}</small>\n' +
    '				</div> -->\n' +
    '			</div>\n' +
    '		</div>\n' +
    '		<div class="clearfix"></div>\n' +
    '		<div class="row pull-right">\n' +
    '			<div class="col-md-12">\n' +
    '				<button class="btn btn-grey" type="button" data-ng-click="reply.closeMe()">Discard</button>\n' +
    '				<button class="btn btn-blue" type="button" ng-disabled="true">Save as Draft</button>\n' +
    '				<button class="btn btn-blue" type="submit">Send</button>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '	</div>\n' +
    '</form>');
	a.put('print-journey-log.tpl.html', '<div class="admin_mode">\n' +
    '	<section>\n' +
    '		<header class="header-print">\n' +
    '			<img src="images/client_logo.png" alt="logo" class="pull-left margin-10"> <label class="print-title">JOURNEY\n' +
    '				LOG\n' +
    '				{{PrintJourneyLog.model.journeyData.journeyDetails[0].journyLogId}}</label>\n' +
    '			<span class="print-subtitle">aero<span class="weight-400">LINE</span><strong class="margin-left-5">CREW</strong></span>\n' +
    '\n' +
    '		</header>\n' +
    '		<div class="container-fluid">\n' +
    '			<div class="row">\n' +
    '				<div class="table-section with-borders margin-bottom-0 journey-log-table">\n' +
    '					<section>\n' +
    '						<table class="table table-bordered">\n' +
    '							<thead>\n' +
    '								<tr>\n' +
    '									<th colspan="8">A/c Registration :\n' +
    '										{{PrintJourneyLog.model.journeyData.journeyDetails[0].regNo}}</th>\n' +
    '									<th colspan="11">Nature of Flight :Charter</th>\n' +
    '									<th colspan="7" class="text-right">A/C Type :\n' +
    '										{{PrintJourneyLog.model.journeyData.journeyDetails[0].aircraftModel}}</th>\n' +
    '								</tr>\n' +
    '								<tr class="header-line-two">\n' +
    '									<th rowspan="3" class="v-aligh-middle">Date</th>\n' +
    '									<th colspan="3">Flight</th>\n' +
    '									<th colspan="4">Shedule</th>\n' +
    '									<th colspan="4">Actual</th>\n' +
    '									<th colspan="2">TTL Hours</th>\n' +
    '									<th colspan="3">Pilot\'s Name</th>\n' +
    '									<th colspan="2">Approach</th>\n' +
    '									<th colspan="3">Pax Count</th>\n' +
    '									<th colspan="4" class="text-right">ETS Data(On Dep)</th>\n' +
    '								</tr>\n' +
    '								<tr>\n' +
    '									<th>No</th>\n' +
    '									<th>From</th>\n' +
    '									<th>To</th>\n' +
    '									<th>STD</th>\n' +
    '									<th>STA</th>\n' +
    '									<th>RSTD</th>\n' +
    '									<th>RSTA</th>\n' +
    '\n' +
    '									<th>OFF BLK</th>\n' +
    '									<th>T/OFF</th>\n' +
    '									<th>LNDG</th>\n' +
    '									<th>ON BLKS</th>\n' +
    '\n' +
    '									<th>FLT</th>\n' +
    '									<th>BLCK</th>\n' +
    '\n' +
    '									<th>TOF</th>\n' +
    '									<th>LNDG</th>\n' +
    '									<th>PIC</th>\n' +
    '\n' +
    '									<th>TYPE</th>\n' +
    '									<th>APP CON.</th>\n' +
    '\n' +
    '									<th>PAX</th>\n' +
    '									<th>INF</th>\n' +
    '									<th>TTL</th>\n' +
    '\n' +
    '									<th>PLD</th>\n' +
    '									<th>FOB(KGs)</th>\n' +
    '									<th>FUP(Ltrs)</th>\n' +
    '									<th>SG</th>\n' +
    '								</tr>\n' +
    '							</thead>\n' +
    '							<tbody>\n' +
    '								<tr ng-repeat="journey in PrintJourneyLog.model.journeyData.journeyDetails track by $index">\n' +
    '									<td>{{journey.estDipatureDate}}</td>\n' +
    '									<td>{{journey.flightNO}}</td>\n' +
    '									<td>{{journey.origin}}</td>\n' +
    '									<td>{{journey.destination}}</td>\n' +
    '									<td>{{journey.stdtime}}</td>\n' +
    '									<td>{{journey.statime}}</td>\n' +
    '									<td>{{journey.estDipatureDateTime}}</td>\n' +
    '									<td>{{journey.estArrivalDateTime}}</td>\n' +
    '									<td>{{journey.outtime}}</td>\n' +
    '									<td>{{journey.offtime}}</td>\n' +
    '									<td>{{journey.ontime}}</td>\n' +
    '									<td>{{journey.intime}}</td>\n' +
    '									<td>{{journey.flyDuration}}</td>\n' +
    '									<td>{{journey.actualDuration}}</td>\n' +
    '									<td>{{}}</td>\n' +
    '									<td>{{}}</td>\n' +
    '									<td>{{}}</td>\n' +
    '									<td>{{}}</td>\n' +
    '									<td>{{}}</td>\n' +
    '									<td>{{journey.actNoChildren + journey.actNoAdult}}</td>\n' +
    '									<td>{{journey.actNoInfants}}</td>\n' +
    '									<td>{{journey.actNoChildren +\n' +
    '										journey.actNoAdult+journey.actNoInfants}}</td>\n' +
    '									<td>{{}}</td>\n' +
    '									<td>{{}}</td>\n' +
    '									<td>{{}}</td>\n' +
    '									<td>{{}}</td>\n' +
    '								</tr>\n' +
    '\n' +
    '								<tr>\n' +
    '									<td><strong>Staff No.</strong></td>\n' +
    '									<td><strong>Rank</strong></td>\n' +
    '									<td colspan="8"><strong>Name</strong></td>\n' +
    '									<td><strong>NAT</strong></td>\n' +
    '									<td><strong>Crew Qua</strong></td>\n' +
    '									<td colspan="3"><strong>Duty period</strong></td>\n' +
    '									<td colspan="11" class="text-center"><strong>Commander\'s\n' +
    '											feedback (Aircraft Library)</strong></td>\n' +
    '								</tr>\n' +
    '\n' +
    '								<tr>\n' +
    '									<td class="white-right-borders"></td>\n' +
    '									<td class="white-right-borders"></td>\n' +
    '									<td colspan="8"></td>\n' +
    '									<td class="white-right-borders"></td>\n' +
    '									<td></td>\n' +
    '									<td><strong>ST.</strong></td>\n' +
    '									<td><strong>FIN.</strong></td>\n' +
    '									<td><strong>TOT.</strong></td>\n' +
    '									<td colspan="11"></td>\n' +
    '								</tr>\n' +
    '								<tr ng-repeat="crew in PrintJourneyLog.model.journeyData.joiningCrewCollection track by $index">\n' +
    '									<td>{{crew.staffNo}}</td>\n' +
    '									<td>{{crew.rank}}</td>\n' +
    '									<td colspan="8">{{crew.name}}</td>\n' +
    '									<td>{{crew.nationalityAbb}}</td>\n' +
    '									<td></td>\n' +
    '									<td>{{crew.start}}</td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td colspan="11"></td>\n' +
    '								</tr>\n' +
    '								<tr>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td colspan="8"></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td colspan="9"><strong>Reports</strong></td>\n' +
    '									<td><strong>Yes</strong></td>\n' +
    '									<td><strong>No</strong></td>\n' +
    '								</tr>\n' +
    '								<tr>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td colspan="8"></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td colspan="9">AIR SAFETY REPORT</td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '								</tr>\n' +
    '								<tr>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td colspan="8"></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td colspan="9">VOYAGE REPORT</td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '								</tr>\n' +
    '								<tr>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td colspan="8"></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td colspan="9">COMMANDER\'S DISCRETION REPORT</td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '								</tr>\n' +
    '								<tr>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td colspan="8"></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td colspan="11" class="text-center"><strong>cockpit\n' +
    '											visits & jump seat occupancy</strong></td>\n' +
    '								</tr>\n' +
    '								<tr>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td colspan="13"></td>\n' +
    '									<td colspan="7" class="text-center"><strong>Name</strong></td>\n' +
    '									<td class="text-center"><strong>Staff No.</strong></td>\n' +
    '									<td colspan="2" class="text-center"><strong>Name</strong></td>\n' +
    '									<td class="text-center"><strong>Staff No.</strong></td>\n' +
    '								</tr>\n' +
    '								<tr>\n' +
    '									<td></td>\n' +
    '									<td></td>\n' +
    '									<td colspan="13"></td>\n' +
    '									<td colspan="7" class="text-center"></td>\n' +
    '									<td class="text-center"></td>\n' +
    '									<td colspan="2" class="text-center"></td>\n' +
    '									<td class="text-center"></td>\n' +
    '								</tr>\n' +
    '								<tr>\n' +
    '									<td><strong>Sector</strong></td>\n' +
    '									<td><strong>Time</strong></td>\n' +
    '									<td colspan="13"><strong>delay reasins (To be\n' +
    '											entered in detail in block letters for each section)</strong></td>\n' +
    '									<td colspan="7" class="text-center"></td>\n' +
    '									<td class="text-center"></td>\n' +
    '									<td colspan="2" class="text-center"></td>\n' +
    '									<td class="text-center"></td>\n' +
    '								</tr>\n' +
    '								<tr>\n' +
    '									<td>1</td>\n' +
    '									<td></td>\n' +
    '									<td colspan="13"></td>\n' +
    '									<td colspan="7" class="text-center"><strong>commander\'s\n' +
    '											Signature</strong></td>\n' +
    '									<td colspan="4" class="text-center"><strong>Data\n' +
    '											entered and actioned by</strong></td>\n' +
    '								</tr>\n' +
    '								<tr>\n' +
    '									<td>2</td>\n' +
    '									<td></td>\n' +
    '									<td colspan="13"></td>\n' +
    '									<td colspan="7" class="text-center white-bottom-borders"></td>\n' +
    '									<td class="text-center"><strong>Department</strong></td>\n' +
    '									<td class="text-center"><strong>name & staff No.</strong></td>\n' +
    '									<td class="text-center"><strong>Date</strong></td>\n' +
    '									<td class="text-center"><strong>Initial</strong></td>\n' +
    '								</tr>\n' +
    '								<tr>\n' +
    '									<td>3</td>\n' +
    '									<td></td>\n' +
    '									<td colspan="13"></td>\n' +
    '									<td colspan="7" class="text-center"></td>\n' +
    '									<td class="text-center">COCKPIT CREW</td>\n' +
    '									<td class="text-center"></td>\n' +
    '									<td class="text-center"></td>\n' +
    '									<td class="text-center"></td>\n' +
    '								</tr>\n' +
    '								<tr>\n' +
    '									<td>4</td>\n' +
    '									<td></td>\n' +
    '									<td colspan="13"></td>\n' +
    '									<td colspan="7" class="text-center"></td>\n' +
    '									<td class="text-center">FLT.DISPATCH</td>\n' +
    '									<td class="text-center"></td>\n' +
    '									<td class="text-center"></td>\n' +
    '									<td class="text-center"></td>\n' +
    '								</tr>\n' +
    '							</tbody>\n' +
    '						</table>\n' +
    '					</section>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '	</section>\n' +
    '</div>');
	a.put('print-gd.tpl.html', '<h2>print G9</h2>\n' +
    '<p>{{PrintGD.ctrlName}}</p>');
	a.put('print-duty-sheet.tpl.html', '<div class="admin_mode">\n' +
    '  <div class="table-section with-borders margin-bottom-0 gd-table">\n' +
    '    <section class="print-page-break">\n' +
    '      <table class="table table-bordered" style="width: 100%;font-size: 13px">\n' +
    '        <tbody style="width: 100%">\n' +
    '        <tr style="width: 100%">\n' +
    '          <td colspan="2" class="white-right-borders"><img src="images/client_logo.png" alt="airline logo" class="gd-image"></td>\n' +
    '          <td colspan="16"><span class="title" style="line-height: 2">Duty\n' +
    '								Sheet</span> <span style="line-height: 2">{{PrintDutySheet.model.searchCriteria.fromDate}}</span>\n' +
    '            <span class="pull-right" style="line-height: 3.9">Aeroline\n' +
    '								<span>CREW</span>\n' +
    '						</span></td>\n' +
    '        </tr>\n' +
    '\n' +
    '        <tr class="duty_print">\n' +
    '          <td style="width: 2%"><strong>Seq</strong></td>\n' +
    '          <td style="width: 5%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print">\n' +
    '                      <td style="width: 15%;text-align: center"><strong>A/C Reg</strong></td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '          <td style="width: 5%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print">\n' +
    '                      <td style="width: 20%;text-align: center"><strong>Flight No</strong></td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '          <td style="width: 5%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print">\n' +
    '                      <td style="width: 15%;text-align: center"><strong>From To</strong></td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '          <td style="width: 5%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print">\n' +
    '                      <td style="width: 12%;text-align: center"><strong>ETD</strong></td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width: 5%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print">\n' +
    '                      <td style="width: 12%;text-align: center"><strong>ETA</strong></td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width: 5%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print">\n' +
    '                      <td style="width: 13%;text-align: center"><strong>ETD (loc)</strong></td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                  <!--ng-show="PrintDutySheet.model.dutySheetHidePersonalDetailsEnabled === \'false\'"/table-->\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width: 5%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print">\n' +
    '                      <td style="width: 13%;text-align: center"><strong>ETA (loc)</strong></td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '          <td style="width: 47%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td style="width: 47%;text-align: center"><strong>Crew Members</strong></td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width: 10%; padding: 0px !important" ng-show="PrintDutySheet.model.dutySheetHidePersonalDetailsEnabled === \'false\'">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td style="width: 10%;text-align: center"><strong>Mobile</strong></td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width: 5%; padding: 0px !important" ng-show="PrintDutySheet.model.dutySheetHidePersonalDetailsEnabled === \'false\'">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td class="td-gender" style="width: 5%;text-align: center"><strong>Gen</strong>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width: 7%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td class="td-sign-in" style="width: 7%;text-align: center"><strong>Sign\n' +
    '                  In</strong></td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width: 7%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td class="td-sign-in" style="width: 7%;text-align: center"><strong>Sign\n' +
    '                  Out</strong></td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width: 7%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td style="width: 7%;text-align: center"><strong>Duty</strong></td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width: 7%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print">\n' +
    '                <td style="width: 7%;text-align: center"><strong>FDP</strong></td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '\n' +
    '\n' +
    '        <tr class="duty_print" ng-repeat="duty in PrintDutySheet.model.dutySheetData.duties track by $index">\n' +
    '          <td style="width: 2%">{{$index+1}}</td>\n' +
    '\n' +
    '          <td style="width:5%;padding: 0px !important">\n' +
    '            <table style="width: 100%; padding: 0px !important" class="normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print" ng-repeat="dutyBlockDetail in duty.dutyBlockDetails">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print bottom_border" ng-repeat="dutyFlightDetail in dutyBlockDetail.dutyFlightDetails">\n' +
    '                      <td style="width: 15%;height: 60px;border-bottom: 1px solid #ddd">{{dutyFlightDetail.acRegNo}}</td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width:7%;padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print" ng-repeat="dutyBlockDetail in duty.dutyBlockDetails">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print bottom_border" ng-repeat="dutyFlightDetail in dutyBlockDetail.dutyFlightDetails">\n' +
    '                      <td style="width: 20%;height: 60px;border-bottom: 1px solid #ddd">{{dutyFlightDetail.flightNo}}<br>\n' +
    '                        {{dutyFlightDetail.flightNo!=null? \'(\': \'\'}}\n' +
    '                        {{dutyFlightDetail.acType}}{{dutyFlightDetail.flightNo!=null?\n' +
    '                        \')\': \'\'}}\n' +
    '                      </td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '\n' +
    '          <td style="width:7%;padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print" ng-repeat="dutyBlockDetail in duty.dutyBlockDetails">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print bottom_border" ng-repeat="dutyFlightDetail in dutyBlockDetail.dutyFlightDetails">\n' +
    '                      <td style="width: 15%;height: 60px;border-bottom: 1px solid #ddd">{{dutyFlightDetail.origin}}\n' +
    '                        {{dutyFlightDetail.destination}}</td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '\n' +
    '          <td style="width:4%;padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print" ng-repeat="dutyBlockDetail in duty.dutyBlockDetails">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print bottom_border" ng-repeat="dutyFlightDetail in dutyBlockDetail.dutyFlightDetails">\n' +
    '                      <td style="width: 12%;height: 60px;border-bottom: 1px solid #ddd">{{dutyFlightDetail.departureTimeStr}}</td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width:4%;padding: 0px !important">\n' +
    '            <table style="width: 100%; padding: 0px !important" class="normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print" ng-repeat="dutyBlockDetail in duty.dutyBlockDetails">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print bottom_border" ng-repeat="dutyFlightDetail in dutyBlockDetail.dutyFlightDetails">\n' +
    '                      <td style="width: 12%;height: 60px;border-bottom: 1px solid #ddd">{{dutyFlightDetail.arrivalTimeStr}}</td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '          <td style="width:4%;padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print" ng-repeat="dutyBlockDetail in duty.dutyBlockDetails">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print bottom_border" ng-repeat="dutyFlightDetail in dutyBlockDetail.dutyFlightDetails">\n' +
    '                      <td style="width: 13%;height: 60px;border-bottom: 1px solid #ddd">{{dutyFlightDetail.depTimeLocalStr}}</td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width:4%;padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr class="duty_print" ng-repeat="dutyBlockDetail in duty.dutyBlockDetails">\n' +
    '                <td class="duty_print">\n' +
    '                  <table class="duty_print">\n' +
    '                    <tr class="duty_print bottom_border" ng-repeat="dutyFlightDetail in dutyBlockDetail.dutyFlightDetails">\n' +
    '                      <td style="width: 13%;height: 60px;border-bottom: 1px solid #ddd">{{dutyFlightDetail.arrTimeLocalStr}}</td>\n' +
    '                    </tr>\n' +
    '                  </table>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '          <td style="width: 47%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr style="width: 100%; padding: 0px !important; border-bottom: 1px solid #ddd !important" ng-repeat="dutyCrewDetail in duty.dutyCrewDetails">\n' +
    '                <td style="width: 47%;height: 21px"><span> &nbsp;{{dutyCrewDetail.crewType}} {{dutyCrewDetail.obsFlight}}</span>\n' +
    '                  <span>{{dutyCrewDetail.crewName!=null? \'-\': \'\'}}</span><span>{{dutyCrewDetail.crewName}}</span>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width: 10%; padding: 0px !important" ng-show="PrintDutySheet.model.dutySheetHidePersonalDetailsEnabled === \'false\'">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr style="width: 100%; padding: 0px !important; border-bottom: 1px solid #ddd !important" ng-repeat="dutyCrewDetail in duty.dutyCrewDetails">\n' +
    '                <td style="width: 10%;height: 21px">&nbsp;{{dutyCrewDetail.contactNumber}}</td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width: 5%; padding: 0px !important" ng-show="PrintDutySheet.model.dutySheetHidePersonalDetailsEnabled === \'false\'">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr style="width: 100%; padding: 0px !important; border-bottom: 1px solid #ddd !important" ng-repeat="dutyCrewDetail in duty.dutyCrewDetails">\n' +
    '                <td class="td-gender" style="width: 5%;height: 21px">\n' +
    '                  <div ng-show="(dutyCrewDetail.gender==\'FEMALE\')? true:false" class="gender female">&nbsp;F</div>\n' +
    '                  <div ng-show="(dutyCrewDetail.gender==\'MALE\')? true:false" class="gender male">&nbsp;M</div>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width: 7%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr style="width: 100%; padding: 0px !important; border-bottom: 1px solid #ddd !important" ng-repeat="dutyCrewDetail in duty.dutyCrewDetails">\n' +
    '                <td class="td-sign-in" style="width: 7%;height: 21px;text-align: center"><i ng-show="(dutyCrewDetail.crewName!=null && (dutyCrewDetail.singInTimeStr==null || dutyCrewDetail.singInTimeStr==\'\'))? true :false" class="material-icons text-danger" style="font-size: 12px">not_interested</i>&nbsp;{{dutyCrewDetail.singInTimeStr!=null\n' +
    '                  ? dutyCrewDetail.singInTimeStr : \'\'}}</td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="width: 7%; padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr style="width: 100%; padding: 0px !important; border-bottom: 1px solid #ddd !important" ng-repeat="dutyCrewDetail in duty.dutyCrewDetails">\n' +
    '                <td class="td-sign-in" style="width: 7%;height: 21px;text-align: center"><i ng-show="(dutyCrewDetail.crewName!=null && (dutyCrewDetail.signOutTimeStr==null || dutyCrewDetail.signOutTimeStr==\'\'))? true :false" class="material-icons text-danger" style="font-size: 12px">not_interested</i>&nbsp;{{dutyCrewDetail.signOutTimeStr!=null\n' +
    '                  ? dutyCrewDetail.signOutTimeStr : \'\'}}</td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr style="width: 100%; padding: 0px !important; border-bottom: 1px solid #ddd !important" ng-repeat="dutyCrewDetail in duty.dutyCrewDetails">\n' +
    '                <td style="width: 7%;height: 21px">&nbsp;{{dutyCrewDetail.duration}}</td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '          <td style="padding: 0px !important">\n' +
    '            <table class="duty_print normal table">\n' +
    '              <tbody>\n' +
    '              <tr style="width: 100%; padding: 0px !important; border-bottom: 1px solid #ddd !important" ng-repeat="dutyCrewDetail in duty.dutyCrewDetails">\n' +
    '                <td style="width: 7%;height: 21px">&nbsp;{{dutyCrewDetail.fdp}}</td>\n' +
    '              </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '\n' +
    '        </tr>\n' +
    '        </tbody>\n' +
    '      </table>\n' +
    '      <strong class="pull-right margin-top-10">Page 1</strong>\n' +
    '    </section>\n' +
    '\n' +
    '    <section class="print-page-break">\n' +
    '      <table class="table table-bordered" ng-if="PrintDutySheet.model.dutySheetData.otherDuties.standByDetails.length > 0">\n' +
    '        <tbody>\n' +
    '        <tr>\n' +
    '          <td colspan="11"><span class="title" style="line-height: 2">Standby\n' +
    '								Details</span> <span class="pull-right" style="line-height: 3.9">Aeroline\n' +
    '								<span>CREW</span>\n' +
    '						</span></td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '          <td><strong>Seq</strong></td>\n' +
    '          <td><strong>SBY Name</strong></td>\n' +
    '          <td><strong>From</strong></td>\n' +
    '          <td><strong>To</strong></td>\n' +
    '          <td><strong>From(local)</strong></td>\n' +
    '          <td><strong>T0(local)</strong></td>\n' +
    '          <td><strong>Type</strong></td>\n' +
    '          <td><strong>ID</strong></td>\n' +
    '          <td><strong>Name</strong></td>\n' +
    '          <td><strong>Phone</strong></td>\n' +
    '          <td><strong>Fly Hrs</strong></td>\n' +
    '        </tr>\n' +
    '        <tr ng-repeat="standByDetail in PrintDutySheet.model.dutySheetData.otherDuties.standByDetails track by $index">\n' +
    '          <td>{{$index+1}}</td>\n' +
    '          <td>{{standByDetail.patternName}}</td>\n' +
    '          <td>{{standByDetail.startTime}}</td>\n' +
    '          <td>{{standByDetail.endTime}}</td>\n' +
    '          <td>{{standByDetail.localStartTime}}</td>\n' +
    '          <td>{{standByDetail.localEndTime}}</td>\n' +
    '          <td>{{standByDetail.crewTypeCode}}</td>\n' +
    '          <td>{{standByDetail.crewId}}</td>\n' +
    '          <td>{{standByDetail.crewName}}</td>\n' +
    '          <td>{{standByDetail.mobileNo}}</td>\n' +
    '          <td>0.00</td>\n' +
    '        </tr>\n' +
    '\n' +
    '        </tbody>\n' +
    '      </table>\n' +
    '\n' +
    '      <table class="table table-bordered" ng-if="PrintDutySheet.model.dutySheetData.otherDuties.deadHeadingDetails.length > 0 ">\n' +
    '        <tbody>\n' +
    '        <tr>\n' +
    '          <td colspan="11"><span class="title" style="line-height: 2">DHD/DHT\n' +
    '								Details</span> <span class="pull-right" style="line-height: 3.9">Aeroline\n' +
    '								<span>CREW</span>\n' +
    '						</span></td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '          <td><strong>Seq</strong></td>\n' +
    '          <td><strong>From</strong></td>\n' +
    '          <td><strong>To</strong></td>\n' +
    '          <td><strong>From Location</strong></td>\n' +
    '          <td><strong>To Location</strong></td>\n' +
    '          <td><strong>ETD</strong></td>\n' +
    '          <td><strong>ETA</strong></td>\n' +
    '          <td><strong>ETD(local)</strong></td>\n' +
    '          <td><strong>ETA(local)</strong></td>\n' +
    '          <td><strong>Crew Name</strong></td>\n' +
    '        </tr>\n' +
    '        <tr ng-repeat="deadHeadingDetail in PrintDutySheet.model.dutySheetData.otherDuties.deadHeadingDetails track by $index">\n' +
    '          <td>{{$index+1}}</td>\n' +
    '          <td>{{deadHeadingDetail.startDate}}</td>\n' +
    '          <td>{{deadHeadingDetail.endDate}}</td>\n' +
    '          <td>{{deadHeadingDetail.startLocation}}</td>\n' +
    '          <td>{{deadHeadingDetail.endLocation}}</td>\n' +
    '          <td>{{deadHeadingDetail.startTime}}</td>\n' +
    '          <td>{{deadHeadingDetail.endTime}}</td>\n' +
    '          <td>{{deadHeadingDetail.startTimeLocal}}</td>\n' +
    '          <td>{{deadHeadingDetail.endTimeLocal}}</td>\n' +
    '          <td>{{deadHeadingDetail.joiningCrew}}</td>\n' +
    '        </tr>\n' +
    '        </tbody>\n' +
    '      </table>\n' +
    '\n' +
    '\n' +
    '      <table class="table table-bordered" ng-if="PrintDutySheet.model.dutySheetData.otherDuties.otherDutyTypeDetails.length > 0 ">\n' +
    '        <tbody>\n' +
    '        <tr>\n' +
    '          <td colspan="11"><span class="title" style="line-height: 2">Other\n' +
    '								Duty Details</span> <span class="pull-right" style="line-height: 3.9">Aeroline\n' +
    '								<span>CREW</span>\n' +
    '						</span></td>\n' +
    '        </tr>\n' +
    '        <tr>\n' +
    '          <td><strong>Seq</strong></td>\n' +
    '          <td><strong>Event Code</strong></td>\n' +
    '          <td><strong>From</strong></td>\n' +
    '          <td><strong>To</strong></td>\n' +
    '          <td><strong>ETD</strong></td>\n' +
    '          <td><strong>ETA</strong></td>\n' +
    '          <td><strong>ETD(local)</strong></td>\n' +
    '          <td><strong>ETA(local)</strong></td>\n' +
    '          <td><strong>Crew Name</strong></td>\n' +
    '        </tr>\n' +
    '        <tr ng-repeat="otherDuty in PrintDutySheet.model.dutySheetData.otherDuties.otherDutyTypeDetails track by $index">\n' +
    '\n' +
    '          <td>{{$index+1}}</td>\n' +
    '          <td>{{otherDuty.eventCode}}</td>\n' +
    '          <td>{{otherDuty.startDate}}</td>\n' +
    '          <td>{{otherDuty.endDate}}</td>\n' +
    '          <td>{{otherDuty.startTime}}</td>\n' +
    '          <td>{{otherDuty.endTime}}</td>\n' +
    '          <td>{{otherDuty.startTimeLocal}}</td>\n' +
    '          <td>{{otherDuty.endTimeLocal}}</td>\n' +
    '          <td>{{otherDuty.joiningCrew}}</td>\n' +
    '        </tr>\n' +
    '        </tbody>\n' +
    '      </table>\n' +
    '\n' +
    '      <strong class="pull-right margin-top-10">Page 2</strong>\n' +
    '    </section>\n' +
    '  </div>\n' +
    '</div>');
	a.put('pairing-rest-tooltip.tpl.html', '<div class="tool-tip-bottom" style="padding:10px">\n' +
    '    <div>Start Time: {{blockDetailTO.startDateStr}} {{blockDetailTO.startTimeStr}}</div>\n' +
    '    <div>End Time: {{blockDetailTO.endDateStr}} {{blockDetailTO.endTimeStr}}</div>\n' +
    '    <div>Duration: {{createPairing.setDurationForRest(blockDetailTO.startDateStr, blockDetailTO.startTimeStr, blockDetailTO.endDateStr, blockDetailTO.endTimeStr)}}</div>\n' +
    '</div>');
	a.put('pairing-flight-tooltip.tpl.html', '<div class="tool-tip-header">\n' +
    '    <i class="material-icons">flight</i>{{$ctrl.toolTipModel.flightNumber}}\n' +
    '    <span>{{$ctrl.toolTipModel.modelNo}}</span>\n' +
    '    <div class="clearfix"></div>\n' +
    '\n' +
    '</div>\n' +
    '<div class="tool-tip-bottom">\n' +
    '    <div class="loc-time">{{$ctrl.toolTipModel.origin}}<span>{{$ctrl.toolTipModel.departureTime}}</span></div>\n' +
    '    <i class="material-icons">trending_flat</i>\n' +
    '    <div class="loc-time">{{$ctrl.toolTipModel.destination}}<span>{{$ctrl.toolTipModel.arrivalTime}}</span></div>\n' +
    '  <div>\n' +
    '    <span ng-if="$ctrl.toolTipModel.filteredCrewTypes.cp">CP - {{$ctrl.toolTipModel.avaliableCaptian}}/{{$ctrl.toolTipModel.requiredCaptain}},</span>\n' +
    '    <span ng-if="$ctrl.toolTipModel.filteredCrewTypes.fo">FO - {{$ctrl.toolTipModel.avaliableFirstOfficer}}/{{$ctrl.toolTipModel.requiredFirstOfficer}},</span>\n' +
    '    <span ng-if="$ctrl.toolTipModel.filteredCrewTypes.so">SO - {{$ctrl.toolTipModel.availableSecondOfficer}}/{{$ctrl.toolTipModel.requiredSecondOfficer}},</span>\n' +
    '    <span ng-if="$ctrl.toolTipModel.filteredCrewTypes.cs">CS - {{$ctrl.toolTipModel.avaliableCabinSupervisor}}/{{$ctrl.toolTipModel.requiredCabinSupervisor}},</span>\n' +
    '    <span ng-if="$ctrl.toolTipModel.filteredCrewTypes.cc">CC - {{$ctrl.toolTipModel.avaliableCabinCrew}}/{{$ctrl.toolTipModel.requiredCabinCrew}}</span>\n' +
    '  </div>\n' +
    '<!--  <div>CP - {{$ctrl.toolTipModel.avaliableCaptian}}/1, FO - {{$ctrl.toolTipModel.avaliableFirstOfficer}}/1, CS - {{$ctrl.toolTipModel.avaliableCabinSupervisor}}/1, CC - {{$ctrl.toolTipModel.avaliableCabinCrew}}/3</div>-->\n' +
    '</div>');
	a.put('override_confirm.tpl.html', '<div class="modal-header">\n' +
    '  <h4 class="modal-title">{{confirmCtrl.model.title}}</h4>\n' +
    '  <button type="button" data-ng-click="confirmCtrl.onCloseClick()" class="close" data-dismiss="modal" aria-hidden="true"><i class="material-icons">clear</i></button>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '\n' +
    '  <p class="bold font-16" data-ng-repeat="msg in confirmCtrl.model.msgCol">{{msg}}</p>\n' +
    '\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '  <button class="btn btn-blue" type="button" ng-click="confirmCtrl.onYesClick()">Override</button>\n' +
    '  <button class="btn btn-grey" type="button" ng-click="confirmCtrl.onNoClick()">No</button>\n' +
    '</div>');
	a.put('missing_items_popup.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Missing Flight / Trainings </h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="missingItems.closeMe()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '<div class="modal-body add-pattern">\n' +
    '\n' +
    '    <div class="row margin-bottom-10" ng-if="missingItems.model.flightList.length!==0">\n' +
    '       <div class="col-md-12">\n' +
    '            <p class="bold font-16">Missing Flights</p>\n' +
    '            <div class="table-section margin-bottom-0">\n' +
    '                <table class="header">\n' +
    '                    <thead>\n' +
    '                    <tr>\n' +
    '                        <th>Pairing Start Date</th>\n' +
    '                        <th>Flight Number</th>\n' +
    '                        <th>Origin</th>\n' +
    '                        <th>Destination</th>\n' +
    '                        <th>Departure Date/Time</th>\n' +
    '                        <th>Arrival Date/Time</th>\n' +
    '                    </tr>\n' +
    '                    </thead>\n' +
    '                </table>\n' +
    '                <div class="content-table">\n' +
    '                    <table class="table content">\n' +
    '                        <tbody>\n' +
    '                        <tr ng-repeat="flight in missingItems.model.flightList track by $index">\n' +
    '                            <td>{{flight.patternStartDate}}</td>\n' +
    '                            <td>{{flight.flightNo}}</td>\n' +
    '                            <td>{{flight.origin}}</td>\n' +
    '                            <td>{{flight.destination}}</td>\n' +
    '                            <td>{{flight.departureDate}} {{flight.departureTime}}</td>\n' +
    '                            <td>{{flight.arrivalDate}} {{flight.arrivalTime}}</td>\n' +
    '                        </tr>\n' +
    '\n' +
    '                        </tbody>\n' +
    '                    </table>\n' +
    '                </div>\n' +
    '             </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row margin-bottom-20" ng-if="missingItems.model.trainingList.length!==0">\n' +
    '\n' +
    '            <div class="col-md-12">\n' +
    '                <p class="bold font-16">Missing Trainings</p>\n' +
    '\n' +
    '                <div class="table-section margin-bottom-0 missing-trainings">\n' +
    '                    <table class="header">\n' +
    '                        <thead>\n' +
    '                        <tr>\n' +
    '                            <th>Pairing Start Date</th>\n' +
    '                            <th>Training Category</th>\n' +
    '                            <th>Training Program</th>\n' +
    '                            <th>Program Details</th>\n' +
    '                            <th>Start Date/Time</th>\n' +
    '                            <th>End Date/Time</th>\n' +
    '                        </tr>\n' +
    '                        </thead>\n' +
    '                    </table>\n' +
    '                    <div class="content-table">\n' +
    '                        <table class="table content">\n' +
    '                            <tbody>\n' +
    '                            <tr ng-repeat="flight in missingItems.model.trainingList track by $index">\n' +
    '                                <td style="width: 15%">{{flight.patternStartDate}}</td>\n' +
    '                                <td style="width: 8%">{{flight.trainingCategoryCode}}</td>\n' +
    '                                <td style="width: 7%">{{flight.trainingProgCode}}</td>\n' +
    '                                <td style="width: 17%">{{flight.trainingProgDetCode}}</td>\n' +
    '                                <td>{{flight.startDate}} {{flight.startTime}}</td>\n' +
    '                                <td>{{flight.endDate}} {{flight.endTime}}</td>\n' +
    '                            </tr>\n' +
    '\n' +
    '                            </tbody>\n' +
    '                        </table>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '    </div>\n' +
    '\n' +
    '</div>');
	a.put('message-manager.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Message Manager</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="messageManager.closeMe()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '	<div class="row">\n' +
    '		<div class="col-md-12">\n' +
    '			<form name="messageManager.searchAny" novalidate="" ng-submit="messageManager.searchSMSList()">\n' +
    '			<uib-tabset> \n' +
    '				<uib-tab index="0" heading="SMS List">\n' +
    '					<div>\n' +
    '						<div class="clearfix margin-top-20"></div>\n' +
    '						<div class="col-md-12" ng-if="$ctrl.fromDateAfterToDate">\n' +
    '							<div class="group">\n' +
    '								<div class="validation-error">Invalid date range.(From Date is\n' +
    '									After To Date)</div>\n' +
    '							</div>\n' +
    '						</div>\n' +
    '						<div class="col-md-2">\n' +
    '							<div class="group">\n' +
    '								<input type="text" class="calID" set-auto-date="" jq-date-picker-options="" ng-change="messageManager.changeSearchField(\'fromDate\')" ng-model="messageManager.model.request.fromDate" name="fromDate" required=""> <span class="bar"></span> <label>From Date</label>\n' +
    '									<div ng-messages="messageManager.searchAny.$submitted && messageManager.searchAny.fromDate.$error" role="alert">\n' +
    '										<div ng-message="required" class="validation-error">From\n' +
    '											Date is required.</div>\n' +
    '										<div ng-if="messageManager.fromDateFormatInvalid" class="validation-error">From Date is Invalid.</div>\n' +
    '									</div>\n' +
    '							</div>\n' +
    '						</div>\n' +
    '						\n' +
    '						<div class="col-md-2">\n' +
    '							<div class="group">\n' +
    '								<input type="text" class="calID" set-auto-date="" jq-date-picker-options="" ng-change="messageManager.changeSearchField(\'toDate\')" ng-model="messageManager.model.request.toDate" name="toDate" required=""> <span class="bar"></span> <label>To Date</label>\n' +
    '									<div ng-messages="messageManager.searchAny.$submitted && messageManager.searchAny.toDate.$error" role="alert">\n' +
    '										<div ng-message="required" class="validation-error">To\n' +
    '											Date is required.</div>\n' +
    '										<div ng-if="messageManager.toDateFormatInvalid" class="validation-error">To Date is Invalid.</div>\n' +
    '									</div>\n' +
    '							</div>\n' +
    '						</div>\n' +
    '		\n' +
    '						<div class="col-md-2">\n' +
    '							<div class="group">\n' +
    '								<select-component component-name="Crew Base" label-field-name="airPortCode" value-field-name="airPortCode" menu-data-source="messageManager.model.SMSListSearch.crewBase" selected-value="messageManager.model.request.crewBase"></select-component>\n' +
    '							</div>\n' +
    '						</div>\n' +
    '		\n' +
    '						<div class="col-md-2">\n' +
    '							<div class="group">\n' +
    '								<select-component component-name="Status" label-field-name="status" value-field-name="statusValue" menu-data-source="messageManager.model.SMSListSearch.status" selected-value="messageManager.model.request.status"></select-component>\n' +
    '							</div>\n' +
    '						</div>\n' +
    '		\n' +
    '						<div class="col-md-2 padding-top-10">\n' +
    '							<div class="group">\n' +
    '								<input type="checkbox" id="status" data-ng-model="messageManager.model.request.refreshStatus"> <label for="status">Ref Status</label>\n' +
    '							</div>\n' +
    '						</div>\n' +
    '		\n' +
    '						<div class="col-md-2">\n' +
    '							<button class="btn save-btn margin-top-5 ripple" data-ng-click="messageManager.searchSMSList()">Search</button>\n' +
    '						</div>\n' +
    '		\n' +
    '		\n' +
    '						<div class="clearfix"></div>\n' +
    '		\n' +
    '						<div class="margin-top-20">\n' +
    '\n' +
    '							<table class="table table-striped tableBodyScroll">\n' +
    '								<thead style="background-color: #718b98">\n' +
    '									<tr class="header">\n' +
    '										<th style="width: 5%">#</th>\n' +
    '										<th>Created Date</th>\n' +
    '										<th>User</th>\n' +
    '										<th>Crew Name</th>\n' +
    '										<th style="width: 20%">Message</th>\n' +
    '										<th>Status</th>\n' +
    '										<th>Conf. ID</th>\n' +
    '										<th>Date Confirmed</th>\n' +
    '										<th>Message Type</th>\n' +
    '									</tr>\n' +
    '								</thead>\n' +
    '								<tbody elastic-search="300">\n' +
    '									<tr ng-if="messageManager.model.SMSList.dtoList.length == 0">\n' +
    '										<td colspan="9" align="center"> No Records Found </td>\n' +
    '									</tr>\n' +
    '									<tr data-ng-repeat="SMS in messageManager.model.SMSList.dtoList">\n' +
    '										<td align="center" style="width: 5%">{{$index+1}}</td>\n' +
    '										<td align="center">{{SMS.createdDate}}</td>\n' +
    '										<td align="center">{{SMS.userNa}}</td>\n' +
    '										<td align="center">{{SMS.crewName}}</td>\n' +
    '										<td align="center" style="width: 20%">{{SMS.mesage}}</td>\n' +
    '										<td align="center">{{SMS.status}}</td>\n' +
    '										<td align="center">{{SMS.confirmationID}}</td>\n' +
    '										<td align="center">{{SMS.confirmedDate}}</td>\n' +
    '										<td align="center">{{SMS.mesageType}}</td>\n' +
    '									</tr>\n' +
    '								</tbody>\n' +
    '							</table>\n' +
    '\n' +
    '						</div>\n' +
    '\n' +
    '					</div>\n' +
    '		\n' +
    '					<div class="clearfix"></div>\n' +
    '				</uib-tab> \n' +
    '				<uib-tab index="1" heading="Email List" style="pointer-events: none" disabled="disabled"> \n' +
    '				</uib-tab> \n' +
    '			</uib-tabset></form>\n' +
    '		</div>	\n' +
    '	</div>\n' +
    '\n' +
    '</div>');
	a.put('loading-panel-directive.tpl.html', '<div class="loading-panel" ng-show="loadingPanel.isLoadingVisible">\n' +
    '\n' +
    '     <div class="sk-cube-grid" ng-show="loadingPanel.animationName ==\'cube\' ">\n' +
    '          <div class="sk-cube sk-cube1"></div>\n' +
    '          <div class="sk-cube sk-cube2"></div>\n' +
    '          <div class="sk-cube sk-cube3"></div>\n' +
    '          <div class="sk-cube sk-cube4"></div>\n' +
    '          <div class="sk-cube sk-cube5"></div>\n' +
    '          <div class="sk-cube sk-cube6"></div>\n' +
    '          <div class="sk-cube sk-cube7"></div>\n' +
    '          <div class="sk-cube sk-cube8"></div>\n' +
    '          <div class="sk-cube sk-cube9"></div>\n' +
    '     </div>\n' +
    '\n' +
    '    <div class="spinner" ng-show="loadingPanel.animationName==\'spinner\' "></div>\n' +
    '\n' +
    '    <div class="sk-circle" ng-show="loadingPanel.animationName==\'circle\' ">\n' +
    '        <div class="sk-circle1 sk-child"></div>\n' +
    '        <div class="sk-circle2 sk-child"></div>\n' +
    '        <div class="sk-circle3 sk-child"></div>\n' +
    '        <div class="sk-circle4 sk-child"></div>\n' +
    '        <div class="sk-circle5 sk-child"></div>\n' +
    '        <div class="sk-circle6 sk-child"></div>\n' +
    '        <div class="sk-circle7 sk-child"></div>\n' +
    '        <div class="sk-circle8 sk-child"></div>\n' +
    '        <div class="sk-circle9 sk-child"></div>\n' +
    '        <div class="sk-circle10 sk-child"></div>\n' +
    '        <div class="sk-circle11 sk-child"></div>\n' +
    '        <div class="sk-circle12 sk-child"></div>\n' +
    '\n' +
    '        <span class="loading-txt">Loading...</span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="sk-circle" ng-show="loadingPanel.animationName==\'circle-no-text\' ">\n' +
    '        <div class="sk-circle1 sk-child"></div>\n' +
    '        <div class="sk-circle2 sk-child"></div>\n' +
    '        <div class="sk-circle3 sk-child"></div>\n' +
    '        <div class="sk-circle4 sk-child"></div>\n' +
    '        <div class="sk-circle5 sk-child"></div>\n' +
    '        <div class="sk-circle6 sk-child"></div>\n' +
    '        <div class="sk-circle7 sk-child"></div>\n' +
    '        <div class="sk-circle8 sk-child"></div>\n' +
    '        <div class="sk-circle9 sk-child"></div>\n' +
    '        <div class="sk-circle10 sk-child"></div>\n' +
    '        <div class="sk-circle11 sk-child"></div>\n' +
    '        <div class="sk-circle12 sk-child"></div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div class="spinner" ng-show="loadingPanel.animationName==\'crewing-loader\' ">\n' +
    '      <span>Loading</span>\n' +
    '      <div class="bounce1"></div>\n' +
    '      <div class="bounce2"></div>\n' +
    '      <div class="bounce3"></div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '</div>');
	a.put('info_dialog.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">{{infodialogctrl.model.title}}</h4>\n' +
    '    <!--<button type="button" data-ng-click="infodialogctrl.onCloseClick()" class="close" data-dismiss="modal"\n' +
    '            aria-hidden="true"><i class="material-icons">clear</i></button>-->\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '\n' +
    '    <pre class="bold font-16" data-ng-repeat="msg in infodialogctrl.model.msgCol">{{msg}}</pre>\n' +
    '\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '  <button class="btn btn-blue" type="button" ng-click="infodialogctrl.onYesClick()">Yes</button>\n' +
    '  <!--<button class="btn btn-grey" type="button" ng-click="infodialogctrl.onNoClick()">No</button>-->\n' +
    '</div>');
	a.put('illegalCrewMap.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Illegal Crew Assigned</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="illegalCrewMap.closeMe()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '<div class="modal-body add-pattern">\n' +
    '    <div class="row margin-bottom-10">\n' +
    '        <div class="col-md-12">\n' +
    '            <div class="table-section margin-bottom-0">\n' +
    '                <table class="header">\n' +
    '                    <thead>\n' +
    '                    <tr>\n' +
    '                        <th>Crew Name</th>\n' +
    '                        <th>Block Name</th>\n' +
    '                    </tr>\n' +
    '                    </thead>\n' +
    '                </table>\n' +
    '                <div class="content-table">\n' +
    '                    <table class="table content">\n' +
    '                        <tbody>\n' +
    '                            <tr ng-repeat="crew in illegalCrewMap.model.illegalCrewMap track by $index">\n' +
    '                                <td>{{crew.crewName}}</td>\n' +
    '                                <td>{{crew.blockName}}</td>\n' +
    '                            </tr>\n' +
    '                        </tbody>\n' +
    '                    </table>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="content-table">\n' +
    '                    <table class="table content">\n' +
    '                        <tbody>\n' +
    '                        <tr>\n' +
    '                            <td>Confirm illegal block?\n' +
    '                                <button class="btn btn-continue" data-ng-click="illegalCrewMap.clickYes()">Yes</button>&nbsp;\n' +
    '                                <button class="btn btn-continue" data-ng-click="illegalCrewMap.closeMe()">No</button></td>\n' +
    '                        </tr>\n' +
    '                        </tbody>\n' +
    '                    </table>\n' +
    '\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
	a.put('generate_pairing.tpl.html', '<div class="modal-header blue">\n' +
    '    <h4 class="modal-title">Generate Pattern</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="generatePairing.closeMe()"><i class="material-icons">clear</i></button>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '    <form name="generatePairing.frmGeneratePairing" novalidate="">\n' +
    '        <div class="row">\n' +
    '        <div class="col-md-12 margin-bottom-20">\n' +
    '            <label class="bold label-top-0">Apply For Period</label>\n' +
    '        </div>\n' +
    '        <div class="clearfix"></div>\n' +
    '        <div class="col-md-4">\n' +
    '            <div class="group">\n' +
    '                <div>\n' +
    '                    <input type="text" class="calID" set-auto-date="" jq-date-picker-options="" ng-model="generatePairing.model.fromDate" name="fromDate" ng-change="generatePairing.changeDateTime(\'fromDate\')" required="">\n' +
    '                    <span class="bar"></span>\n' +
    '                    <label>FROM<span class="required-star">*</span></label>\n' +
    '                    <div ng-messages="generatePairing.frmGeneratePairing.$submitted && generatePairing.frmGeneratePairing.fromDate.$error" role="alert">\n' +
    '                        <div ng-message="required" class="validation-error">From Date is required.</div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="clearfix"></div>\n' +
    '            <div class="group">\n' +
    '                <div>\n' +
    '                    <input type="text" class="calID" set-auto-date="" jq-date-picker-options="" ng-model="generatePairing.model.toDate" name="toDate" required="" ng-change="generatePairing.changeDateTime(\'toDate\')">\n' +
    '                    <span class="bar"></span>\n' +
    '                    <label>To<span class="required-star">*</span></label>\n' +
    '                    <div ng-messages="generatePairing.frmGeneratePairing.$submitted && generatePairing.frmGeneratePairing.toDate.$error" role="alert">\n' +
    '                        <div ng-message="required" class="validation-error">From Date is required.</div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-md-4">\n' +
    '            <div class="group">\n' +
    '                <ul class="date-list">\n' +
    '                    <li ng-repeat="day in generatePairing.model.displayWeekdays track by $index">\n' +
    '                        <input type="checkbox" name="day" ng-value="day.shortName" id="{{day.shortName}}" ng-model="day.selected" required="" ng-click="generatePairing.setSingleDay(day)" ng-disabled="!day.editable">\n' +
    '                        <label for="{{day.shortName}}">{{day.shortName}}</label>\n' +
    '                    </li>\n' +
    '                </ul>\n' +
    '                <div class="clearfix"></div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-4">\n' +
    '            <div class="group">\n' +
    '                <label class="showlabel">Minimum Connection Time<span class="required-star">*</span></label>\n' +
    '                <input type="text" required="" ng-model="generatePairing.model.minConnTime">\n' +
    '                <div ng-messages="generatePairing.frmGeneratePairing.$submitted && generatePairing.frmGeneratePairing.minConnTime.$error" role="alert">\n' +
    '                    <div ng-message="required" class="validation-error">Min connection time is required.</div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="pull-right margin-top-10">\n' +
    '                <button class="btn btn-continue" ng-click="generatePairing.sendGeneratePairing()">Save</button>\n' +
    '                <div class="clearfix"></div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    </form>\n' +
    '</div>');
	a.put('flight-watch-send-notification-popup.tpl.html', '<div class="modal-header">\n' +
    '  <h4 class="modal-title">\n' +
    '    Send Notifications\n' +
    '  </h4>\n' +
    '  <button type="button" data-ng-click="FlightWatchSendNotificationCtrl.closeSendNotificationPopUp()" class="close" data-dismiss="modal" aria-hidden="true">\n' +
    '    <i class="material-icons">clear</i>\n' +
    '  </button>\n' +
    '</div>\n' +
    '<form name="FlightWatchSendNotificationCtrl.frmEditor" novalidate="" data-ng-submit=" FlightWatchSendNotificationCtrl.frmEditor.$valid && FlightWatchSendNotificationCtrl.validateAndSendNotification()">\n' +
    '  <div class="modal-body">\n' +
    '    <div ng-repeat="notificationItem in FlightWatchSendNotificationCtrl.flightLegDetails">\n' +
    '      <div class="col-md-12 padding-0 margin-top-20">\n' +
    '        <div class="col-md-4 padding-0">\n' +
    '          <div class="col-md-12 padding-0">\n' +
    '            <input type="checkbox" id="checkbox{{$index}}" class="no-border" ng-model="notificationItem.isChecked">\n' +
    '            <label for="checkbox{{$index}}" style="font-weight: bold;color: #0c0c0c">\n' +
    '              Message for {{notificationItem.originApt}} - {{notificationItem.destinationApt}}\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-8 padding-0" ng-init="FlightWatchSendNotificationCtrl.notificationTypeChange(notificationItem)">\n' +
    '          <div class="col-md-3 padding-0">\n' +
    '            <input type="radio" class="css-checkbox" ng-click="FlightWatchSendNotificationCtrl.notificationTypeChange(notificationItem)" name="reportType_{{$index}}" id="delay{{$index}}" ng-model="notificationItem.notificationType" value="FLT_DELAY_SMS" ng-required="notificationItem.isChecked">\n' +
    '            <label class="css-label radGroup2" for="delay{{$index}}">Flight Delay</label>\n' +
    '\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col-md-3 padding-0">\n' +
    '            <input type="radio" class="css-checkbox" ng-click="FlightWatchSendNotificationCtrl.notificationTypeChange(notificationItem)" name="reportType_{{$index}}" id="change{{$index}}" ng-model="notificationItem.notificationType" value="FLT_CHANGE_SMS" ng-required="notificationItem.isChecked">\n' +
    '            <label class="css-label radGroup2" for="change{{$index}}">Flight Change</label>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col-md-4 padding-0">\n' +
    '            <input type="radio" class="css-checkbox" ng-click="FlightWatchSendNotificationCtrl.notificationTypeChange(notificationItem)" name="reportType_{{$index}}" id="cancel{{$index}}" ng-model="notificationItem.notificationType" value="FLT_CANCEL_SMS" ng-required="notificationItem.isChecked">\n' +
    '            <label class="css-label radGroup2" for="cancel{{$index}}">Flight Cancellation</label>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="col-md-2 padding-0">\n' +
    '            <input type="radio" class="css-checkbox" ng-click="FlightWatchSendNotificationCtrl.notificationTypeChange(notificationItem)" name="reportType_{{$index}}" id="other{{$index}}" ng-model="notificationItem.notificationType" value="FLT_OTHER_SMS" ng-required="notificationItem.isChecked">\n' +
    '            <label class="css-label radGroup2" for="other{{$index}}">Other</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '     <div class="" ng-messages="FlightWatchSendNotificationCtrl.frmEditor.$submitted && FlightWatchSendNotificationCtrl.frmEditor[\'reportType_\'+$index].$error" role="alert">\n' +
    '      <div style="text-align: right" ng-message="required" class="validation-error">Notification type is required.</div>\n' +
    '     </div>\n' +
    '      <div class="col-md-12 padding-0 margin-top-10">\n' +
    '        <textarea class="padding-10" name="textArea_{{$index}}" ng-required="notificationItem.isChecked" id="textArea_{{$index}}" ng-model="notificationItem.message" rows="2" cols="30" maxlength="270" style="border:solid 1px grey">\n' +
    '        </textarea>\n' +
    '        </div>\n' +
    '      <div class="col-md-12" ng-messages="FlightWatchSendNotificationCtrl.frmEditor.$submitted && FlightWatchSendNotificationCtrl.frmEditor[\'textArea_\'+$index].$error" role="alert">\n' +
    '        <div style="text-align: right" ng-message="required" class="validation-error">Message is required.</div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="modal-footer">\n' +
    '    <div class="col-md-12 margin-top-15">\n' +
    '      <div class="col-md-8 padding-0">\n' +
    '        <input type="button" class="btn btn-grey" ng-click="FlightWatchSendNotificationCtrl.closeSendNotificationPopUp()" value="Cancel">\n' +
    '      </div>\n' +
    '      <div class="col-md-4 padding-0">\n' +
    '        <input type="submit" class="btn btn-login pull-right" value="Send Notifications">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>');
	a.put('filter_aircraft.tpl.html', '<div>\n' +
    '    <div class="popover-title margin-bottom-10">Filter Aircraft by\n' +
    '        <button type="button" class="close"><i class="material-icons">clear</i></button>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="clearfix"></div>\n' +
    '\n' +
    '    <div class="group">\n' +
    '\n' +
    '        <div class="btn-group select-dropdown" uib-dropdown="">\n' +
    '\n' +
    '            <button type="button" class="btn select-dropdown-label" uib-dropdown-toggle="" ng-click="submit()">Hull Type</button>\n' +
    '\n' +
    '            <ul class="dropdown-menu" role="menu" uib-dropdown-menu="">\n' +
    '                <li ng-repeat="action in actions">\n' +
    '                    <a href="#" ng-click="setAction(action)">{{action.name}}</a>\n' +
    '                </li>\n' +
    '            </ul>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div class="group">\n' +
    '\n' +
    '        <div class="btn-group select-dropdown" uib-dropdown="">\n' +
    '\n' +
    '            <button type="button" class="btn select-dropdown-label" uib-dropdown-toggle="" ng-click="submit()">Modal</button>\n' +
    '\n' +
    '            <ul class="dropdown-menu" role="menu" uib-dropdown-menu="">\n' +
    '                <li ng-repeat="action in actions">\n' +
    '                    <a href="#" ng-click="setAction(action)">{{action.name}}</a>\n' +
    '                </li>\n' +
    '            </ul>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="group">\n' +
    '\n' +
    '        <div class="btn-group select-dropdown" uib-dropdown="">\n' +
    '\n' +
    '            <button type="button" class="btn select-dropdown-label" uib-dropdown-toggle="" ng-click="submit()">Tail Number</button>\n' +
    '\n' +
    '            <ul class="dropdown-menu" role="menu" uib-dropdown-menu="">\n' +
    '                <li ng-repeat="action in actions">\n' +
    '                    <a href="#" ng-click="setAction(action)">{{action.name}}</a>\n' +
    '                </li>\n' +
    '            </ul>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-md-12 padding-0 margin-bottom-10">\n' +
    '        <button class="btn-panel" type="button">Filter and Sort</button>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '</div>');
	a.put('fdp-details-popover.tpl.html', '<div class="fdp-info-popover">\n' +
    '        <div class="popover-title fdp-popover-title margin-bottom-10">\n' +
    '            {{createPairing.pairingPopOver.content.blockName}}\n' +
    '            <button type="button" ng-click="createPairing.closePopover()" class="close"><i class="material-icons">clear</i></button>\n' +
    '        </div>\n' +
    '        <div class="clearfix"></div>\n' +
    '        <div class="fdp-popover-content">\n' +
    '            <div class="col-md-8 margin-bottom-10">Starting Time</div>\n' +
    '            <div class="col-md-4 margin-bottom-10 text-right">{{createPairing.pairingPopOver.content.startTime}}</div>\n' +
    '\n' +
    '            <div class="clearfix"></div>\n' +
    '\n' +
    '            <div class="col-md-8 margin-bottom-10">No. of Legs</div>\n' +
    '            <div class="col-md-4 margin-bottom-10 text-right">{{createPairing.pairingPopOver.content.noOfLegs}}</div>\n' +
    '\n' +
    '            <div class="clearfix"></div>\n' +
    '\n' +
    '            <div class="col-md-8 margin-bottom-10">Current Duty Period</div>\n' +
    '            <div class="col-md-4 margin-bottom-10 text-right">{{createPairing.pairingPopOver.content.currentDutyPeriod}}</div>\n' +
    '\n' +
    '            <div class="clearfix"></div>\n' +
    '\n' +
    '            <div class="col-md-8 margin-bottom-10">Extended FDP By Split Duty <i style="color: orange;font-size: 10px" class="material-icons">fiber_manual_record</i></div>\n' +
    '            <div class="col-md-4 margin-bottom-10 text-right">{{createPairing.pairingPopOver.content.extendedFDPSplitDuty}}</div>\n' +
    '\n' +
    '            <div class="clearfix"></div>\n' +
    '\n' +
    '            <div class="col-md-8 margin-bottom-10">Maximum FDP Limit</div>\n' +
    '            <div class="col-md-4 margin-bottom-10 text-right">{{createPairing.pairingPopOver.content.maxFDPLimit}}</div>\n' +
    '\n' +
    '            <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '    </div>');
	a.put('evaluate_trainings.tpl.html', '<div class="modal-header">\n' +
    '  <h4 class="modal-title">Update Training Results</h4>\n' +
    '  <button type="button" class="close" data-dismiss="modal" data-ng-click="evalTrainings.closeMe()" aria-hidden="true">\n' +
    '    <i class="material-icons">clear</i>\n' +
    '  </button>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-12 padding-0">\n' +
    '      <table class="table">\n' +
    '        <thead>\n' +
    '        <tr>\n' +
    '          <th class="td-vertical-align text-center">#</th>\n' +
    '          <th class="td-vertical-align text-center">Training Slot</th>\n' +
    '          <th class="td-vertical-align text-left">Assigned Crew</th>\n' +
    '\n' +
    '        </tr>\n' +
    '        </thead>\n' +
    '        <tbody>\n' +
    '        <tr ng-if="evalTrainings.model.info.length == 0">\n' +
    '          <td colspan="4" align="center">No Records Found</td>\n' +
    '        </tr>\n' +
    '\n' +
    '        <tr data-ng-repeat="training in evalTrainings.model.info track by $index">\n' +
    '          <td class="td-vertical-align text-center">\n' +
    '            <div>{{$index+1}}</div>\n' +
    '          </td>\n' +
    '          <td class="td-vertical-align text-center">\n' +
    '              <input type="checkbox" id="select-{{training.trainingSlotId}}" ng-model="training.allCrewSelected" ng-click="evalTrainings.selectAllCrewForTraining(training)">\n' +
    '              <label class="checkbox" for="select-{{training.trainingSlotId}}" ng-style="{\'color\': \'black\'}"> &emsp; {{training.trainingSlot}}</label>\n' +
    '          </td>\n' +
    '\n' +
    '\n' +
    '          <td class="td-vertical-align text-center">\n' +
    '            <table>\n' +
    '              <tr data-ng-repeat="crew in training.assignedCrewTrainingDetails track by $index">\n' +
    '\n' +
    '                <td class="td-vertical-align text-left" ng-if="$index % 2 === 0">\n' +
    '                  <input ng-if="$index % 2 === 0" type="checkbox" id="{{crew.crewProfileId}}-{{training.trainingSlotId}}" ng-model="crew.isChecked" ng-disabled="!training.expiryUpdatable || crew.trainingCategory !== \'TRAINEE\'">\n' +
    '                  <label ng-if="$index % 2 === 0" class="checkbox" for="{{crew.crewProfileId}}-{{training.trainingSlotId}}" ng-style="{\'color\': \'black\'}">{{crew.crewName}} -\n' +
    '                    <span style="background-color: #296ef1; border: 1px solid #000; padding: 1px 3px; margin-left: 3px; color: white; font-size: 12px">{{crew.crewType}}</span>\n' +
    '                    <span ng-if="crew.otherHub" style="background-color: #296ef1; border: 1px solid #000; padding: 1px 3px; margin-left: 3px; color: white; font-size: 12px">{{crew.otherHub}}</span>\n' +
    '                    <a ng-hide="!training.expiryUpdatable || crew.trainingCategory !== \'TRAINEE\'">[<a ng-style="{\'color\': (crew.result == null ? \'blue\' : crew.result == \'FAIL\' ? \'red\' : \'green\')}" ng-hide="!training.expiryUpdatable || crew.trainingCategory !== \'TRAINEE\'">{{crew.result}} <a ng-if="crew.result == null" ng-hide="!training.expiryUpdatable || crew.trainingCategory !== \'TRAINEE\'">PENDING</a><a ng-hide="!training.expiryUpdatable || crew.trainingCategory !== \'TRAINEE\'">]</a></a></a> &emsp; &emsp;</label>\n' +
    '\n' +
    '                  <input ng-if="training.assignedCrewTrainingDetails.length > ($index + 1)" type="checkbox" id="{{training.assignedCrewTrainingDetails[$index + 1].crewProfileId}}-{{training.trainingSlotId}}" ng-model="training.assignedCrewTrainingDetails[$index + 1].isChecked" ng-disabled="!training.expiryUpdatable || training.assignedCrewTrainingDetails[$index + 1].trainingCategory !== \'TRAINEE\'">\n' +
    '                  <label ng-if="training.assignedCrewTrainingDetails.length > ($index + 1)" class="checkbox" for="{{training.assignedCrewTrainingDetails[$index + 1].crewProfileId}}-{{training.trainingSlotId}}" ng-style="{\'color\': \'black\'}">{{training.assignedCrewTrainingDetails[$index + 1].crewName}} -\n' +
    '                    <span style="background-color: #296ef1; border: 1px solid #000; padding: 1px 3px; margin-left: 3px; color: white; font-size: 12px">{{training.assignedCrewTrainingDetails[$index + 1].crewType}}</span>\n' +
    '                    <span ng-if="training.assignedCrewTrainingDetails[$index + 1].otherHub" style="background-color: #296ef1; border: 1px solid #000; padding: 1px 3px; margin-left: 3px; color: white; font-size: 12px">{{training.assignedCrewTrainingDetails[$index + 1].otherHub}}</span>\n' +
    '                    <a ng-hide="!training.expiryUpdatable || training.assignedCrewTrainingDetails[$index + 1].trainingCategory !== \'TRAINEE\'">[<a ng-style="{\'color\': (training.assignedCrewTrainingDetails[$index + 1].result == null ? \'blue\' : training.assignedCrewTrainingDetails[$index + 1].result == \'FAIL\' ? \'red\' : \'green\')}" ng-hide="!training.expiryUpdatable || training.assignedCrewTrainingDetails[$index + 1].trainingCategory !== \'TRAINEE\'">{{training.assignedCrewTrainingDetails[$index + 1].result}}\n' +
    '                      <a ng-if="training.assignedCrewTrainingDetails[$index + 1].result == null" ng-hide="!training.expiryUpdatable || training.assignedCrewTrainingDetails[$index + 1].trainingCategory !== \'TRAINEE\'">PENDING</a>\n' +
    '                      <a ng-hide="!training.expiryUpdatable || training.assignedCrewTrainingDetails[$index + 1].trainingCategory !== \'TRAINEE\'">]\n' +
    '                      </a>\n' +
    '                    </a>\n' +
    '                    </a>\n' +
    '                  </label>\n' +
    '                </td>\n' +
    '\n' +
    '              </tr>\n' +
    '            </table>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '        </tbody>\n' +
    '      </table>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<div class="col-md-12">\n' +
    '  <div class="col-md-3 pull-right">\n' +
    '    <div class="group">\n' +
    '      <select-component component-name="Result" label-field-name="name" value-field-name="name" menu-data-source="evalTrainings.model.allResults" selected-value="evalTrainings.model.selectedResult"></select-component>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '\n' +
    '<div class="row margin-bottom-20">\n' +
    '  <div class="col-md-2">\n' +
    '  </div>\n' +
    '  <div class="col-md-10">\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '<div class="modal-body send-sms">\n' +
    '\n' +
    '  <div class="row margin-bottom-10">\n' +
    '    <div class="col-md-12">\n' +
    '      <button class="btn btn-blue pull-right" type="button" data-ng-click="evalTrainings.updateResults()">Update</button>\n' +
    '      <button class="btn btn-grey" type="button" data-ng-click="evalTrainings.closeMe()">Close</button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</div>');
	a.put('edit-training-popover.tpl.html', '<div class="training-popover">\n' +
    '    <div class="popover-title margin-bottom-10" style="background-color:#0bae8e">{{$ctrl.popover.trainingLocDesc}} {{$ctrl.popover.trainingProCategory}}\n' +
    '        <button type="button" class="close" ng-click="$ctrl.closePopover()"><i class="material-icons">close</i></button>\n' +
    '        <button type="button" class="close" ng-if="$ctrl.popover.usedInCurrentPattern"><i class="material-icons">check_circle</i></button>\n' +
    '    </div>\n' +
    '    <div class="clearfix"></div>\n' +
    '    <div class="row padding-10">\n' +
    '        <div class="col-md-5 padding-right-0">\n' +
    '            Program\n' +
    '        </div>\n' +
    '        <div class="col-md-7 padding-left-0">\n' +
    '            <strong>: {{$ctrl.popover.trainingProgramDesc}}</strong>\n' +
    '        </div>\n' +
    '        <div class="clearfix"></div>\n' +
    '        <div class="col-md-5 padding-right-0">\n' +
    '            Location\n' +
    '        </div>\n' +
    '        <div class="col-md-7 padding-left-0">\n' +
    '            <strong>: {{$ctrl.popover.trainingLocCode}}</strong>\n' +
    '        </div>\n' +
    '        <div class="clearfix"></div>\n' +
    '        <div class="col-md-5 padding-right-0">\n' +
    '            Slot\n' +
    '        </div>\n' +
    '        <div class="col-md-7 padding-left-0">\n' +
    '            <strong>: {{$ctrl.popover.slotName}}</strong>\n' +
    '        </div>\n' +
    '        <div class="clearfix"></div>\n' +
    '        <div class="col-md-5 padding-right-0">\n' +
    '            Time\n' +
    '        </div>\n' +
    '        <div class="col-md-7 padding-left-0">\n' +
    '            <strong>: {{$ctrl.popover.startDateZulu}} {{$ctrl.popover.startTimeZulu}} /\n' +
    '                {{$ctrl.popover.endDateZulu}} {{$ctrl.popover.endTimeZulu}}</strong>\n' +
    '        </div>\n' +
    '        <div class="clearfix"></div>\n' +
    '        <div class="col-md-5 padding-right-0">\n' +
    '            Assigned\n' +
    '        </div>\n' +
    '        <div class="col-md-7 padding-left-0">\n' +
    '            <strong>: {{$ctrl.popover.assignedNoOfCrew}}</strong>\n' +
    '        </div>\n' +
    '        <div class="clearfix"></div>\n' +
    '        <div class="col-md-5 padding-right-0">\n' +
    '            Required\n' +
    '            </div>\n' +
    '            <div class="col-md-7 padding-left-0">\n' +
    '                <strong>: {{$ctrl.popover.requiredNoOfCrew}}</strong>\n' +
    '            </div>\n' +
    '            <div class="clearfix"></div>\n' +
    '        <div class="col-md-12 margin-top-20">\n' +
    '            <div class="group">\n' +
    '                <select-component component-name="Training Programs *" label-field-name="trainingProgramCode" menu-data-source="$ctrl.programs" selected-value="$ctrl.popover.trainingProgram" on-item-selected="$ctrl.onChangeProgram(selectedItem)"></select-component>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="clearfix"></div>\n' +
    '        <div class="col-md-12">\n' +
    '            <div class="group">\n' +
    '                <select-component component-name="Program Detail *" label-field-name="trainingProgDetailDesc" menu-data-source="$ctrl.programDetails" selected-value="$ctrl.popover.trainingProgramDetail" on-item-selected="$ctrl.onChangeProgramDetail(selectedItem)"></select-component>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '      <div class="clearfix"></div>\n' +
    '      <div class="col-md-12">\n' +
    '        <div class="col-md-12 margin-bottom-10 radio-group">\n' +
    '          <label class="radio-label margin-bottom-15 text">Rest Required?</label>\n' +
    '          <div class="clearfix"></div>\n' +
    '          <div class="checkbox-left-align">\n' +
    '            <input type="radio" name="$ctrl.rest" value="true" ng-model="$ctrl.rest"><label class="text">Yes</label>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="checkbox-left-align margin-left-20">\n' +
    '            <input type="radio" name="$ctrl.rest" value="false" ng-model="$ctrl.rest"><label class="text">No </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '<!--        <div class="group" >-->\n' +
    '<!--          <select-component-->\n' +
    '<!--            component-name="Rest Required *"-->\n' +
    '<!--            label-field-name="trainingProgDetailDesc"-->\n' +
    '<!--            menu-data-source="$ctrl.programDetails"-->\n' +
    '<!--            selected-value="$ctrl.popover.trainingProgramDetail"-->\n' +
    '<!--            on-item-selected="$ctrl.onChangeProgramDetail(selectedItem)"></select-component>-->\n' +
    '<!--        </div>-->\n' +
    '      </div>\n' +
    '        <div class="clearfix"></div>\n' +
    '        <div class="col-md-12" ng-if="$ctrl.showInCrewPortal!==null">\n' +
    '            <div class="checkbox-left-align" ng-if="$ctrl.showInCrewPortal.isVisible">\n' +
    '                <input type="checkbox" id="test22" data-ng-model="$ctrl.showInCrewPortal.value" ng-disabled="!$ctrl.showInCrewPortal.isEnabled">\n' +
    '                <label for="test22" class="small-checkbox"></label>\n' +
    '                <label>Hide in Crew Portal</label>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-12 margin-bottom-10">\n' +
    '            <button class="btn-panel" type="button" ng-click="$ctrl.onAddTrainingClick($ctrl.popover)">Add Training</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
	a.put('delayed_report_timing.tpl.html', '<div class="modal-header">\n' +
    '  <h4 class="modal-title">{{DelayedReportTimingCtrl.model.title}}</h4>\n' +
    '  <button type="button" data-ng-click="DelayedReportTimingCtrl.onCloseClick()" class="close" data-dismiss="modal" aria-hidden="true"><i class="material-icons">clear</i></button>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '\n' +
    '  <div class="col-md-12 col-sm-3">\n' +
    '    <div class="row" style="overflow-x: auto; display: block">\n' +
    '      <table class="table" style="min-width: 2000px">\n' +
    '        <thead style="background-color: #718b98">\n' +
    '        <tr class="row">\n' +
    '          <th class="td-vertical-align text-center" style="vertical-align: top !important">Crew Id</th>\n' +
    '          <th class="td-vertical-align text-center" style="vertical-align: top !important">Crew Name</th>\n' +
    '          <th class="td-vertical-align text-center" style="vertical-align: top !important">Crew Type</th>\n' +
    '          <th class="td-vertical-align text-center" style="vertical-align: top !important">Check-in (UTC)</th>\n' +
    '          <th class="td-vertical-align text-center" style="vertical-align: top !important">Sign-in (UTC)</th>\n' +
    '          <th class="td-vertical-align text-center" style="vertical-align: top !important">Check-out (UTC)</th>\n' +
    '          <th class="td-vertical-align text-center" style="vertical-align: top !important">Max FDP</th>\n' +
    '          <th class="td-vertical-align text-center" style="vertical-align: top !important">Block FDP</th>\n' +
    '          <th class="td-vertical-align text-center" style="vertical-align: top !important">Duty Hrs</th>\n' +
    '          <th ng-if="DelayedReportTimingCtrl.model.showMaxDutyHrLimit" class="td-vertical-align text-center" style="vertical-align: top !important">Max Duty Hr Limit</th>\n' +
    '          <th class="td-vertical-align text-center" style="vertical-align: top !important">SBY Call Out</th>\n' +
    '          <th class="td-vertical-align text-center" style="vertical-align: top !important">Delayed Reporting</th>\n' +
    '          <th ng-if="DelayedReportTimingCtrl.model.showReduceRestColumn" class="td-vertical-align text-center" style="vertical-align: top !important">Reduce Rest</th>\n' +
    '          <th class="td-vertical-align text-center" style="vertical-align: top !important">\n' +
    '            <div style="display: inline-block; text-align: left">\n' +
    '              Original Check-in (UTC)\n' +
    '              <div style="padding-top: 3px; margin-top: 2px; font-size: 0.85em">\n' +
    '                <input type="checkbox" id="applySameOriginalCheckinHeader" name="applySameOriginalCheckinHeader" style="vertical-align: middle; margin-right: 4px" ng-click="DelayedReportTimingCtrl.applyDateToAll()" ng-model="DelayedReportTimingCtrl.applyDateTimeToAll" ng-disabled="DelayedReportTimingCtrl.isDisabledInputItems">\n' +
    '                <label for="applySameOriginalCheckinHeader" style="font-weight: bold; font-family: Roboto, sans-serif; color: #212121; vertical-align: middle">Apply To All</label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </th>\n' +
    '        </tr>\n' +
    '        </thead>\n' +
    '        <tbody style="overflow-x:auto">\n' +
    '        <tr ng-if="DelayedReportTimingCtrl.model.delayedReportTimingList.length == 0">\n' +
    '          <td colspan="13" align="center">No Records Found</td>\n' +
    '        </tr>\n' +
    '        <tr data-ng-repeat="delayedTiming in DelayedReportTimingCtrl.model.delayedReportTimingList  track by $index" class="row">\n' +
    '          <td class="td-vertical-align text-center" style="padding-top: 10px !important">{{delayedTiming.crewId}}</td>\n' +
    '          <td class="td-vertical-align text-left" style="padding-top: 10px !important">{{delayedTiming.crewName}}</td>\n' +
    '          <td class="td-vertical-align text-center" style="padding-top: 10px !important">{{delayedTiming.crewType}}</td>\n' +
    '          <td class="td-vertical-align text-center" style="width: 210px">\n' +
    '            <div class="col-md-8" ng-class="{\'disable-calendar\': DelayedReportTimingCtrl.isDisabledInputItems}">\n' +
    '              <input type="text" class="calID" jq-date-picker-options="" ng-model="delayedTiming.checkInDate" ng-change="DelayedReportTimingCtrl.changeAny($event)" ng-disabled="DelayedReportTimingCtrl.isDisabledInputItems" style="top: 0px !important" ng-class="{\'invalid-input\': DelayedReportTimingCtrl.isInvalidCheckinCheckOutTiming(delayedTiming)}">\n' +
    '            </div>\n' +
    '            <div class="col-md-4">\n' +
    '              <input class="inline-input" type="text" contenteditable="true" tabindex="11" ng-model="delayedTiming.checkInTime" ui-mask="29:69" ui-mask-auto-complete="" ui-mask-placeholder="HH:MM" ui-mask-placeholder-char=" " model-view-value="true" ng-disabled="DelayedReportTimingCtrl.isDisabledInputItems" style="top: 0px !important" ng-class="{\'invalid-input\': DelayedReportTimingCtrl.isInvalidCheckinCheckOutTiming(delayedTiming)}">\n' +
    '            </div>\n' +
    '          </td>\n' +
    '          <td class="td-vertical-align text-center" style="width: 230px">\n' +
    '            <div class="col-md-8" ng-class="{\'disable-calendar\': DelayedReportTimingCtrl.isDisabledInputItems&&DelayedReportTimingCtrl.canEditSignIn}">\n' +
    '              <input type="text" class="calID" jq-date-picker-options="" ng-model="delayedTiming.signInDate" ng-change="DelayedReportTimingCtrl.changeAny($event)" ng-disabled="DelayedReportTimingCtrl.isDisabledInputItems||!delayedTiming.isSignInTimeEditable" style="top: 0px !important" ng-class="{\'invalid-input\': DelayedReportTimingCtrl.isSignInTimeExceeding24Hours(delayedTiming)}">\n' +
    '            </div>\n' +
    '            <div class="col-md-4">\n' +
    '              <input class="inline-input" type="text" contenteditable="true" tabindex="11" ng-model="delayedTiming.signInTime" ui-mask="29:69" ui-mask-auto-complete="" ui-mask-placeholder="HH:MM" ui-mask-placeholder-char=" " model-view-value="true" ng-disabled="DelayedReportTimingCtrl.isDisabledInputItems||!delayedTiming.isSignInTimeEditable" style="top: 0px !important" ng-class="{\'invalid-input\': DelayedReportTimingCtrl.isSignInTimeExceeding24Hours(delayedTiming)}">\n' +
    '            </div>\n' +
    '          </td>\n' +
    '          <td class="td-vertical-align text-center" style="width: 210px">\n' +
    '            <div class="col-md-8" ng-class="{\'disable-calendar\': DelayedReportTimingCtrl.isDisabledInputItems}">\n' +
    '              <input type="text" class="calID" jq-date-picker-options="" ng-model="delayedTiming.checkOutDate" ng-change="DelayedReportTimingCtrl.changeAny($event)" ng-disabled="DelayedReportTimingCtrl.isDisabledInputItems" style="top: 0px !important">\n' +
    '            </div>\n' +
    '            <div class="col-md-4">\n' +
    '              <input class="inline-input" type="text" contenteditable="true" tabindex="11" ng-model="delayedTiming.checkOutTime" ui-mask="29:69" ui-mask-auto-complete="" ui-mask-placeholder="HH:MM" ui-mask-placeholder-char=" " model-view-value="true" ng-disabled="DelayedReportTimingCtrl.isDisabledInputItems" style="top: 0px !important">\n' +
    '            </div>\n' +
    '          </td>\n' +
    '          <td class="td-vertical-align text-center" style="padding-top: 10px !important">\n' +
    '            <span>{{delayedTiming.maxFDP || \'--:--\'}}</span>\n' +
    '            <i class="material-icons fdp-pending ng-scope" ng-if="delayedTiming.hasFlightPatternUpdateSync" style="color: #0000ff; vertical-align: middle; font-size: 18px; margin-left: 3px">sync_problem</i>\n' +
    '          </td>\n' +
    '          <td class="td-vertical-align text-center" style="padding-top: 10px !important">{{delayedTiming.blockFDP}}</td>\n' +
    '          <td class="td-vertical-align text-center" style="padding-top: 10px !important" ng-style="DelayedReportTimingCtrl.model.showMaxDutyHrLimit\n' +
    '              && (delayedTiming.crewType === \'CC\' || delayedTiming.crewType === \'CS\')\n' +
    '               && delayedTiming.maxDutyHrLimitDecimal != null\n' +
    '               && delayedTiming.dutyHrsDecimal > delayedTiming.maxDutyHrLimitDecimal ?\n' +
    '               {\'color\': \'red\', \'font-weight\': \'bold\'} : {}">{{delayedTiming.dutyHrs}}</td>\n' +
    '          <td ng-if="DelayedReportTimingCtrl.model.showMaxDutyHrLimit" class="td-vertical-align text-center" style="padding-top: 10px !important">{{delayedTiming.maxDutyHrLimit || \'--:--\'}}</td>\n' +
    '          <td class="td-vertical-align text-center">\n' +
    '            <div>\n' +
    '              <input type="checkbox" id="{{\'sbyCallOut\'+delayedTiming.crewId}}" ng-model="delayedTiming.sbyCallOut" ng-disabled="true">\n' +
    '              <label class="checkbox" for="{{\'sbyCallOut\'+delayedTiming.crewId}}"></label>\n' +
    '            </div>\n' +
    '          </td>\n' +
    '          <td class="td-vertical-align text-center">\n' +
    '            <div>\n' +
    '              <input type="checkbox" id="{{\'delayedReportTiming\'+delayedTiming.crewId}}" ng-model="delayedTiming.delayedReporting" ng-disabled="DelayedReportTimingCtrl.isDisabledInputItems">\n' +
    '              <label class="checkbox" for="{{\'delayedReportTiming\'+delayedTiming.crewId}}"></label>\n' +
    '            </div>\n' +
    '          </td>\n' +
    '          <td ng-if="DelayedReportTimingCtrl.model.showReduceRestColumn" class="td-vertical-align text-center">\n' +
    '            <div>\n' +
    '              <input type="checkbox" id="{{\'reduceRest\'+delayedTiming.crewId}}" ng-model="delayedTiming.reduceRest" ng-disabled="DelayedReportTimingCtrl.isDisabledInputItems || (delayedTiming.crewType !== \'CC\' && delayedTiming.crewType !== \'CS\')">\n' +
    '              <label class="checkbox" for="{{\'reduceRest\'+delayedTiming.crewId}}"></label>\n' +
    '            </div>\n' +
    '          </td>\n' +
    '          <td class="td-vertical-align text-center" style="width: 230px">\n' +
    '            <div class="col-md-8" ng-class="{\'disable-calendar\': (!delayedTiming.delayedReporting|| DelayedReportTimingCtrl.isDisabledInputItems)}">\n' +
    '              <input type="text" class="calID" jq-date-picker-options="" ng-model="delayedTiming.originalCheckInDate" ng-change="DelayedReportTimingCtrl.changeAny($event)" ng-disabled="(!delayedTiming.delayedReporting||DelayedReportTimingCtrl.isDisabledInputItems)" style="top: 0px !important" ng-class="[{\'invalid-input\': DelayedReportTimingCtrl.isInvalidCheckinOriginalCheckinTiming(delayedTiming)} , {\'invalid-input\': DelayedReportTimingCtrl.isOriginalCheckinTimeBehind(delayedTiming)}]">\n' +
    '            </div>\n' +
    '            <div class="col-md-4">\n' +
    '              <input class="inline-input" type="text" contenteditable="true" tabindex="11" ng-model="delayedTiming.originalCheckInTime" ui-mask="29:69" ui-mask-auto-complete="" ui-mask-placeholder="HH:MM" ui-mask-placeholder-char=" " model-view-value="true" ng-disabled="(!delayedTiming.delayedReporting||DelayedReportTimingCtrl.isDisabledInputItems)" style="top: 0px !important" ng-class="[{\'invalid-input\': DelayedReportTimingCtrl.isInvalidCheckinOriginalCheckinTiming(delayedTiming)} , {\'invalid-input\': DelayedReportTimingCtrl.isOriginalCheckinTimeBehind(delayedTiming)}]">\n' +
    '            </div>\n' +
    '          </td>\n' +
    '        </tr>\n' +
    '        </tbody>\n' +
    '      </table>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '  <button class="btn btn-grey" type="button" ng-click="DelayedReportTimingCtrl.onNoClick()">Close</button>\n' +
    '  <button class="btn btn-blue" type="button" ng-click="DelayedReportTimingCtrl.onClickUpdate()" ng-show="DelayedReportTimingCtrl.isDisabledInputItems">Update</button>\n' +
    '  <button class="btn btn-blue" type="button" ng-click="DelayedReportTimingCtrl.onClickSave()" ng-hide="DelayedReportTimingCtrl.isDisabledInputItems">Save</button>\n' +
    '</div>');
	a.put('deadhead_travel_response.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">DeadHead Travel Bookings </h4>\n' +
    '    <button ng-if="deadheadTravel.model.failedCount==0" type="button" class="close" data-dismiss="modal" data-ng-click="deadheadTravel.closeMe()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '<div class="modal-body add-pattern">\n' +
    '\n' +
    '    <div class="row margin-bottom-10" ng-if="deadheadTravel.model.responseList.length!==0">\n' +
    '       <div class="col-md-12">\n' +
    '            <p class="bold font-16">Deadhead Travel Requests</p>\n' +
    '            <div class="table-section margin-bottom-0">\n' +
    '                <table class="header">\n' +
    '                    <thead>\n' +
    '                    <tr>\n' +
    '                        <th style="width: 30%">Requested Date Time</th>\n' +
    '                        <th style="width: 30%">PNR</th>\n' +
    '                        <th>Status</th>\n' +
    '                        <th>      </th>\n' +
    '                        <th>      </th>\n' +
    '                        <th>      </th>\n' +
    '                    </tr>\n' +
    '                    </thead>\n' +
    '                </table>\n' +
    '                <div class="content-table">\n' +
    '                    <table class="table content">\n' +
    '                        <tbody>\n' +
    '                        <tr ng-repeat="dto in deadheadTravel.model.responseList track by $index" style="height: 20px">\n' +
    '                            <td style="width: 30%">{{dto.bookingDateTime}}</td>\n' +
    '                            <td style="width: 30%">{{dto.pnr=== null?\' - \':dto.pnr}}</td>\n' +
    '                            <td>\n' +
    '                              <span style="color: red;vertical-align:top" ng-show="!dto.bookingSuccess" uib-tooltip-template="\'error.html\'" ng-mouseover="deadheadTravel.showFailDetails(dto.bookingError)"><i class="material-icons small-icon">error_outline</i></span>\n' +
    '                              {{dto.bookingStatus}}</td>\n' +
    '                            <td ng-if="!dto.bookingSuccess">\n' +
    '                              <button type="button" class="btn btn-primary pull-right" ng-click="deadheadTravel.onResubmitTravelRequest(dto.patternId)">Resend</button></td>\n' +
    '                            <td ng-if="!dto.bookingSuccess">\n' +
    '                            <button type="button" class="btn btn-primary pull-right" ng-click="deadheadTravel.onOverrideTravelRequest(dto.patternId)">Override</button></td>\n' +
    '                            <td ng-if="!dto.bookingSuccess">\n' +
    '                            </td>\n' +
    '                            </tr>\n' +
    '                          \n' +
    '                        </tbody>\n' +
    '                    </table>\n' +
    '                </div>\n' +
    '             </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<script type="text/ng-template" id="error.html">\n' +
    '  <div style="padding: 5px">{{deadheadTravel.model.detailedMessage}}\n' +
    '  </div>\n' +
    '</script>');
	a.put('datepicker.tpl.html', '<input type="text" class="calID" set-auto-date="" required="" name="{{dpName}}">');
	a.put('datepicker.inline.tpl.html', '<div class="calID"></div>');
	a.put('crewing_replace_pairing.tpl.html', '<div class="modal-header">\n' +
    '  <h4 class="modal-title">Replace Pairing</h4>\n' +
    '  <button type="button" class="close" data-dismiss="modal" data-ng-click="replaceCtrl.closeMe()" aria-hidden="true">\n' +
    '    <i class="material-icons">clear</i>\n' +
    '  </button>\n' +
    '</div>\n' +
    '<div class="modal-body add-pattern">\n' +
    '  <div class="row" ng-show="replaceCtrl.model.patternData.length">\n' +
    '\n' +
    '    <div class="col-md-12 header-container">\n' +
    '      <div class="add-pattern-wrapper">\n' +
    '        <div class="pattern-div-header">\n' +
    '          <div class="headers bold search" style="width: 20%">\n' +
    '            <div class="group">\n' +
    '              <input type="text" data-ng-model="replaceCtrl.model.searchByName">\n' +
    '              <span class="bar"></span> <label>Search by Name</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="headers search" style="width: 10%">\n' +
    '            <div class="group">\n' +
    '              <select ng-options="type.name for type in replaceCtrl.model.patternTypes" ng-model="replaceCtrl.model.searchByPatternType">\n' +
    '                <option value="">Pattern Type</option>\n' +
    '              </select>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="headers bold search" style="width: 12%">\n' +
    '            <div class="group">\n' +
    '              <input type="text" data-ng-model="replaceCtrl.model.searchByAircraft"> <span class="bar"></span> <label>AC Model</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="headers bold search" style="width: 12%">\n' +
    '            <div class="group">\n' +
    '              <input type="text" data-ng-model="replaceCtrl.model.searchByStartDate"> <span class="bar"></span> <label>Start Time</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="headers bold search" style="width: 10%">\n' +
    '            <div class="group">\n' +
    '              <input type="text" data-ng-model="replaceCtrl.model.searchByEndDate"> <span class="bar"></span> <label>End Date</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="headers bold search" style="width: 8%">\n' +
    '            <div class="group">\n' +
    '              <input type="text" data-ng-model="replaceCtrl.model.searchByCrewAssigned"> <span class="bar"></span> <label>Assigned</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="headers bold search" style="width: 8%">\n' +
    '            <div class="group">\n' +
    '              <input type="text" data-ng-model="replaceCtrl.model.searchByCrewRequired"> <span class="bar"></span> <label>Required</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="headers bold search" style="width: 10%">\n' +
    '            <div class="group">\n' +
    '              <input type="text" data-ng-model="replaceCtrl.model.searchByDurationType"> <span class="bar"></span> <label>Duration Type</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="headers search" style="width: 10%">\n' +
    '            <div class="group">\n' +
    '              <select ng-options="pairingBase for pairingBase in replaceCtrl.model.pairingBases" ng-model="replaceCtrl.model.searchByPairingBase">\n' +
    '                <option value="">ALL</option>\n' +
    '              </select>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="headers text-right bold search" style="width: 5%">&nbsp;</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="pattern-div-header">\n' +
    '          <div class="headers bold" style="width: 25%">Name</div>\n' +
    '          <div class="headers bold" style="width: 5%">&nbsp;&nbsp;&nbsp;&nbsp;</div>\n' +
    '          <div class="headers bold" style="width: 10%">Aircraft</div>\n' +
    '          <div class="headers bold" style="width: 17%">Start Date Time\n' +
    '            (Local)</div>\n' +
    '          <div class="headers bold" style="width: 17%">End Date Time\n' +
    '            (Local)</div>\n' +
    '          <div class="headers bold" style="width: 5%">Assigned</div>\n' +
    '          <div class="headers bold" style="width: 5%">Req</div>\n' +
    '          <div class="headers bold" style="width: 11%">Duration Type</div>\n' +
    '          <div class="headers text-right bold" style="width: 5%">&nbsp;</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-md-12">\n' +
    '      <div class="add-pattern-container">\n' +
    '        <div class="add-pattern-wrapper" data-ng-repeat="pattern in replaceCtrl.model.patternData |\n' +
    '                     filter:{patternName: replaceCtrl.model.searchByName,\n' +
    '                             patternType :replaceCtrl.model.searchByPatternType.name.toUpperCase(),\n' +
    '                             aircraftModelNum1:replaceCtrl.model.searchByAircraft,\n' +
    '                             startTime : replaceCtrl.model.searchByStartDate,\n' +
    '                             endDate :replaceCtrl.model.searchByEndDate,\n' +
    '                             assignedCrew :replaceCtrl.model.searchByCrewAssigned,\n' +
    '                             requiredCrew :replaceCtrl.model.searchByCrewRequired,\n' +
    '                             durationTypeDesc : replaceCtrl.model.searchByDurationType,\n' +
    '                             pairingBase : ((replaceCtrl.model.searchByPairingBase == \'\' ) ? pattern.pairingBase : replaceCtrl.model.searchByPairingBase)\n' +
    '                             }" ng-class="{\'isSelected\':replaceCtrl.model.selectedPattern.patternId == pattern.patternId}">\n' +
    '\n' +
    '          <div class="pattern-div-header" data-ng-click="replaceCtrl.onSelectPairing(pattern)" ng-class="{\n' +
    '                                \'red-header\':pattern.isModified == \'Y\',\n' +
    '                                \'is-training\' : pattern.trainingProgramId != null }">\n' +
    '            <div class="headers" style="width: 25%">\n' +
    '\n' +
    '              <div class="length-ellipsis">{{pattern.patternName}}</div>\n' +
    '\n' +
    '            </div>\n' +
    '            <div class="headers bold" style="width: 5%">\n' +
    '              <span class="away-pairing" ng-show="pattern.landsAwayFromBase">Away</span>\n' +
    '              <span class="open-pairing" ng-show="(pattern.requiredCrew > 0) && (pattern.assignedCrew < pattern.requiredCrew)">Open</span>\n' +
    '              <span class="" ng-hide="(pattern.requiredCrew > 0) && (pattern.assignedCrew < pattern.requiredCrew)">&nbsp;&nbsp;&nbsp;&nbsp;</span>\n' +
    '            </div>\n' +
    '            <div class="headers bold" style="width: 10%">{{pattern.aircraftModelNum1}}\n' +
    '              {{pattern.aircraftModelNum2}}&nbsp;</div>\n' +
    '            <div class="headers" style="width: 17%">{{pattern.startDate}}\n' +
    '              {{pattern.startTime}}</div>\n' +
    '            <div class="headers" style="width: 17%">{{pattern.endDate}}\n' +
    '              {{pattern.endTime}}</div>\n' +
    '            <div class="headers" style="width: 5%">{{pattern.assignedCrew}}</div>\n' +
    '            <div class="headers" style="width: 5%">{{pattern.requiredCrew}}</div>\n' +
    '            <div class="headers" style="width: 11%">{{pattern.durationTypeDesc}}</div>\n' +
    '            <div class="headers text-right" style="width: 5%">\n' +
    '              <a href="" data-ng-click="replaceCtrl.onPairingOpen(pattern)"><i class="material-icons">{{pattern.isOpen ? \'arrow_drop_up\' :\n' +
    '                \'arrow_drop_down\'}}</i></a>\n' +
    '            </div>\n' +
    '            <div class="clearfix"></div>\n' +
    '          </div>\n' +
    '          <div class="pattern-div-body" ng-class="{\'open-pattern\':pattern.isOpen}">\n' +
    '            <div class="pattern-box-outer" data-ng-repeat="block in pattern.moreDetail.blockList">\n' +
    '              <div class="pattern-box-inner" data-ng-repeat="detail in block.blockDetailList" ng-class="detail.type">\n' +
    '                <div class="pattern-box-header" ng-hide="detail.isRest">\n' +
    '                  <i class="material-icons">{{detail.iconClass}}</i>{{detail.header}}\n' +
    '                </div>\n' +
    '                <div class="pattern-box-content" ng-hide="detail.isRest">\n' +
    '                  <div class="start-loc location">\n' +
    '                    {{detail.leftLblOne}}<span>{{detail.leftLblTwo}}</span>\n' +
    '                  </div>\n' +
    '                  <div class="arrow-line"></div>\n' +
    '                  <div class="arrow-right"></div>\n' +
    '                  <div class="end-loc location">\n' +
    '                    {{detail.rightLblOne}}<span>{{detail.rightLblTwo}}</span>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="clearfix"></div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="clearfix"></div>\n' +
    '            </div>\n' +
    '            <div class="clearfix"></div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '        <div class="clearfix"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row no-pairing" ng-show="replaceCtrl.model.showNoRecord">\n' +
    '    No pairings available</div>\n' +
    '  <div class="loading-panel" ng-hide="replaceCtrl.model.showNoRecord || replaceCtrl.model.patternData.length > 0">\n' +
    '    <div class="animation-container">\n' +
    '      <div class="spinner">\n' +
    '        <div class="bounce1"></div>\n' +
    '        <div class="bounce2"></div>\n' +
    '        <div class="bounce3"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-footer add-pattern-footer grey-bg confirmation-footer ng-scope" ng-show="replaceCtrl.model.patternData.length">\n' +
    '  <div style="float: left">\n' +
    '    <span class="away-pairing">Away</span> : Checkout away from crew base\n' +
    '  </div>\n' +
    '  <div class="confirmation-txt">\n' +
    '    <div class="checkbox-right-align">\n' +
    '      <label>Request :</label> <input type="checkbox" id="isRequest" data-ng-model="replaceCtrl.model.isRequest"> <label for="isRequest" class="small-checkbox"></label>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="checkbox-right-align">\n' +
    '      <label>Called from Day Off :</label> <input type="checkbox" id="isCallFromDayOff" data-ng-model="replaceCtrl.model.isCallFromDayOff"> <label for="isCallFromDayOff" class="small-checkbox"></label>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="checkbox-right-align">\n' +
    '      <label>OBS Flight :</label> <input type="checkbox" id="isObsFlight" data-ng-model="replaceCtrl.model.isObsFlight"> <label for="isObsFlight" class="small-checkbox"></label>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="checkbox-right-align">\n' +
    '      <label>Hide in Crew Portal :</label> <input type="checkbox" id="isHideinCrewPortal" data-ng-model="replaceCtrl.model.isHideinCrewPortal"> <label for="isHideinCrewPortal" class="small-checkbox"></label>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '  <button class="btn btn-blue" type="button" ng-click="replaceCtrl.onReplacePairingClick()" ng-class="{\'disable\':!replaceCtrl.model.selectedPattern}" tabindex="0">Replace\n' +
    '    Pairing</button>\n' +
    '</div>\n' +
    '<div>{{params.date}}</div>');
	a.put('crewing_pax_msg_details.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">APP/APIS</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="$close()" aria-hidden="true"><i class="material-icons">clear</i></button>\n' +
    '</div>\n' +
    ' <div class="modal-body margin-bottom-50 show-expiry">\n' +
    '    <div class="row">\n' +
    '        <div class="col-md-12 header-container">\n' +
    '            <div class="add-pattern-wrapper">\n' +
    '                <div class="pattern-div-header">\n' +
    '                    <div class="headers bold" style="width:10%">#</div>\n' +
    '                    <div class="headers bold" style="width:15%">Flight Number</div>\n' +
    '                    <div class="headers bold" style="width:15%">OnD</div>\n' +
    '                    <div class="headers bold" style="width:15%">Message Type</div>\n' +
    '                    <div class="headers bold" style="width:15%">Scheduled Date Time</div>\n' +
    '                    <div class="headers bold" style="width:15%">Country</div>\n' +
    '                    <div class="headers bold" style="width:15%">Status</div>\n' +
    '                    <div class="headers bold"></div>\n' +
    '                    <div class="clearfix"></div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '       <div class="col-md-12">\n' +
    '            <div class="add-pattern-wrapper" data-ng-repeat="pax in paxMsgDet.model.paxMsgDet track by $index">\n' +
    '                <div class="pattern-div-header">\n' +
    '                    <div class="headers" style="width:10%">{{$index+1}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:15%">{{pax.flightNO}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:15%">{{pax.origin}}-{{pax.destination}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:15%">{{pax.msgType}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:15%">{{pax.scheduledDateTime}}&nbsp;</div>\n' +
    '                    <div class="headers" style="width:15%">{{pax.countryCode}} </div>\n' +
    '                    <span ng-if="pax.msgStatus===\'REJECTED\' || pax.msgStatus===\'SERVICE_ERROR\'"><i style="font-size:18px" class="material-icons">error_outline</i>\n' +
    '                	</span>\n' +
    '                    {{pax.msgStatus}}&nbsp;</div>\n' +
    '                    <div ng-if="pax.msgStatus===\'REJECTED\' || pax.msgStatus===\'SERVICE_ERROR\'">\n' +
    '                    	<button type="button" ng-click="paxMsgDet.onResubmit(pax)">Resend</button>\n' +
    '                    </div>\n' +
    '                    <div class="clearfix"></div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '');
	a.put('crewing_history.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">History</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="historyCtrl.closeMe()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '<div class="modal-body margin-bottom-50 add-pattern">\n' +
    '    <div class="row" ng-show="historyCtrl.model.history.length">\n' +
    '\n' +
    '        <div class="col-md-12 header-container">\n' +
    '            <div class="add-pattern-wrapper">\n' +
    '                <div class="pattern-div-header">\n' +
    '                    <div class="headers bold" style="width:30%">Action Date(Local)</div>\n' +
    '                    <div class="headers bold" style="width:30%">Action By</div>\n' +
    '                    <div class="headers bold" style="width:40%">Action</div>\n' +
    '                    <div class="clearfix"></div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-md-12 add-pattern-container">\n' +
    '\n' +
    '            <div class="add-pattern-wrapper" data-ng-repeat="action in historyCtrl.model.history">\n' +
    '\n' +
    '                <div class="pattern-div-header row-content" ng-class="{\'alternate\':$index % 2 == 0}">\n' +
    '                    <div class="headers bold" style="width:30%">{{action.createdDate}}</div>\n' +
    '                    <div class="headers bold" style="width:30%">{{action.createdBy}}</div>\n' +
    '                    <div class="headers" style="width:40%">{{action.action}}</div>\n' +
    '                    <div class="clearfix"></div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div ng-show="historyCtrl.model.history.length == 0">\n' +
    '        <div class="col-md-12 no-pairing">History not available</div>\n' +
    '\n' +
    '    </div>\n' +
    '</div>');
	a.put('crewing_assign_training.tpl.html', '<!--<div class="modal-header">\n' +
    '    <div class="row">\n' +
    '        <div class="col-md-12">\n' +
    '            <h4 class="modal-title">Add Training</h4>\n' +
    '\n' +
    '\n' +
    '            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n' +
    '                    data-ng-click="trainingCtrl.onCloseClick()"><i class="material-icons">clear</i></button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-body margin-bottom-50 trainig-pattern-view ">\n' +
    '    <div class="canvas" style="width: 95%" ng-show="!trainingCtrl.model.isLoadingVisible">\n' +
    '        <training-pairing-component\n' +
    '                start-date="trainingCtrl.model.selectedDate"\n' +
    '                on-select-training=""\n' +
    '                on-select-program=""\n' +
    '                show-in-crew-portal="trainingCtrl.model.showInCrewPortal"\n' +
    '                on-add-training="trainingCtrl.onAddTrainingClick(selectedTraining)"></training-pairing-component>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="loading-panel" ng-show="trainingCtrl.model.isLoadingVisible">\n' +
    '        <div class="animation-container">\n' +
    '            <div class="spinner">\n' +
    '                <div class="bounce1"></div>\n' +
    '                <div class="bounce2"></div>\n' +
    '                <div class="bounce3"></div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '</div>-->\n' +
    '\n' +
    '<div class="modal-header">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-12">\n' +
    '      <h4 class="modal-title">Add Training</h4>\n' +
    '\n' +
    '\n' +
    '      <button type="button" class="close" data-dismiss="modal" aria-hidden="true" data-ng-click="trainingCtrl.onCloseClick()"><i class="material-icons">clear</i></button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-body add-pattern" style="height: 380px">\n' +
    '  <div class="row">\n' +
    '\n' +
    '    <div class="col-md-12 header-container">\n' +
    '      <div class="add-pattern-wrapper">\n' +
    '       <div class="pattern-div-header">\n' +
    '\n' +
    '          <div class="headers bold search" style="width: 40%">\n' +
    '            <div class="group">\n' +
    '            </div>\n' +
    '          </div>\n' +
    '           <div class="headers search" style="width: 30%;overflow: visible">\n' +
    '             <div class="group">\n' +
    '               <select-component component-name="By Location" label-field-name="location" menu-data-source="trainingCtrl.model.locationList" selected-value="trainingCtrl.model.formVal.selectedLocation" on-item-selected="trainingCtrl.onSelectLocation(selectedItem)"></select-component>\n' +
    '             </div>\n' +
    '           </div>\n' +
    '\n' +
    '           <div class="headers bold search" style="width: 30%;overflow: visible">\n' +
    '             <div class="group">\n' +
    '               <select-component component-name="By Category" label-field-name="category" menu-data-source="trainingCtrl.model.categoryList" selected-value="trainingCtrl.model.formVal.selectedTrainingCategory" on-item-selected="trainingCtrl.onSelectCategory(selectedItem)"></select-component>\n' +
    '             </div>\n' +
    '           </div>\n' +
    '          </div>\n' +
    '\n' +
    '        <div class="pattern-div-header">\n' +
    '          <div class="headers bold" style="width: 20%">Training Slot	</div>\n' +
    '          <div class="headers bold" style="width: 10%">Start Date</div>\n' +
    '          <div class="headers bold" style="width: 10%">End Date</div>\n' +
    '          <div class="headers bold" style="width: 5%">Training Category	</div>\n' +
    '          <div class="headers bold" style="width: 15%">Location</div>\n' +
    '          <div class="headers bold" style="width: 10%">Crew Assigned</div>\n' +
    '          <div class="headers bold" style="width: 10%">Crew Required</div>\n' +
    '          <div class="headers bold" style="width: 10%">Training Prog.	</div>\n' +
    '          <div class="headers bold" style="width: 10%">Prog. Detail</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-md-12">\n' +
    '      <div class="add-pattern-container">\n' +
    '        <div class="add-pattern-wrapper" data-ng-repeat="training in trainingCtrl.model.trainings" data-ng-click="trainingCtrl.onClickTraining(training)" ng-class="{\'isSelected\':trainingCtrl.model.selectedTraining.trainingSlotId == training.trainingSlotId}">\n' +
    '\n' +
    '          <div class="pattern-div-header">\n' +
    '            <div class="headers" style="width: 20%">{{training.slotName}}</div>\n' +
    '            <div class="headers bold" style="width: 10%">{{training.startDateZulu}} {{training.startTimeZulu}}</div>\n' +
    '            <div class="headers bold" style="width: 10%">{{training.endDateZulu}} {{training.endTimeZulu}}</div>\n' +
    '            <div class="headers" style="width: 5%">{{training.trainingProCategory}}</div>\n' +
    '            <div class="headers" style="width: 15%">{{training.trainingLocCode}}</div>\n' +
    '            <div class="headers" style="width: 10%; text-align: center">{{training.assignedNoOfCrew}}</div>\n' +
    '            <div class="headers" style="width: 10%; text-align: center">{{training.requiredNoOfCrew}}</div>\n' +
    '            <div class="headers" style="width:10%; text-align: center">{{training.trainingProgramCode}}</div>\n' +
    '            <div class="headers" style="width: 10%; text-align: center">{{training.trainingProgramDetailCode}}</div>\n' +
    '            <div class="clearfix"></div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="row no-pairing" ng-show="trainingCtrl.model.trainings.length==0">\n' +
    '      No training available</div>\n' +
    '   <div class="loading-panel" ng-hide="!trainingCtrl.model.isLoadingVisible">\n' +
    '      <div class="animation-container">\n' +
    '        <div class="spinner">\n' +
    '          <div class="bounce1"></div>\n' +
    '          <div class="bounce2"></div>\n' +
    '          <div class="bounce3"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-footer add-pattern-footer grey-bg confirmation-footer ng-scope" ng-show="trainingCtrl.model.trainings.length">\n' +
    '\n' +
    '  <div>\n' +
    '    <div class="col-md-4">\n' +
    '      <div class="group">\n' +
    '        <select-component component-name="Training Programs" label-field-name="trainingProgramCode" menu-data-source="trainingCtrl.model.programs" selected-value="trainingCtrl.model.popover.trainingProgram" on-item-selected="trainingCtrl.onChangeProgram(selectedItem)" is-required="true"></select-component>\n' +
    '        <div ng-if="trainingCtrl.model.addTrainingClicked && (trainingCtrl.model.popover.trainingProgram == null || angular.isUndefined(trainingCtrl.model.popover.trainingProgram))" class="validation-error"> Training program is required.</div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-md-4">\n' +
    '      <div class="group">\n' +
    '        <select-component component-name="Program Detail" label-field-name="trainingProgDetailDesc" menu-data-source="trainingCtrl.model.programDetails" selected-value="trainingCtrl.model.popover.trainingProgramDetail" on-item-selected="trainingCtrl.onChangeProgramDetail(selectedItem)" is-required="true"></select-component>\n' +
    '        <div ng-if="trainingCtrl.model.addTrainingClicked && (trainingCtrl.model.popover.trainingProgramDetail == null || angular.isUndefined(trainingCtrl.model.popover.trainingProgramDetail))" class="validation-error">Program Detail is required.</div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="checkbox-right-align">\n' +
    '      <label>Hide in Crew Portal :</label> <input type="checkbox" id="isHideinCrewPortal" data-ng-model="trainingCtrl.model.isHideinCrewPortal"> <label for="isHideinCrewPortal" class="small-checkbox"></label>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '  <button class="btn btn-blue" type="button" ng-click="trainingCtrl.onAddTrainingClick()" ng-class="{\'disable\':!trainingCtrl.model.selectedTraining}" tabindex="0">Add\n' +
    '    Training</button>\n' +
    '</div>\n' +
    '');
	a.put('crewing_assign_pairing_regulation_details.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Block Regulations</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="$close()" aria-hidden="true"><i class="material-icons">clear</i></button>\n' +
    '</div>\n' +
    '<div class="modal-body regulation-view">\n' +
    '\n' +
    '\n' +
    '    <div class="row">\n' +
    '        <div class="col-md-12">\n' +
    '            <div class="table-section margin-bottom-0">\n' +
    '\n' +
    '\n' +
    '                <div>\n' +
    '                    <table class="header">\n' +
    '                        <thead>\n' +
    '                        <tr>\n' +
    '                            <th>Block Name</th>\n' +
    '                            <th>#</th>\n' +
    '                            <th>Regulation Name</th>\n' +
    '                            <th class="text-right">Accepted</th>\n' +
    '                            <th class="text-right">Day 1</th>\n' +
    '                            <th class="text-right">Day 2</th>\n' +
    '                            <th class="seeAll">&nbsp;</th>\n' +
    '                        </tr>\n' +
    '                        </thead>\n' +
    '                    </table>\n' +
    '\n' +
    '                    <!--Without Grouping-->\n' +
    '                    <div class="content-table" ng-hide="regulationCtrl.model.isRegulationMapWithGrouping">\n' +
    '                        <table class="table content" style="margin-top:0px">\n' +
    '                            <tbody>\n' +
    '                            <tr data-ng-repeat="block in regulationCtrl.model.regulations">\n' +
    '                                <td rowspan="1" ng-class="{\'red-text\': block.isViolated}">\n' +
    '                                    {{block.regulationBlockName}}<br><span ng-show="block.isViolated">Illegal Regulation Exist *</span>\n' +
    '                                </td>\n' +
    '                                <td style="padding-right:0px !important">\n' +
    '                                    <table class="table" style="margin-top:0px;width:100%">\n' +
    '                                        <tbody>\n' +
    '                                        <tr data-ng-repeat="regulation in block.regulations" ng-show="block.showAll || (!regulation.legalDay1)  ||  (!regulation.legalDay2)||  (regulation.warningDay1)||  (regulation.warningDay2)||  (regulation.limitationWarningDay1)||  (regulation.limitationWarningDay2)" ng-class="{\'red-text\': block.showAll && (!regulation.legalDay1 || !regulation.legalDay2), \'warning-text\': block.showAll && (regulation.legalDay1 && regulation.legalDay2) && (regulation.limitationWarningDay1 || regulation.limitationWarningDay2|| regulation.warningDay1 || regulation.warningDay2)}">\n' +
    '                                            <td>{{$index+1}}</td>\n' +
    '                                            <td>{{regulation.description || regulation.regulationCode}}</td>\n' +
    '                                            <td class="text-right">{{regulation.duration}}</td>\n' +
    '                                            <td class="text-right" ng-class="{\'isError\':!regulation.legalDay1, \'isWarning\':regulation.legalDay1 && (regulation.limitationWarningDay1 || regulation.warningDay1)}">\n' +
    '                                                {{regulation.day1Value}}\n' +
    '                                            </td>\n' +
    '                                            <td class="text-right" ng-class="{\'isError\':!regulation.legalDay2, \'isWarning\':regulation.legalDay2 && (regulation.limitationWarningDay2 || regulation.warningDay2)}">\n' +
    '                                                {{regulation.day2Value}}\n' +
    '                                            </td>\n' +
    '                                        </tr>\n' +
    '                                        </tbody>\n' +
    '                                    </table>\n' +
    '                                </td>\n' +
    '                                <td>\n' +
    '                                    <a data-ng-click="block.showAll = !block.showAll" class="show-hide-rows" href="">{{block.showAll\n' +
    '                                        ? \'Hide All\' : \'Show All\'}}<i class="material-icons">{{block.showAll ?\n' +
    '                                            \'keyboard_arrow_up\' : \'keyboard_arrow_down\'}}</i></a>\n' +
    '                                </td>\n' +
    '                            </tr>\n' +
    '                            </tbody>\n' +
    '                        </table>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!--WITH GROUPING-->\n' +
    '                    <div class="content-table" ng-show="regulationCtrl.model.isRegulationMapWithGrouping">\n' +
    '                        <div data-ng-repeat="group in regulationCtrl.model.regulations">\n' +
    '                            <div>{{group.groupFieldTwo}}</div>\n' +
    '                            <div>\n' +
    '                                <table class="table content" style="margin-top:0px">\n' +
    '                                    <tbody>\n' +
    '                                    <tr data-ng-repeat="block in group.adaptedRegulationMap">\n' +
    '                                        <td rowspan="1" ng-class="{\'red-text\': block.isViolated}">\n' +
    '                                            {{block.regulationBlockName}}<br><span ng-show="block.isViolated">Illegal Regulation Exist *</span>\n' +
    '                                        </td>\n' +
    '                                        <td style="padding-right:0px !important">\n' +
    '                                            <table class="table" style="margin-top:0px;width:100%">\n' +
    '                                                <tbody>\n' +
    '                                                <tr data-ng-repeat="regulation in block.regulations" ng-show="block.showAll || (!regulation.legalDay1)  ||  (!regulation.legalDay2)||  (regulation.warningDay1)||  (regulation.warningDay2)" ng-class="{\'red-text\': block.showAll && (!regulation.legalDay1 || !regulation.legalDay2), \'warning-text\': block.showAll && (regulation.warningDay1 || regulation.warningDay2)}">\n' +
    '                                                    <td>{{$index+1}}</td>\n' +
    '                                                    <td>{{regulation.description || regulation.regulationCode}}</td>\n' +
    '                                                    <td class="text-right">{{regulation.duration}}</td>\n' +
    '                                                    <td class="text-right" ng-class="{\'isError\':!regulation.legalDay1, \'isWarning\':!regulation.warningDay1}">\n' +
    '                                                        {{regulation.day1Value}}\n' +
    '                                                    </td>\n' +
    '                                                    <td class="text-right" ng-class="{\'isError\':!regulation.legalDay2, \'isWarning\':!regulation.warningDay2}">\n' +
    '                                                        {{regulation.day2Value}}\n' +
    '                                                    </td>\n' +
    '                                                </tr>\n' +
    '                                                </tbody>\n' +
    '                                            </table>\n' +
    '                                        </td>\n' +
    '                                        <td>\n' +
    '                                            <a data-ng-click="block.showAll = !block.showAll" class="show-hide-rows" href="">{{block.showAll\n' +
    '                                                ? \'Hide All\' : \'Show All\'}}<i class="material-icons">{{block.showAll\n' +
    '                                                    ?\n' +
    '                                                    \'keyboard_arrow_up\' : \'keyboard_arrow_down\'}}</i></a>\n' +
    '                                        </td>\n' +
    '                                    </tr>\n' +
    '                                    </tbody>\n' +
    '                                </table>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '</div>\n' +
    '<div class="modal-footer grey-bg text-align-left">\n' +
    '    <div class="row" ng-if="regulationCtrl.model.isRestrictedOperation">\n' +
    '        <div class="col-md-3" ng-if="!regulationCtrl.model.isRestrictedForAssigningIllegalDuties">\n' +
    '            <div class="group duty-change-reason-dropdown">\n' +
    '                <select-component component-name="Reason for Override" label-field-name="dropdownName" value-field-name="dropdownName" menu-data-source="regulationCtrl.model.dutyChangeReasons" selected-value="regulationCtrl.model.dutyChangeReason" is-required="isReasonRequired"></select-component>\n' +
    '\n' +
    '              <div ng-if="regulationCtrl.model.dutyChangeReasonValidation" role="alert">\n' +
    '                <div class="validation-error">Reason for Override is required.</div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-md-1" ng-if="!regulationCtrl.model.isRestrictedForAssigningIllegalDuties">\n' +
    '            <label class="control-label">Message</label>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-md-4" ng-if="!regulationCtrl.model.isRestrictedForAssigningIllegalDuties">\n' +
    '            <div class="form-group">\n' +
    '                <textarea class="form-control" data-ng-model="regulationCtrl.model.dutyChangeComment" rows="3"></textarea>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="col-md-3 text-right" ng-hide="regulationCtrl.model.hideFooterButtons">\n' +
    '            <div ng-if="!regulationCtrl.model.isRestrictedForAssigningIllegalDuties">\n' +
    '                <div class="confirmation-txt">Do you wish to continue?</div>\n' +
    '                <button class="btn btn-blue" type="button" ng-click="regulationCtrl.onConfirmClick()">Yes</button>\n' +
    '                <button class="btn btn-grey" type="button" data-ng-click="$close()">No</button>\n' +
    '            </div>\n' +
    '           <!-- <div ng-if="regulationCtrl.model.isRestrictedForAssigningIllegalDuties">\n' +
    '                <div class="red-text text-bold text-align-right">Your Role Level is insufficient for this override</div>\n' +
    '            </div>-->\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '   <div class="col-md-12" ng-if="regulationCtrl.model.isRestrictedForAssigningIllegalDuties" ng-hide="regulationCtrl.model.hideFooterButtons">\n' +
    '      <div class="red-text text-bold text-align-right">Your Role Level is insufficient for this override</div>\n' +
    '   </div>\n' +
    '\n' +
    '    <div class="row text-align-right" ng-if="!regulationCtrl.model.isRestrictedOperation" ng-hide="regulationCtrl.model.hideFooterButtons">\n' +
    '        <div class="col-md-12">\n' +
    '            <div class="confirmation-txt">Do you wish to continue?</div>\n' +
    '            <button class="btn btn-blue" type="submit" ng-click="regulationCtrl.onConfirmClick()">Yes</button>\n' +
    '            <button class="btn btn-grey" type="button" data-ng-click="$close()">No</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
	a.put('crewing_assign_pairing.tpl.html', '<div class="modal-header">\n' +
    '	<h4 class="modal-title">Add Pairing</h4>\n' +
    '	<button type="button" class="close" data-dismiss="modal" data-ng-click="assignCtrl.closeMe()" aria-hidden="true">\n' +
    '		<i class="material-icons">clear</i>\n' +
    '	</button>\n' +
    '</div>\n' +
    '<div class="modal-body add-pattern">\n' +
    '	<div class="row" ng-show="assignCtrl.model.patternData.length">\n' +
    '\n' +
    '		<div class="col-md-12 header-container">\n' +
    '			<div class="add-pattern-wrapper">\n' +
    '				<div class="pattern-div-header">\n' +
    '					<div class="headers bold search" style="width: 20%">\n' +
    '						<div class="group">\n' +
    '							<input type="text" data-ng-model="assignCtrl.model.searchByName">\n' +
    '							<span class="bar"></span> <label>Search by Name</label>\n' +
    '						</div>\n' +
    '					</div>\n' +
    '\n' +
    '					<div class="headers search" style="width: 10%">\n' +
    '						<div class="group">\n' +
    '							<select ng-options="type.name for type in assignCtrl.model.patternTypes" ng-model="assignCtrl.model.searchByPatternType">\n' +
    '								<option value="">Pattern Type</option>\n' +
    '							</select>\n' +
    '						</div>\n' +
    '					</div>\n' +
    '\n' +
    '					<div class="headers bold search" style="width: 10%">\n' +
    '						<div class="group">\n' +
    '							<input type="text" data-ng-model="assignCtrl.model.searchByAircraft"> <span class="bar"></span> <label>AC Model</label>\n' +
    '						</div>\n' +
    '					</div>\n' +
    '					<div class="headers bold search" style="width: 10%">\n' +
    '						<div class="group">\n' +
    '							<input type="text" data-ng-model="assignCtrl.model.searchByStartDate"> <span class="bar"></span> <label>Start Time</label>\n' +
    '						</div>\n' +
    '					</div>\n' +
    '					<div class="headers bold search" style="width: 10%">\n' +
    '						<div class="group">\n' +
    '							<input type="text" data-ng-model="assignCtrl.model.searchByEndDate"> <span class="bar"></span> <label>End Date</label>\n' +
    '						</div>\n' +
    '					</div>\n' +
    '					<div class="headers bold search" style="width: 8%">\n' +
    '						<div class="group">\n' +
    '							<input type="text" data-ng-model="assignCtrl.model.searchByCrewAssigned"> <span class="bar"></span> <label>Assigned</label>\n' +
    '						</div>\n' +
    '					</div>\n' +
    '					<div class="headers bold search" style="width: 8%">\n' +
    '						<div class="group">\n' +
    '							<input type="text" data-ng-model="assignCtrl.model.searchByCrewRequired"> <span class="bar"></span> <label>Required</label>\n' +
    '						</div>\n' +
    '					</div>\n' +
    '					<div class="headers bold search" style="width: 9%">\n' +
    '						<div class="group">\n' +
    '							<input type="text" data-ng-model="assignCtrl.model.searchByDurationType"> <span class="bar"></span> <label>Duration Type</label>\n' +
    '						</div>\n' +
    '					</div>\n' +
    '					<div class="headers bold search" style="width: 9%">\n' +
    '						<div class="group">\n' +
    '							<input type="text" data-ng-model="assignCtrl.model.searchByAcmiCode"> <span class="bar"></span> <label>ACMI Code</label>\n' +
    '						</div>\n' +
    '					</div>\n' +
    '					<div class="headers search" style="width: 6%">\n' +
    '						<div class="group">\n' +
    '							<select ng-options="pairingBase for pairingBase in assignCtrl.model.pairingBases" ng-model="assignCtrl.model.searchByPairingBase">\n' +
    '								<option value="">ALL</option>\n' +
    '							</select>\n' +
    '						</div>\n' +
    '					</div>\n' +
    '					<div class="headers text-right bold search" style="width: 5%">&nbsp;</div>\n' +
    '					<div class="clearfix"></div>\n' +
    '				</div>\n' +
    '\n' +
    '				<div class="pattern-div-header">\n' +
    '					<div class="headers bold" style="width: 25%">Name</div>\n' +
    '					<div class="headers bold" style="width: 5%">&nbsp;&nbsp;&nbsp;&nbsp;</div>\n' +
    '					<div class="headers bold" style="width: 10%">Aircraft</div>\n' +
    '					<div class="headers bold" style="width: 15%">Start Date Time\n' +
    '						(Local)</div>\n' +
    '					<div class="headers bold" style="width: 15%">End Date Time\n' +
    '						(Local)</div>\n' +
    '					<div class="headers bold" style="width: 5%">Assigned</div>\n' +
    '					<div class="headers bold" style="width: 5%">Req</div>\n' +
    '					<div class="headers bold" style="width: 9%">Duration Type</div>\n' +
    '					<div class="headers bold" style="width: 6%">ACMI Type</div>\n' +
    '					<div class="headers text-right bold" style="width: 5%">&nbsp;</div>\n' +
    '					<div class="clearfix"></div>\n' +
    '				</div>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '\n' +
    '		<div class="col-md-12">\n' +
    '			<div class="add-pattern-container">\n' +
    '				<div class="add-pattern-wrapper" data-ng-repeat="pattern in assignCtrl.model.patternData |\n' +
    '                     filter:{patternName: assignCtrl.model.searchByName,\n' +
    '                             patternType :assignCtrl.model.searchByPatternType.name.toUpperCase(),\n' +
    '                             aircraftModelNum1:assignCtrl.model.searchByAircraft,\n' +
    '                             startTime : assignCtrl.model.searchByStartDate,\n' +
    '                             endDate :assignCtrl.model.searchByEndDate,\n' +
    '                             assignedCrew :assignCtrl.model.searchByCrewAssigned,\n' +
    '                             requiredCrew :assignCtrl.model.searchByCrewRequired,\n' +
    '                             durationTypeDesc : assignCtrl.model.searchByDurationType,\n' +
    '                             acmiCode : assignCtrl.model.searchByAcmiCode,\n' +
    '                             pairingBase : ((assignCtrl.model.searchByPairingBase == \'\' ) ? pattern.pairingBase : assignCtrl.model.searchByPairingBase)\n' +
    '                             }" ng-class="{\'isSelected\':assignCtrl.model.selectedPattern.patternId == pattern.patternId}">\n' +
    '\n' +
    '					<div class="pattern-div-header" data-ng-click="assignCtrl.onSelectPairing(pattern)" ng-class="{\n' +
    '                                \'red-header\':pattern.isModified == \'Y\',\n' +
    '                                \'is-training\' : pattern.trainingProgramId != null }">\n' +
    '						<div class="headers" style="width: 25%">\n' +
    '\n' +
    '							<div class="length-ellipsis">{{pattern.patternName}}</div>\n' +
    '\n' +
    '						</div>\n' +
    '						<div class="headers bold" style="width: 5%">\n' +
    '							<span class="away-pairing" ng-show="pattern.landsAwayFromBase">Away</span>\n' +
    '							<span class="open-pairing" ng-show="(pattern.requiredCrew > 0) && (pattern.assignedCrew < pattern.requiredCrew)">Open</span>\n' +
    '							<span class="" ng-hide="(pattern.requiredCrew > 0) && (pattern.assignedCrew < pattern.requiredCrew)">&nbsp;&nbsp;&nbsp;&nbsp;</span>\n' +
    '						</div>\n' +
    '						<div class="headers bold" style="width: 10%">{{pattern.aircraftModelNum1}}\n' +
    '							{{pattern.aircraftModelNum2}}&nbsp;</div>\n' +
    '						<div class="headers" style="width: 15%">{{pattern.startDate}}\n' +
    '							{{pattern.startTime}}</div>\n' +
    '						<div class="headers" style="width: 15%">{{pattern.endDate}}\n' +
    '							{{pattern.endTime}}</div>\n' +
    '						<div class="headers" style="width: 5%">{{pattern.assignedCrew}}</div>\n' +
    '						<div class="headers" style="width: 5%">{{pattern.requiredCrew}}</div>\n' +
    '						<div class="headers" style="width: 9%">{{pattern.durationTypeDesc}}</div>\n' +
    '						<div class="headers" style="width: 6%">{{pattern.acmiCode}}</div>\n' +
    '						<div class="headers text-right" style="width: 5%">\n' +
    '							<a href="" data-ng-click="assignCtrl.onPairingOpen(pattern)"><i class="material-icons">{{pattern.isOpen ? \'arrow_drop_up\' :\n' +
    '									\'arrow_drop_down\'}}</i></a>\n' +
    '						</div>\n' +
    '						<div class="clearfix"></div>\n' +
    '					</div>\n' +
    '					<div class="pattern-div-body" ng-class="{\'open-pattern\':pattern.isOpen}">\n' +
    '						<div class="pattern-box-outer" data-ng-repeat="block in pattern.moreDetail.blockList">\n' +
    '							<div class="pattern-box-inner" data-ng-repeat="detail in block.blockDetailList" ng-class="detail.type">\n' +
    '								<div class="pattern-box-header" ng-hide="detail.isRest">\n' +
    '									<i class="material-icons">{{detail.iconClass}}</i>{{detail.header}}\n' +
    '								</div>\n' +
    '								<div class="pattern-box-content" ng-hide="detail.isRest">\n' +
    '									<div class="start-loc location">\n' +
    '										{{detail.leftLblOne}}<span>{{detail.leftLblTwo}}</span>\n' +
    '									</div>\n' +
    '									<div class="arrow-line"></div>\n' +
    '									<div class="arrow-right"></div>\n' +
    '									<div class="end-loc location">\n' +
    '										{{detail.rightLblOne}}<span>{{detail.rightLblTwo}}</span>\n' +
    '									</div>\n' +
    '								</div>\n' +
    '								<div class="clearfix"></div>\n' +
    '							</div>\n' +
    '\n' +
    '							<div class="clearfix"></div>\n' +
    '						</div>\n' +
    '						<div class="clearfix"></div>\n' +
    '					</div>\n' +
    '\n' +
    '				</div>\n' +
    '				<div class="clearfix"></div>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '	</div>\n' +
    '	<div class="row no-pairing" ng-show="assignCtrl.model.showNoRecord">\n' +
    '		No pairings available</div>\n' +
    '	<div class="loading-panel" ng-hide="assignCtrl.model.showNoRecord || assignCtrl.model.patternData.length > 0">\n' +
    '		<div class="animation-container">\n' +
    '			<div class="spinner">\n' +
    '				<div class="bounce1"></div>\n' +
    '				<div class="bounce2"></div>\n' +
    '				<div class="bounce3"></div>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '	</div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-footer add-pattern-footer grey-bg confirmation-footer ng-scope" ng-show="assignCtrl.model.patternData.length">\n' +
    '	<div style="float: left">\n' +
    '		<span class="away-pairing">Away</span> : Checkout away from crew base\n' +
    '	</div>\n' +
    '	<div class="confirmation-txt">\n' +
    '		<div class="checkbox-right-align">\n' +
    '			<label>Request :</label> <input type="checkbox" id="isRequest" data-ng-model="assignCtrl.model.isRequest"> <label for="isRequest" class="small-checkbox"></label>\n' +
    '		</div>\n' +
    '\n' +
    '		<div class="checkbox-right-align">\n' +
    '			<label>Called from Day Off :</label> <input type="checkbox" id="isCallFromDayOff" data-ng-model="assignCtrl.model.isCallFromDayOff"> <label for="isCallFromDayOff" class="small-checkbox"></label>\n' +
    '		</div>\n' +
    '\n' +
    '		<div class="checkbox-right-align">\n' +
    '			<label>OBS Flight :</label> <input type="checkbox" id="isObsFlight" data-ng-model="assignCtrl.model.isObsFlight"> <label for="isObsFlight" class="small-checkbox"></label>\n' +
    '		</div>\n' +
    '\n' +
    '		<div class="checkbox-right-align">\n' +
    '			<label>Hide in Crew Portal :</label> <input type="checkbox" id="isHideinCrewPortal" data-ng-model="assignCtrl.model.isHideinCrewPortal"> <label for="isHideinCrewPortal" class="small-checkbox"></label>\n' +
    '		</div>\n' +
    '\n' +
    '	</div>\n' +
    '	<button class="btn btn-blue" type="button" ng-click="assignCtrl.onAssignPairingClick()" ng-class="{\'disable\':!assignCtrl.model.selectedPattern}" tabindex="0">Add\n' +
    '		Pairing</button>\n' +
    '</div>\n' +
    '<div>{{params.date}}</div>');
	a.put('crewing_assign_event.tpl.html', '<div class="modal-header">\n' +
    '    <div class="">\n' +
    '        <div class="col-md-3 padding-left-0">\n' +
    '            <h4 class="modal-title">{{eventCtrl.model.type}}</h4> <span class="date">{{eventCtrl.model.day.date}}</span>\n' +
    '        </div>\n' +
    '        <button type="button" class="close" data-dismiss="modal" data-ng-click="eventCtrl.onCloseClick()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '        </button>\n' +
    '    </div>\n' +
    '</div>\n' +
    '<div class="modal-body assign-event-modal-body">\n' +
    '    <div class="row">\n' +
    '        <div class="col-md-4">\n' +
    '\n' +
    '            <uib-tabset active="eventCtrl.model.activeTab">\n' +
    '                <uib-tab index="0" heading="Duty">\n' +
    '                    <div class="row event-right-list">\n' +
    '                        <div class="col-md-6 height-30" data-ng-repeat="event in eventCtrl.model.eventTypes[\'DUTY\'] track by event.event_id" data-ng-click="eventCtrl.onEventTypeClick(event)">\n' +
    '                            <a href="" class="event-link" ng-class="{\'active-list-item\':eventCtrl.model.formVal.event.event_id == event.event_id}">{{::event.eventDescription}}\n' +
    '                                <i class="material-icons" ng-if="eventCtrl.model.formVal.event.event_id == event.event_id">check_circle</i></a>\n' +
    '                        </div>\n' +
    '                        <div class="clearfix"></div>\n' +
    '                    </div>\n' +
    '\n' +
    '                </uib-tab>\n' +
    '                <uib-tab index="1" heading="Leave">\n' +
    '                    <div class="row event-right-list">\n' +
    '                        <div class="col-md-6 height-30" data-ng-repeat="event in ::eventCtrl.model.eventTypes[\'LEAVE\'] track by event.event_id" data-ng-click="eventCtrl.onEventTypeClick(event)">\n' +
    '                            <a href="" class="event-link" ng-class="{\'active-list-item\':eventCtrl.model.formVal.event.event_id == event.event_id}">{{::event.eventDescription}}\n' +
    '                                <i class="material-icons" ng-if="eventCtrl.model.formVal.event.event_id == event.event_id">check_circle</i></a>\n' +
    '                        </div>\n' +
    '                        <div class="clearfix"></div>\n' +
    '                    </div>\n' +
    '                </uib-tab>\n' +
    '               <uib-tab index="2" heading="Rest">\n' +
    '                   <div class="row event-right-list">\n' +
    '                       <div class="col-md-6 height-30" data-ng-repeat="event in ::eventCtrl.model.eventTypes[\'REST\'] track by event.event_id" data-ng-click="eventCtrl.onEventTypeClick(event)">\n' +
    '                           <a href="" class="event-link" ng-class="{\'active-list-item\':eventCtrl.model.formVal.event.event_id == event.event_id}">{{::event.eventDescription}}\n' +
    '                               <i class="material-icons" ng-if="eventCtrl.model.formVal.event.event_id == event.event_id">check_circle</i></a>\n' +
    '                       </div>\n' +
    '                       <div class="clearfix"></div>\n' +
    '                   </div>\n' +
    '               </uib-tab>\n' +
    '            </uib-tabset>\n' +
    '\n' +
    '        </div>\n' +
    '        <div class="col-md-8">\n' +
    '\n' +
    '            <div class="row">\n' +
    '                <div class="col-md-3 col-md-6">\n' +
    '\n' +
    '                    <div class="group">\n' +
    '                        <div ng-style="eventCtrl.model.formVal.startDate.isDisable ? {\'pointer-events\':\'none\'} : {\'pointer-events\':\'auto\'}">\n' +
    '                            <input type="text" set-auto-date="" jq-date-picker-options="" ng-model="eventCtrl.model.formVal.startDate.value" ng-change="eventCtrl.onStartDateChange()" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.startDate.isDisable">\n' +
    '                            <span class="bar"></span>\n' +
    '                            <label>Start Date<span class="required-star">*</span></label>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-2 col-md-6">\n' +
    '\n' +
    '\n' +
    '                    <div class="group label-with-placeholder">\n' +
    '                        <input type="text" ui-mask="29:69" ui-mask-placeholder="HH:MM" ui-mask-placeholder-char=" " model-view-value="true" ng-model="eventCtrl.model.formVal.startTime.value" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.startTime.isDisable" ng-change="eventCtrl.onStartTimeChange()">\n' +
    '                        <span class="bar"></span>\n' +
    '\n' +
    '                        <label style="margin-top: -8px">Start Time(UTC)<span class="required-star">*</span></label>\n' +
    '                        <i class="material-icons">access_time</i>\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-3 col-md-6">\n' +
    '\n' +
    '                    <div class="group">\n' +
    '\n' +
    '                        <div>\n' +
    '\n' +
    '                            <input type="text" set-auto-date="" jq-date-picker-options="" ng-model="eventCtrl.model.formVal.endDate.value" ng-change="eventCtrl.onEndDateChange()" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.endDate.isDisable">\n' +
    '                            <span class="bar"></span>\n' +
    '                            <label>End Date<span class="required-star">*</span></label>\n' +
    '\n' +
    '                        </div>\n' +
    '\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-2 col-md-6">\n' +
    '\n' +
    '\n' +
    '                    <div class="group label-with-placeholder">\n' +
    '                        <input type="text" ui-mask="29:69" ui-mask-placeholder="HH:MM" ui-mask-placeholder-char=" " model-view-value="true" data-ng-model="eventCtrl.model.formVal.endTime.value" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.endTime.isDisable" ng-change="eventCtrl.onEndTimeChange()">\n' +
    '\n' +
    '                        <span class="bar"></span>\n' +
    '\n' +
    '                        <label style="margin-top: -8px">End Time(UTC)<span class="required-star">*</span></label>\n' +
    '                        <i class="material-icons">access_time</i>\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-2 col-md-12">\n' +
    '\n' +
    '\n' +
    '                    <div class="group">\n' +
    '                        <input type="text" data-ng-model="eventCtrl.model.formVal.dutyPeriod.value" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.dutyPeriod.isDisable">\n' +
    '                        <span class="bar"></span>\n' +
    '\n' +
    '                        <label style="margin-top: -8px">Duty Hours</label>\n' +
    '                        <i class="material-icons">access_time</i>\n' +
    '\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '            </div>\n' +
    '\n' +
    '\n' +
    '            <div class="row margin-bottom-30">\n' +
    '\n' +
    '                <div class="col-md-3 col-md-6">\n' +
    '\n' +
    '                    <!--<select-component\n' +
    '                            component-name="Start Location"\n' +
    '                            label-field-name="airPortCode"\n' +
    '                            value-field-name="airPortCode"\n' +
    '                            menu-data-source="eventCtrl.model.airportList"\n' +
    '                            is-disable="eventCtrl.model.formVal.startLocation.isDisable"\n' +
    '                            selected-value="eventCtrl.model.formVal.startLocation.value"></select-component>-->\n' +
    '                    <div class="group">\n' +
    '                        <div>\n' +
    '                            <input type="text" id="StartLocation" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.startLocation.isDisable" component-name="Start Location" name="StartLocation" ng-model="eventCtrl.model.formVal.startLocation.value" typeahead="" uib-typeahead="airport as airport.airPortCode for airport in eventCtrl.model.airportList | filter:$viewValue" autocomplete="off" auto-close="enabled">\n' +
    '                            <label>Start Location <span ng-if="eventCtrl.model.formVal.isStartLocationRequred" class="required-star">*</span></label>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-3 col-md-6">\n' +
    '\n' +
    '                    <!--<select-component\n' +
    '                            component-name="End Location"\n' +
    '                            label-field-name="airPortCode"\n' +
    '                            value-field-name="airPortCode"\n' +
    '                            menu-data-source="eventCtrl.model.airportList"\n' +
    '                            is-disable="eventCtrl.model.formVal.endLocation.isDisable"\n' +
    '                            selected-value="eventCtrl.model.formVal.endLocation.value"></select-component>-->\n' +
    '                    <div class="group">\n' +
    '                        <div>\n' +
    '                            <input type="text" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.endLocation.isDisable" component-name="End Location" name="EndLocation" ng-model="eventCtrl.model.formVal.endLocation.value" typeahead="" uib-typeahead="airport as airport.airPortCode for airport in eventCtrl.model.airportList | filter:$viewValue" autocomplete="off">\n' +
    '                            <label>End Location <span ng-if="eventCtrl.model.formVal.isEndLocationRequred" class="required-star">*</span></label>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-3 col-md-6">\n' +
    '\n' +
    '                    <!--<select-component\n' +
    '                            component-name="Event Occurring Flight"\n' +
    '                            label-field-name="eventName"\n' +
    '                            value-field-name="eventId"\n' +
    '                            menu-data-source="eventCtrl.model.flightOccurringEvents"\n' +
    '                            is-disable="eventCtrl.model.formVal.eventOccurringFlight.isDisable"\n' +
    '                            selected-value="eventCtrl.model.formVal.eventOccurringFlight.value"></select-component>-->\n' +
    '                    <div class="group">\n' +
    '                        <div class="small-typeahead">\n' +
    '                            <input type="text" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.eventOccurringFlight.isDisable" component-name="Event Occurring Flight" name="EventOccurringFlight" ng-model="eventCtrl.model.formVal.eventOccurringFlight.value" typeahead="" uib-typeahead="event as event.eventName for event in eventCtrl.model.flightOccurringEvents | filter:$viewValue" autocomplete="off">\n' +
    '                            <label>Event Occurring Flight</label>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-3 col-md-6">\n' +
    '\n' +
    '                   <!-- <select-component\n' +
    '                            component-name="Aircraft Type"\n' +
    '                            label-field-name="modelNumber"\n' +
    '                            value-field-name="modelNumber"\n' +
    '                            menu-data-source="eventCtrl.model.aircraftType"\n' +
    '                            is-disable="eventCtrl.model.formVal.aircraftType.isDisable"\n' +
    '                            selected-value="eventCtrl.model.formVal.aircraftType.value"></select-component>-->\n' +
    '                    <div class="group">\n' +
    '                        <div>\n' +
    '                            <input type="text" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.aircraftType.isDisable" component-name="Aircraft Type" name="AircraftType" ng-model="eventCtrl.model.formVal.aircraftType.value" typeahead="" uib-typeahead="aircraft as aircraft.modelNumber for aircraft in eventCtrl.model.aircraftType | filter:$viewValue" autocomplete="off">\n' +
    '                            <label>Aircraft Type</label>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '\n' +
    '            </div>\n' +
    '\n' +
    '\n' +
    '            <div class="row margin-bottom-20">\n' +
    '\n' +
    '\n' +
    '                <div class="col-md-3 padding-right-0">\n' +
    '\n' +
    '                    <div class="checkbox-left-align">\n' +
    '\n' +
    '                        <input type="checkbox" id="isExcludeFromPayment" data-ng-model="eventCtrl.model.formVal.isExcludeFromPayment.value" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.isExcludeFromPayment.isDisable">\n' +
    '                        <label for="isExcludeFromPayment" class="small-checkbox"></label>\n' +
    '                        <label>Exclude From Payment</label>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-3">\n' +
    '\n' +
    '                    <div class="checkbox-left-align">\n' +
    '\n' +
    '                        <input type="checkbox" id="isAirportStandby" data-ng-model="eventCtrl.model.formVal.isAirportStandby.value" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.isAirportStandby.isDisable">\n' +
    '                        <label for="isAirportStandby" class="small-checkbox"></label>\n' +
    '                        <label>Airport Standby</label>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-2">\n' +
    '\n' +
    '                    <div class="checkbox-left-align">\n' +
    '\n' +
    '                        <input type="checkbox" id="isRequest" data-ng-model="eventCtrl.model.formVal.isRequest.value" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.isRequest.isDisable">\n' +
    '                        <label for="isRequest" class="small-checkbox"></label>\n' +
    '                        <label>Request</label>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-2">\n' +
    '\n' +
    '                    <div class="checkbox-left-align">\n' +
    '\n' +
    '                        <input type="checkbox" id="isCallFromDayOff" data-ng-model="eventCtrl.model.formVal.isCallFromDayOff.value" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.isCallFromDayOff.isDisable">\n' +
    '                        <label for="isCallFromDayOff" class="small-checkbox"></label>\n' +
    '                        <label>Call from Day off</label>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-2">\n' +
    '\n' +
    '                    <div class="checkbox-left-align">\n' +
    '\n' +
    '                        <input type="checkbox" id="isOutStationOff" data-ng-model="eventCtrl.model.formVal.isOutStationOff.value" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.isOutStationOff.isDisable">\n' +
    '                        <label for="isOutStationOff" class="small-checkbox"></label>\n' +
    '                        <label>Out Station OFF</label>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row margin-bottom-20">\n' +
    '                <div class="col-md-4">\n' +
    '                    <div class="checkbox-left-align">\n' +
    '                        <input type="checkbox" id="isHideinCrewPortal" ng-disabled="!$ctrl.model.status" data-ng-model="eventCtrl.model.formVal.isHideinCrewPortal.value">\n' +
    '                        <label for="isHideinCrewPortal" class="small-checkbox"></label>\n' +
    '                        <label>Hide in Crew Portal</label>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '\n' +
    '              <div class="col-md-">\n' +
    '\n' +
    '                <div class="checkbox-left-align">\n' +
    '\n' +
    '                  <input type="checkbox" id="isOffC" data-ng-model="eventCtrl.model.formVal.isOffC.value" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.isOffC.isDisable">\n' +
    '                  <label for="isOffC" class="small-checkbox"></label>\n' +
    '                  <label>OFF-C</label>\n' +
    '                </div>\n' +
    '\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="col-md-">\n' +
    '\n' +
    '                <div class="checkbox-left-align">\n' +
    '\n' +
    '                  <input type="checkbox" id="isMoff" data-ng-model="eventCtrl.model.formVal.isMoff.value" ng-disabled="!eventCtrl.model.status || eventCtrl.model.formVal.isMoff.isDisable">\n' +
    '                  <label for="isMoff" class="small-checkbox"></label>\n' +
    '                  <label>M-OFF</label>\n' +
    '                </div>\n' +
    '\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="row margin-top-20">\n' +
    '                 <div class="col-md-9">\n' +
    '\n' +
    '                   <!--  <div class="group">\n' +
    '                        <textarea\n' +
    '                                ng-model="eventCtrl.model.formVal.remark.value"\n' +
    '                                ng-disabled="eventCtrl.model.formVal.remark.isDisable"></textarea>\n' +
    '                        <span class="bar"></span>\n' +
    '                        <label>Add Remarks</label>\n' +
    '\n' +
    '                    </div> -->\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="col-md-3">\n' +
    '\n' +
    '                    <div class="pull-right margin-top-70">\n' +
    '                        <button ng-class="[{\'btn-continue\':eventCtrl.model.status},{\'btn\':true},{\'btn-disabled\':!eventCtrl.model.status}]" data-ng-click="eventCtrl.onAddEventClick()">\n' +
    '                            {{eventCtrl.model.formVal.isEditMode ? \'Update Event\' : \'Add Event\'}}\n' +
    '                        </button>\n' +
    '                        <div class="clearfix"></div>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '</div>');
	a.put('crewFilter.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Filter Crew</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" data-ng-click="crewFilter.onClose()"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '    <div class="sel-date">{{crewFilter.model.selectedValues.day}}</div>\n' +
    '</div>\n' +
    '<div class="modal-body crew-filter">\n' +
    '    <div class="row">\n' +
    '        <div class="col-md-3">\n' +
    '            <label class="label-top-0 margin-bottom-20"><b>Select Flights</b></label>\n' +
    '          <div class="btn-group select-dropdown" uib-dropdown="">\n' +
    '            <select-component component-name="Flight" label-field-name="flightNumber" menu-data-source="crewFilter.model.flights" value-field-name="flightNumber" selected-value="crewFilter.model.selectedValues.flights" multi-select="typeahead" multi-select-sort-by="flightId"></select-component>\n' +
    '            <span class="bar"></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-3">\n' +
    '            <label class="label-top-0 margin-bottom-20"><b>Leaves</b></label>\n' +
    '          <div class="btn-group select-dropdown" uib-dropdown="">\n' +
    '            <select-component component-name="Leave" label-field-name="eventDescription" menu-data-source="crewFilter.model.leaves" value-field-name="eventDescription" selected-value="crewFilter.model.selectedValues.leaves" multi-select="typeahead"></select-component>\n' +
    '            <span class="bar"></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-3">\n' +
    '            <label class="label-top-0 margin-bottom-20"><b>Destinations</b></label>\n' +
    '          <div class="btn-group select-dropdown" uib-dropdown="">\n' +
    '            <select-component component-name="Destination" label-field-name="airPortCode" menu-data-source="crewFilter.model.airports" value-field-name="airPortCode" selected-value="crewFilter.model.selectedValues.airports" multi-select="typeahead"></select-component>\n' +
    '            <span class="bar"></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-3">\n' +
    '            <label class="label-top-0 margin-bottom-20"><b>Events</b></label>\n' +
    '            <advance-select-component input-mode="typehead" is-add-all-option-available="true" is-all-all-selected="crewFilter.model.isAllEventsSelected" selected-values="crewFilter.model.selectedValues.events" selected-value-display-field="eventDescription" date-source="crewFilter.model.events" input-field-label="Event"></advance-select-component>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="clearfix"></div>\n' +
    '        <div class="col-md-12">\n' +
    '            <button class="btn save-btn pull-right" data-ng-click="crewFilter.onFilterClick()">Filter</button>\n' +
    '            <div class="clearfix"></div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '</div>');
	a.put('credit-hours-popup.tpl.html', '<div class="modal-header">\n' +
    '  <h4 class="modal-title">Credit Hours</h4>\n' +
    '  <button type="button" class="close" data-dismiss="modal" data-ng-click="creditHours.onCloseClick()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '  </button>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-body margin-bottom-50 show-expiry" style="-webkit-user-select: text;\n' +
    '    -khtml-user-select: text;\n' +
    '    -moz-user-select: text;\n' +
    '    -o-user-select: text;\n' +
    '    user-select: text">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-12 header-container">\n' +
    '      <div class="add-pattern-wrapper">\n' +
    '        <div class="pattern-div-header">\n' +
    '          <div class="headers bold" style="width:25%;text-align: center">Segment</div>\n' +
    '          <div class="headers bold" style="width:15%;text-align: center">Credit</div>\n' +
    '          <div class="headers bold" style="width:15%;text-align: center">Divertion</div>\n' +
    '          <div class="headers bold" style="width:15%;text-align: center">Is Night?</div>\n' +
    '          <div class="headers bold" style="width:15%;text-align: center">Total HH.HH</div>\n' +
    '          <div class="headers bold" style="width:15%;text-align: center">Acc Total</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-md-12">\n' +
    '      <div class="add-pattern-wrapper" data-ng-repeat="cr in creditHours.model.creditHours track by $index">\n' +
    '        <div class="pattern-div-header row-content">\n' +
    '          <div class="headers" style="width:25%;text-align: center">{{cr.segment}}&nbsp;</div>\n' +
    '          <div class="headers" style="width:15%;text-align: center">{{cr.credit}}&nbsp;</div>\n' +
    '          <div class="headers" style="width:15%;text-align: center">{{cr.divertion}}&nbsp;</div>\n' +
    '          <div class="headers" style="width:15%;text-align: center">{{cr.isNight}}&nbsp;<span ng-if="cr.isPartialNight">*</span></div>\n' +
    '          <div class="headers" style="width:15%;text-align: center">{{cr.totalCreditHours}}&nbsp;</div>\n' +
    '          <div class="headers" style="width:15%;text-align: center">{{cr.accTotal}}&nbsp;</div>\n' +
    '          <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="clearfix"></div>\n' +
    '      <span style="font-size: 12px" ng-if="creditHours.model.creditHours.length>0">* represent partially night flights</span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '<!--<script>\n' +
    '  $(\'.modal-dialog\').draggable();\n' +
    '</script>-->');
	a.put('conflicts-trainings.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Conflicts records exists</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="conflictsTrainings.closeMe()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '<div class="modal-body add-pattern">\n' +
    '    <div class="row margin-bottom-10">\n' +
    '        <div class="col-md-12">\n' +
    '            <div class="table-section margin-bottom-0">\n' +
    '                <table class="header">\n' +
    '                    <thead>\n' +
    '                        <tr>\n' +
    '                            <th>Start Date/Time (Local)</th>\n' +
    '                            <th>End Date/Time (Local)</th>\n' +
    '                            <th>Slot Name</th>\n' +
    '                        </tr>\n' +
    '                    </thead>\n' +
    '                </table>\n' +
    '                <div class="content-table">\n' +
    '                    <table class="table content">\n' +
    '                        <tbody>\n' +
    '                            <tr ng-repeat="training in conflictsTrainings.model.conflictsTrainings track by $index">\n' +
    '                                <td>{{training.startDateTime}}</td>\n' +
    '                                <td>{{training.endDateTime}}</td>\n' +
    '                                <td>{{training.trainingDesc}}</td>\n' +
    '                            </tr>\n' +
    '                        </tbody>\n' +
    '                    </table>\n' +
    '                </div>\n' +
    '\n' +
    '                <div class="content-table">\n' +
    '                    <table class="table content">\n' +
    '                        <tbody>\n' +
    '                        <tr>\n' +
    '                            <td>Confirm conflicts records?\n' +
    '                                <button class="btn btn-continue" data-ng-click="conflictsTrainings.clickYes()">Yes</button>&nbsp;\n' +
    '                                <button class="btn btn-continue" data-ng-click="conflictsTrainings.closeMe()">No</button></td>\n' +
    '                        </tr>\n' +
    '                        </tbody>\n' +
    '                    </table>\n' +
    '\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
	a.put('confirm_overlap.tpl.html', '<div class="modal-header">\n' +
    '  <h4 class="modal-title">{{confirmCtrl.model.title}}</h4>\n' +
    '  <button type="button" data-ng-click="confirmCtrl.onCloseClick()" class="close" data-dismiss="modal" aria-hidden="true"><i class="material-icons">clear</i></button>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '\n' +
    '  <p class="bold font-16" data-ng-repeat="msg in confirmCtrl.model.msgCol">{{msg}}</p>\n' +
    '\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '  <button class="btn btn-blue" type="button" ng-click="confirmCtrl.onYesClick()">Swap Duty</button>\n' +
    '  <button class="btn btn-grey" type="button" ng-click="confirmCtrl.onNoClick()">Continue</button>\n' +
    '</div>');
	a.put('confirm_dialog.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">{{confirmCtrl.model.title}}</h4>\n' +
    '    <button type="button" data-ng-click="confirmCtrl.onCloseClick()" class="close" data-dismiss="modal" aria-hidden="true"><i class="material-icons">clear</i></button>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '\n' +
    '    <p class="bold font-16" data-ng-repeat="msg in confirmCtrl.model.msgCol">{{msg}}</p>\n' +
    '\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '    <button class="btn btn-blue" type="button" ng-click="confirmCtrl.onYesClick()">Yes</button>\n' +
    '    <button class="btn btn-grey" type="button" ng-click="confirmCtrl.onNoClick()">No</button>\n' +
    '</div>');
	a.put('confirm-show-in-portal.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">{{showInCrewPortal.model.title}}</h4>\n' +
    '    <button type="button" data-ng-click="showInCrewPortal.onCloseClick()" class="close" data-dismiss="modal" aria-hidden="true"><i class="material-icons">clear</i></button>\n' +
    '</div>\n' +
    '<div class="modal-body">\n' +
    '    <p class="bold font-16" data-ng-repeat="msg in showInCrewPortal.model.msgCol">{{msg}}</p>\n' +
    '    <div class="checkbox-right-align" data-ng-if="showInCrewPortal.model.allCrew!=\'DONT_SHOW\'">\n' +
    '        <label>Only for Selected Crew Members</label>\n' +
    '        <input type="checkbox" id="test22" data-ng-model="showInCrewPortal.model.allCrew">\n' +
    '        <label for="test22" class="small-checkbox"></label>\n' +
    '    </div>\n' +
    '</div>\n' +
    '<div class="modal-footer">\n' +
    '    <button class="btn btn-blue" type="button" ng-click="showInCrewPortal.onYesClick()">Ok</button>\n' +
    '</div>');
	a.put('configure_aircraft.tpl.html', '<div>\n' +
    '    <div class="popover-title margin-bottom-10">Configure Aircrafts\n' +
    '        <button type="button" class="close"><i class="material-icons">clear</i></button>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="clearfix"></div>\n' +
    '\n' +
    '    <div class="group">\n' +
    '\n' +
    '        <div class="btn-group select-dropdown" uib-dropdown="">\n' +
    '\n' +
    '           <!-- <button type="button" class="btn select-dropdown-label" uib-dropdown-toggle ng-click="submit()">\n' +
    '                {{selectedAction.name}}\n' +
    '            </button>\n' +
    '\n' +
    '            <ul class="dropdown-menu" role="menu" uib-dropdown-menu>\n' +
    '                <li ng-repeat="action in actions">\n' +
    '                    <a href="#" ng-click="setAction(action)">{{action.name}}</a>\n' +
    '                </li>\n' +
    '            </ul>-->\n' +
    '            <select-component component-name="Base" label-field-name="airPortCode" menu-data-source="$ctrl.baseType" selected-value="$ctrl.base"></select-component>\n' +
    '\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="clearfix"></div>\n' +
    '\n' +
    '\n' +
    '    <div class="col-md-12 col-sm-12 padding-0">\n' +
    '\n' +
    '        <label class="normal-label margin-bottom-20">AOG</label>\n' +
    '\n' +
    '        <div class="clearfix"></div>\n' +
    '        <div class="group">\n' +
    '\n' +
    '            <div class="col-md-6 padding-0">\n' +
    '\n' +
    '\n' +
    '                <input type="radio" name="radiog_dark" id="radio1" class="css-checkbox">\n' +
    '                <label for="radio1" class="css-label radGroup2">Enable</label>\n' +
    '\n' +
    '            </div>\n' +
    '            <div class="col-md-6 padding-0">\n' +
    '\n' +
    '\n' +
    '                <input type="radio" name="radiog_dark" id="radio2" class="css-checkbox" checked="checked">\n' +
    '                <label for="radio2" class="css-label radGroup2">Disable</label>\n' +
    '\n' +
    '\n' +
    '            </div>\n' +
    '\n' +
    '\n' +
    '            <div class="clearfix"></div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="clearfix"></div>\n' +
    '\n' +
    '\n' +
    '    <div class="group">\n' +
    '        <input type="text" value="08.05" required="">\n' +
    '        <span class="bar"></span>\n' +
    '\n' +
    '        <label>Starting Time</label>\n' +
    '        <i class="material-icons">access_time</i>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div class="group">\n' +
    '        <input type="text" value="08.05" required="">\n' +
    '        <span class="bar"></span>\n' +
    '\n' +
    '        <label>End Time</label>\n' +
    '        <i class="material-icons">access_time</i>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div class="col-md-12 padding-0 margin-bottom-10">\n' +
    '        <button class="btn-panel" type="button" ng-click="$ctrl.configureAircraft()">Apply</button>\n' +
    '    </div>\n' +
    '</div>');
	a.put('alert.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Send Alert</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="alert.closeMe()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '<div class="modal-body send-alert">\n' +
    '    <form novalidate="" name="alert.form" data-ng-submit="alert.onSendAlertClick()">\n' +
    '    <div class="row margin-bottom-20">\n' +
    '\n' +
    '        <div class="col-md-3">\n' +
    '            <label>Alert Content<span class="required-star">*</span></label>\n' +
    '        </div>\n' +
    '        <div class="col-md-9">\n' +
    '            <textarea data-ng-model="alert.model.params.message" required=""></textarea>\n' +
    '        </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row margin-bottom-10">\n' +
    '        <div class="col-md-12">\n' +
    '            <button class="btn btn-blue pull-right" type="submit">Send</button>\n' +
    '            <button class="btn btn-grey" type="button" data-ng-click="alert.closeMe()">Close</button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '</form></div>');
	a.put('admin_cmnd_descretion-popup.tpl.html', '<style type="text/css">\n' +
    '		@page { margin-right: 0.35in; margin-top: 0.25in; margin-bottom: 0.4in }\n' +
    '		p { margin-bottom: 0.1in; direction: ltr; color: #000000; line-height: 115%; orphans: 2; widows: 2 }\n' +
    '		p.western { font-family: "Times New Roman", serif; font-size: 12pt; so-language: en-US }\n' +
    '		p.cjk { font-family: "Times New Roman", serif; font-size: 12pt }\n' +
    '		p.ctl { font-family: "Times New Roman", serif; font-size: 12pt; so-language: ar-SA }\n' +
    '</style>\n' +
    '\n' +
    '<div class="modal-header">\n' +
    '  <h4 class="modal-title"></h4>\n' +
    '  <button type="button" class="close" data-dismiss="modal" data-ng-click="cmndDescretionPopup.onCloseClick()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '  </button>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal-body margin-bottom-50 show-expiry" style="-webkit-user-select: text;\n' +
    '    -khtml-user-select: text;\n' +
    '    -moz-user-select: text;\n' +
    '    -o-user-select: text;\n' +
    '    user-select: text">\n' +
    '  <div class="row">\n' +
    '\n' +
    '<div title="header">\n' +
    '	<table width="100%" cellpadding="7" cellspacing="0">\n' +
    '		<col width="203">\n' +
    '		<col width="255">\n' +
    '		<col width="190">\n' +
    '		<tr>\n' +
    '			<td rowspan="2" width="203" height="14" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '				<p align="center">\n' +
    '</p>\n' +
    '			</td>\n' +
    '			<td rowspan="2" width="255" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '				<p align="center"><font face="Arial, sans-serif"><font size="4" style="font-size: 14pt"><b>COMMANDER\'S DISCRETION REPORT</b></font></font></p>\n' +
    '			</td>\n' +
    '			<td width="190" style="border-top: 1px solid #000000; border-bottom: none; border-left: 1px solid #000000; border-right: 1px solid #000000; padding: 0in 0.08in">\n' +
    '				<p align="center" style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>REFERENCE\n' +
    '				NO (CDR)</b></font></font></p>\n' +
    '			</td>\n' +
    '		</tr>\n' +
    '		<tr>\n' +
    '			<td width="190" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000; padding: 0in 0.08in">\n' +
    '				<p style="text-transform: uppercase;text-align: center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b> {{cmndDescretionPopup.model.generalData.cdr}}</b></font></font></p>\n' +
    '			</td>\n' +
    '		</tr>\n' +
    '	</table>\n' +
    '	<p style="margin-bottom: 0in; line-height: 100%"><br>\n' +
    '\n' +
    '	</p>\n' +
    '</div>\n' +
    '<table width="100%" cellpadding="7" cellspacing="0" style="page-break-before: always">\n' +
    '	<col width="284">\n' +
    '	<col width="186">\n' +
    '	<col width="180">\n' +
    '	<tr>\n' +
    '		<td width="284" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western"><span style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Aircraft\n' +
    '			Registration : {{cmndDescretionPopup.model.generalData.acRegestrations}}</b></font></font></span></p>\n' +
    '		</td>\n' +
    '		<td width="186" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Aircraft\n' +
    '			Type : {{cmndDescretionPopup.model.generalData.acTypes}}</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="180" style="border: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p class="western"><span style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>DEP.\n' +
    '			Date</b></font></font></span><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>\n' +
    '			</b></font></font><sup><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b><sup style="top: -0.2em">(1)</sup></b></font></font></sup><span style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>\n' +
    '			:{{cmndDescretionPopup.model.generalData.departureDate}}</b></font></font></span></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '</table>\n' +
    '<p class="western" style="margin-bottom: 0in; line-height: 100%"><br></p>\n' +
    '<p class="western" align="center" style="margin-bottom: 0in; text-transform: uppercase; line-height: 100%">\n' +
    '<font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"></font></font></p>\n' +
    '<p class="western" style="margin-bottom: 0in; text-transform: uppercase; line-height: 100%"><br></p>\n' +
    '\n' +
    '<!-- Part A -->\n' +
    '<table width="100%" cellpadding="7" cellspacing="0">\n' +
    '	<col width="220">\n' +
    '	<col width="94">\n' +
    '	<col width="226">\n' +
    '	<col width="94">\n' +
    '	<tr>\n' +
    '		<td colspan="4" width="677" height="9" bgcolor="#d8d8d8" style="background: #d8d8d8" style="border: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p class="western" style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Part\n' +
    '			A : Crew Members Affected</b></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td width="220" height="10" style="border-top: 1.00pt solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Name</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="94" style="border-top: 1.00pt solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Position</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="226" style="border-top: 1.00pt solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Name</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="94" style="border-top: 1.00pt solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p class="western" align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Position</b></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr ng-repeat="a in cmndDescretionPopup.model.partA track by $index" ng-if="$index % 2 == 0">\n' +
    '		<td width="220" height="10" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western"><br>\n' +
    '				{{a.crewName}}\n' +
    '			</p>\n' +
    '		</td>\n' +
    '		<td width="94" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western"><br>\n' +
    '				{{a.crewTypeCode}}\n' +
    '			</p>\n' +
    '		</td>\n' +
    '		<td width="226" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p ng-if="!$last" class="western"><br>\n' +
    '				{{cmndDescretionPopup.model.partA[$index + 1].crewName}}\n' +
    '			</p>\n' +
    '		</td>\n' +
    '		<td width="94" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p ng-if="!$last" class="western"><br>\n' +
    '				{{cmndDescretionPopup.model.partA[$index + 1].crewTypeCode}}\n' +
    '			</p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '</table>\n' +
    '\n' +
    '<!-- Part B -->\n' +
    '<p class="western" style="margin-bottom: 0in; line-height: 100%"><br>\n' +
    '\n' +
    '</p>\n' +
    '<table width="100%" cellpadding="7" cellspacing="0">\n' +
    '	<colgroup>\n' +
    '		<col width="217">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="69">\n' +
    '		<col width="26">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="57">\n' +
    '		<col width="27">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="213">\n' +
    '	</colgroup>\n' +
    '	<tr>\n' +
    '		<td colspan="6" width="679" height="9" bgcolor="#d8d8d8" style="background: #d8d8d8" style="border: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p class="western" style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Part\n' +
    '			B : reduction of pre-flight rest</b></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td width="217" height="7" style="border-top: 1.00pt solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" style="text-transform: uppercase"><br>\n' +
    '\n' +
    '			</p>\n' +
    '		</td>\n' +
    '		<td colspan="4" width="222" style="border-top: 1.00pt solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>UTC\n' +
    '			</b></font></font><sup><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b><sup style="top: -0.2em">(2)</sup></b></font></font></sup></p>\n' +
    '		</td>\n' +
    '		<td width="213" style="border-top: 1.00pt solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p class="western" align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Local\n' +
    '			</b></font></font><sup><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b><sup style="top: -0.2em">(2)</sup></b></font></font></sup></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td width="217" height="7" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Last\n' +
    '			duty started</font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="4" width="222" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" align="center"><font color="#000000"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partB.lastDutyStartedUTC}}</font></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="213" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p class="western" align="center"><font color="#000000"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partB.lastDutyStartedLocal}}</font></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td width="217" height="7" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Last\n' +
    '			duty ended</font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="4" width="222" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" align="center"><font color="#000000"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partB.lastDutyEndedUTC}}</font></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="213" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p class="western" align="center"><font color="#000000"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partB.lastDutyEndedLocal}}</font></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td width="217" height="7" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Rest\n' +
    '			earned</font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="4" width="222" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" align="center"><font color="#000000"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partB.restEarned}}</font></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="213" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p class="western" align="center"><font color="#c0c0c0"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"></font></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td width="217" height="7" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Calculated\n' +
    '			earliest next available</font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="4" width="222" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" align="center"><font color="#000000"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partB.calculatedEarliestNextAvailableUTC}}</font></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="213" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p class="western" align="center"><font color="#000000"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partB.calculatedEarliestNextAvailableLocal}}</font></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td width="217" height="7" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Actual\n' +
    '			start of next duty period</font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="4" width="222" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" align="center"><font color="#000000"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partB.nextDutyPeriodStartUTC}}</font></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="213" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1px solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p class="western" align="center"><font color="#000000"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partB.nextDutyPeriodStartLocal}}</font></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td width="217" height="10" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Rest\n' +
    '			period reduced by :</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="69" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" style="text-transform: uppercase"><br>\n' +
    '\n' +
    '			</p>\n' +
    '		</td>\n' +
    '		<td width="26" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '			<p class="western" align="right"> {{cmndDescretionPopup.model.partB.restPeriodReducedByHours}}\n' +
    '				<font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Hrs.</b></font></font>\n' +
    '			</p>\n' +
    '		</td>\n' +
    '		<td width="57" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western"><br></p>\n' +
    '		</td>\n' +
    '		<td width="27" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '			<p class="western" align="right"> {{cmndDescretionPopup.model.partB.restPeriodReducedByMinutes}}\n' +
    '				<font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b> Min.</b></font></font>\n' +
    '			</p>\n' +
    '		</td>\n' +
    '		<td width="213" style="border-top: 1.00pt solid #000000; border-bottom: none; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western"><br></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '</table>\n' +
    '\n' +
    '\n' +
    '<!-- Part C -->\n' +
    '<p class="western" style="margin-bottom: 0in; line-height: 100%"><br></p>\n' +
    '<table width="100%" cellpadding="4" cellspacing="0" style="background: transparent; page-break-before: auto; page-break-after: auto; page-break-inside: auto">\n' +
    '	<colgroup>\n' +
    '		<col width="78">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="4361">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="78">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="6">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="21">\n' +
    '		<col width="35">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="4">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="24">\n' +
    '		<col width="35">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="97">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="28">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="16">\n' +
    '		<col width="15">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="17">\n' +
    '		<col width="16">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="5">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="15">\n' +
    '	</colgroup>\n' +
    '	<colgroup>\n' +
    '		<col width="4368">\n' +
    '		<col width="21">\n' +
    '		<col width="30">\n' +
    '	</colgroup>\n' +
    '	<tr>\n' +
    '		<td colspan="24" width="684" height="15" bgcolor="#d8d8d8" style="background: #d8d8d8" style="border: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Part C : EXTENSION OF DUTY PERIOD</b></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td colspan="24" width="684" height="16" style="border-top: 1.00pt solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p align="center" style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Flight Details</b></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td colspan="12" width="337" height="13" style="border-top: 1.00pt solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p align="center" style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Planned</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="12" width="339" style="border-top: 1.00pt solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p align="center" style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Actual</b></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td colspan="3" width="12.5%" height="13" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p style="text-transform: uppercase"><br></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Place</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>UTC\n' +
    '			</b></font></font><sup><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b><sup style="top: -0.2em">(2)</sup></b></font></font></sup></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Local\n' +
    '			</b></font></font><sup><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b><sup style="top: -0.2em">(2)</sup></b></font></font></sup></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p align="center"><br></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Place</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>UTC\n' +
    '			</b></font></font><sup><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b><sup style="top: -0.2em">(2)</sup></b></font></font></sup></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Local\n' +
    '			</b></font></font><sup><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b><sup style="top: -0.2em">(2)</sup></b></font></font></sup></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td colspan="3" width="12.5%" height="13" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Duty Start</font></font></p>\n' +
    '		</td>\n' +
    '\n' +
    '		<td colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0.04in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.plannedDutyStartPlace}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0.04in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partC1.plannedDutyStartUTC}}</font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="12.5%" style="border: 1px solid #000000; padding: 0.04in 0.08in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partC1.plannedDutyStartLocal}}</font></font></p>\n' +
    '		</td>\n' +
    '\n' +
    '		<td colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Duty Start</font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0.04in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.actualDutyStartPlace}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0.04in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partC1.actualDutyStartUTC}}</font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="12.5%" style="border: 1px solid #000000; padding: 0.04in 0.08in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partC1.actualDutyStartLocal}}</font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '\n' +
    '	<!-- Part C 2------>\n' +
    '\n' +
    '	<tr ng-repeat="c2 in cmndDescretionPopup.model.partC2 track by $index" style="background: transparent">\n' +
    '				\n' +
    '			<!-- Departure -->\n' +
    '		\n' +
    '				<td ng-if="c2.number % 2 == 1" colspan="3" width="12.5%" height="13" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '					<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Depart</font></font></p>\n' +
    '				</td>\n' +
    '				<td ng-if="c2.number  % 2 == 1" colspan="3" width="12.5%" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000;; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '					<p>{{c2.plannedDeparturePlace}}<br></p>\n' +
    '				</td>\n' +
    '				<td ng-if="c2.number  % 2 == 1" colspan="3" width="12.5%" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000;; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '					<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{c2.plannedDepartureDateUTC}}</font></font></p>\n' +
    '				</td>\n' +
    '				<td ng-if="c2.number  % 2 == 1" colspan="3" width="12.5%" style="background: transparent" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0.08in">\n' +
    '					<p><br></p>\n' +
    '				</td>\n' +
    '				\n' +
    '				<td ng-if="c2.number  % 2 == 1" colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '					<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Depart</font></font></p>\n' +
    '				</td>\n' +
    '				<td ng-if="c2.number  % 2 == 1" colspan="3" width="12.5%" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '					<p>{{c2.actualDeparturePlace}}<br></p>\n' +
    '				</td>\n' +
    '				<td ng-if="c2.number  % 2 == 1" colspan="3" width="12.5%" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '					<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{c2.actualDepartureDateUTC}}</font></font></p>\n' +
    '				</td>\n' +
    '				<td ng-if="c2.number  % 2 == 1" colspan="3" width="12.5%" style="background: transparent" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0.08in">\n' +
    '					<p><br></p>\n' +
    '				</td>\n' +
    '				\n' +
    '			<!-- Arrival -->\n' +
    '		\n' +
    '				<td ng-if="c2.number  % 2 == 0" colspan="3" width="12.5%" height="13" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '					<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Arrive</font></font></p>\n' +
    '				</td>\n' +
    '				<td ng-if="c2.number  % 2 == 0" colspan="3" width="12.5%" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000;; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '					<p>{{c2.plannedArrivalPlace}}<br></p>\n' +
    '				</td>\n' +
    '				<td ng-if="c2.number  % 2 == 0" colspan="3" width="12.5%" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000;; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '					<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{c2.plannedArrivalDateUTC}}</font></font></p>\n' +
    '				</td>\n' +
    '				<td ng-if="c2.number  % 2 == 0" colspan="3" width="12.5%" style="background: transparent" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0.08in">\n' +
    '					<p><br></p>\n' +
    '				</td>\n' +
    '				\n' +
    '				<td ng-if="c2.number  % 2 == 0" colspan="3" width="12.5%" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '					<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Arrive</font></font></p>\n' +
    '				</td>\n' +
    '				<td ng-if="c2.number  % 2 == 0" colspan="3" width="12.5%" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '					<p>{{c2.actualArrivalPlace}}<br></p>\n' +
    '				</td>\n' +
    '				<td ng-if="c2.number  % 2 == 0" colspan="3" width="12.5%" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '					<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{c2.actualArrivalDateUTC}}</font></font></p>\n' +
    '				</td>\n' +
    '				<td ng-if="c2.number  % 2 == 0" colspan="3" width="12.5%" style="background: transparent" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0.08in">\n' +
    '					<p><br></p>\n' +
    '				</td>\n' +
    '		\n' +
    '	</tr>\n' +
    '\n' +
    '	<!-- Part C 2------>\n' +
    '\n' +
    '	<tr style="background: transparent">\n' +
    '		<td colspan="3" width="78" height="13" bgcolor="#d8d8d8" style="background: #d8d8d8" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><br></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="79" bgcolor="#d8d8d8" style="background: #d8d8d8" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><br></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="79" bgcolor="#d8d8d8" style="background: #d8d8d8" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><br></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="79" bgcolor="#d8d8d8" style="background: #d8d8d8" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><br></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="97" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">FDP ended </font></font><sup><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">(3)</font></font></sup></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="76" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.fdpEndedPlace}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="77" style="border-top: none; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000; padding-top: 0in; padding-bottom: 0.04in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partC1.fdpEndedDateUTC}}</font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="66" style="background: transparent" style="">\n' +
    '			<p><br></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '\n' +
    '	<!-- Part C 1---- -->\n' +
    '\n' +
    '	<tr>\n' +
    '		<td colspan="8" width="40%" height="16" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Planned flight duty time : </b></font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="1" width="2.5%" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.plannedFlightDutyTimeH}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="1" width="2.5%" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '			<p align="right"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Hrs</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="1" width="2.5%" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.plannedFlightDutyTimeM}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="1" width="2.5%" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '			<p align="right"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Min</b></font></font></p>\n' +
    '		</td>\n' +
    '\n' +
    '		<td colspan="8" colspan="3" width="40%" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p align="left"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Actual flight duty time :</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="1" width="2.5%" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.actualFlightDutyTimeH}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="1" width="2.5%" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '			<p align="right"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Hrs</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="1" width="2.5%" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.actualFlightDutyTimeM}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="1" width="2.5%" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: 1.00pt solid #000000; padding-top: 0in; padding-bottom: 0in; padding-left: 0in; padding-right: 0.08in">\n' +
    '			<p align="right"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Min</b></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td colspan="15" width="478" height="16" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Flying Duty Time Standard Rules (OM-A  7.3.3) </b></font></font><sup><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>(4):</b></font></font></sup></p>\n' +
    '		</td>\n' +
    '		<td width="16" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.flyingDutyTimeStandardH}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="64" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Hrs</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="35" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.flyingDutyTimeStandardM}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="2" width="59" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: 1.00pt solid #000000; padding-top: 0in; padding-bottom: 0in; padding-left: 0in; padding-right: 0.08in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Min</b></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td colspan="15" width="478" height="16" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Extended FDP  (OM-A 7.4.4) or</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="16" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partC1.extendedFdpH}}</font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="64" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Hrs</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="35" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><br>{{cmndDescretionPopup.model.partC1.extendedFdpM}}</p>\n' +
    '		</td>\n' +
    '		<td colspan="2" width="59" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: none; border-right: 1.00pt solid #000000; padding-top: 0in; padding-bottom: 0in; padding-left: 0in; padding-right: 0.08in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Min</b></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td colspan="15" width="478" height="16" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Extended FDP by Split Duty (OM-A 7.4.2) or</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="16" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partC1.extendedFdpBySplitDutyH}}</font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="64" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Hrs</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="35" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.extendedFdpBySplitDutyH}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="2" width="59" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: none; border-right: 1.00pt solid #000000; padding-top: 0in; padding-bottom: 0in; padding-left: 0in; padding-right: 0.08in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Min</b></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td colspan="15" width="478" height="16" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Extended FDP by In-Flight Rest (OM-A 7.4.1) :</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="16" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">{{cmndDescretionPopup.model.partC1.extendedFdpByInFlightRestH}}</font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="64" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Hrs</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="35" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.extendedFdpByInFlightRestH}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="2" width="59" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: none; border-right: 1.00pt solid #000000; padding-top: 0in; padding-bottom: 0in; padding-left: 0in; padding-right: 0.08in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Min</b></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td colspan="15" width="478" height="16" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Maximum legal FDP including Discretion :</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td width="16" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.maxLegalFdpIncludingDiscretionH}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="64" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Hrs</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="35" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.maxLegalFdpIncludingDiscretionM}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="2" width="59" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: none; border-right: 1.00pt solid #000000; padding-top: 0in; padding-bottom: 0in; padding-left: 0in; padding-right: 0.08in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Min</b></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td colspan="15" width="478" height="15" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Discretion (OM-A 7.4.4)(Actual flight duty time minus Flying Duty Time Standard Rules) </b></font></font>\n' +
    '			</p>\n' +
    '		</td>\n' +
    '		<td width="16" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.discretionH}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="64" style="border-top: 1.00pt solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Hrs</b></font></font></p>\n' +
    '		</td>\n' +
    '		<td colspan="3" width="35" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p>{{cmndDescretionPopup.model.partC1.discretionM}}<br></p>\n' +
    '		</td>\n' +
    '		<td colspan="2" width="59" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: none; border-right: 1.00pt solid #000000; padding-top: 0in; padding-bottom: 0in; padding-left: 0in; padding-right: 0.08in">\n' +
    '			<p align="center"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Min</b></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '</table>\n' +
    '\n' +
    '<!-- Part D -->\n' +
    '<p class="western" style="margin-bottom: 0in; line-height: 100%"><br>\n' +
    '\n' +
    '</p>\n' +
    '<table width="100%" cellpadding="7" cellspacing="0">\n' +
    '	<col width="340">\n' +
    '	<col width="166">\n' +
    '	<col width="150">\n' +
    '	<col width="144">\n' +
    '	<tr>\n' +
    '		<td colspan="5" width="828" height="9" bgcolor="#d8d8d8" style="background: #d8d8d8" style="border: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p class="western"><span style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Part D : CAPTAIN\'S REPORT OF CIRCUMSTANCES </b></font></font></span><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><i><b>(Use\n' +
    '			Capital Letters)</b></i></font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '	<tr>\n' +
    '		<td colspan="5" width="828" height="15" style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1.00pt solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p class="western" style="text-transform: uppercase"><br>{{cmndDescretionPopup.model.partD.cpsCircumstances}}</p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '\n' +
    '	<tr valign="bottom">\n' +
    '		<td width="340" height="43" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">NAME : {{cmndDescretionPopup.model.partD.cpsName}}</font></font></p>\n' +
    '		</td>\n' +
    '		<td width="166" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1px solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<p class="western" align="left"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">SIGN :</font></font>\n' +
    '			</p>\n' +
    '		</td>\n' +
    '		<td width="150" height="43" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none;border-left: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '			<div style="width:140px" align="right"><img align="right" style="max-width: 100%; max-height: 100%" src="{{cmndDescretionPopup.model.partD.cpsSign}}"></div>\n' +
    '		</td>\n' +
    '		<td width="144" style="border-top: 1px solid #000000; border-bottom: 1.00pt solid #000000; border-left: 1px solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '			<p class="western"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">DATE : {{cmndDescretionPopup.model.partD.signedDate}}</font></font></p>\n' +
    '		</td>\n' +
    '	</tr>\n' +
    '</table>\n' +
    '<p class="western" align="justify" style="margin-bottom: 0in; line-height: 100%">\n' +
    '<br>\n' +
    '\n' +
    '<!-- Part E -->\n' +
    '<table width="100%" cellpadding="7" cellspacing="0">\n' +
    '	<col width="52">\n' +
    '	<col width="92">\n' +
    '	<col width="73">\n' +
    '	<col width="73">\n' +
    '	<col width="43">\n' +
    '	<col width="214">\n' +
    '	<col width="48">\n' +
    '	<tbody>\n' +
    '		<tr>\n' +
    '			<td colspan="7" width="678" height="9" bgcolor="#d8d8d8" style="background: #d8d8d8" style="border: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '				<p class="western" style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><b>Part E : REMARKS AND ACTION</b></font></font></p>\n' +
    '			</td>\n' +
    '		</tr>\n' +
    '	</tbody>\n' +
    '	<tbody>\n' +
    '		<tr>\n' +
    '			<!-- <td colspan="7" width="678" height="15" style="border-top: 1.00pt solid #000000; border-bottom: none; border-left: 1.00pt solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '				<p class="western"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Discretion\n' +
    '				Correctly Exercised :	</font></font><span style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Yes\n' +
    '				</font></font></span><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">/\n' +
    '				NO</font></font><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">\n' +
    '				</font></font><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt"><i>(Circle\n' +
    '				as appropriate)</i></font></font></p>\n' +
    '			</td> -->\n' +
    '		</tr>\n' +
    '		<tr ng-repeat="e in cmndDescretionPopup.model.partE.adminRemarks track by $index ">\n' +
    '			<td colspan="7" width="678" height="15" style="border-top: none; border-bottom: 1.00pt dotted #000000; border-left: 1.00pt solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '				<p class="western"><br>\n' +
    '					{{e}}\n' +
    '				</p>\n' +
    '			</td>\n' +
    '		</tr>\n' +
    '\n' +
    '		<tr ng-if="cmndDescretionPopup.model.partE.isDiscretionExercisedCorrectly">\n' +
    '			<td width="52" height="16" style="border-top: none; border-bottom: none; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '				<p class="western"><span style="text-transform: uppercase"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Date</font></font></span><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">\n' +
    '				: </font></font>\n' +
    '				</p>\n' +
    '			</td>\n' +
    '			<td width="92" style="border-top: none; border-bottom: 1px solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '				<p class="western"><br>\n' +
    '\n' +
    '				</p>\n' +
    '			</td>\n' +
    '			<td width="73" style="border: none; padding: 0in">\n' +
    '				<p class="western"><br>\n' +
    '\n' +
    '				</p>\n' +
    '			</td>\n' +
    '			<td width="73" style="border: none; padding: 0in">\n' +
    '				<p class="western"><br>\n' +
    '\n' +
    '				</p>\n' +
    '			</td>\n' +
    '			<td width="43" style="border: none; padding: 0in">\n' +
    '				<p class="western"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">SIGN :</font></font></p>\n' +
    '			</td>\n' +
    '			<td width="214" style="border-top: none; border-bottom: 1px solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '				<p class="western"><br>\n' +
    '\n' +
    '				</p>\n' +
    '			</td>\n' +
    '			<td width="48" style="border-top: none; border-bottom: none; border-left: none; border-right: 1.00pt solid #000000; padding-top: 0in; padding-bottom: 0in; padding-left: 0in; padding-right: 0.08in">\n' +
    '				<p class="western"><br>\n' +
    '\n' +
    '				</p>\n' +
    '			</td>\n' +
    '		</tr>\n' +
    '		<tr ng-if="cmndDescretionPopup.model.partE.isDiscretionExercisedCorrectly">\n' +
    '			<td colspan="4" width="332" height="15" style="border-top: none; border-bottom: 1.00pt solid #000000; border-left: 1.00pt solid #000000; border-right: none; padding-top: 0in; padding-bottom: 0in; padding-left: 0.08in; padding-right: 0in">\n' +
    '				<p class="western"><br>\n' +
    '\n' +
    '				</p>\n' +
    '			</td>\n' +
    '			<td width="43" style="border-top: none; border-bottom: 1.00pt solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '				<p class="western"><br>\n' +
    '\n' +
    '				</p>\n' +
    '			</td>\n' +
    '			<td width="214" valign="top" style="border-top: none; border-bottom: 1.00pt solid #000000; border-left: none; border-right: none; padding: 0in">\n' +
    '				<p class="western" align="center" style="margin-top: 0.03in"><font face="Arial, sans-serif"><font size="2" style="font-size: 10pt">Chief\n' +
    '				Pilot </font></font>\n' +
    '				</p>\n' +
    '			</td>\n' +
    '			<td width="48" style="border-top: none; border-bottom: 1.00pt solid #000000; border-left: none; border-right: 1.00pt solid #000000; padding-top: 0in; padding-bottom: 0in; padding-left: 0in; padding-right: 0.08in">\n' +
    '				<p class="western"><br>\n' +
    '\n' +
    '				</p>\n' +
    '			</td>\n' +
    '		</tr>\n' +
    '\n' +
    '		<tr ng-if="cmndDescretionPopup.model.remarkButtonClicked">\n' +
    '			<td colspan="7" width="678" height="15" style="border-top: none; border-bottom: 1.00pt dotted #000000; border-left: 1.00pt solid #000000; border-right: 1.00pt solid #000000; padding: 0in 0.08in">\n' +
    '				<textarea id="adminRemark" name="adminRemark" ng-model="cmndDescretionPopup.model.remarks" rows="5" cols="50"></textarea>\n' +
    '			</td>\n' +
    '		</tr>\n' +
    '\n' +
    '	</tbody>\n' +
    '</table>\n' +
    '\n' +
    '\n' +
    '	<div class="modal-footer confirmation-footer">\n' +
    '\n' +
    '	    <button ng-if="!cmndDescretionPopup.model.remarkButtonClicked && cmndDescretionPopup.model.generalData.status != \'APPROVED\'" class="btn btn-blue" type="button" ng-click="cmndDescretionPopup.onRemoarkClick()">Add Remark</button>\n' +
    '	    <button ng-if="!cmndDescretionPopup.model.remarkButtonClicked && cmndDescretionPopup.model.generalData.status != \'REJECTED\' && cmndDescretionPopup.model.generalData.status != \'APPROVED\'" class="btn btn-red" style="background-color: red" type="button" ng-click="cmndDescretionPopup.onReject()">Reject</button>\n' +
    '	    <button ng-if="!cmndDescretionPopup.model.remarkButtonClicked && cmndDescretionPopup.model.generalData.status != \'APPROVED\'" class="btn btn-green" style="background-color: #39b54a" type="button" ng-click="cmndDescretionPopup.onApprove()">Approve</button>\n' +
    '\n' +
    '	    <button ng-if="cmndDescretionPopup.model.remarkButtonClicked" class="btn btn-grey" type="button" data-ng-click="$close()">Cancel</button>\n' +
    '	    <button ng-if="cmndDescretionPopup.model.remarkButtonClicked" class="btn btn-blue" type="button" ng-click="cmndDescretionPopup.onSaveRemark()">Save</button>\n' +
    '\n' +
    '	</div>\n' +
    '\n' +
    '  </p></div>\n' +
    '</div>');
	a.put('add_roster_score_version.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Score Version</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="scoreVersion.closeMe()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '<div class="modal-body add-pattern">\n' +
    '\n' +
    '    <form novalidate="" name="scoreVersion.form" data-ng-submit="scoreVersion.onSaveClick()">\n' +
    '        <div class="row margin-bottom-10">\n' +
    '\n' +
    '            <div class="col-md-2">\n' +
    '                <label>Category<span class="required-star">*</span></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-10">\n' +
    '                <select-component is-required="true" component-name="Crew Type" label-field-name="crewTypeDescription" value-field-name="crewTypeCode" menu-data-source="scoreVersion.model.crewTypes" selected-value="scoreVersion.model.params.crewType"></select-component>\n' +
    '            </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row margin-bottom-20">\n' +
    '\n' +
    '            <div class="col-md-2">\n' +
    '                <label>Score Version name<span class="required-star">*</span></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-10">\n' +
    '                <textarea data-ng-model="scoreVersion.model.params.scoreVersion" required=""></textarea>\n' +
    '            </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row margin-bottom-10">\n' +
    '\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row margin-bottom-10">\n' +
    '            <div class="col-md-12">\n' +
    '                <button class="btn btn-blue pull-right" type="submit">Save</button>\n' +
    '                <button class="btn btn-grey" type="button" data-ng-click="scoreVersion.closeMe()">Close</button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </form>\n' +
    '\n' +
    '</div>');
	a.put('add_memo.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">Memo</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="memo.closeMe()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '<div class="modal-body add-pattern">\n' +
    '\n' +
    '    <form novalidate="" name="memo.form" data-ng-submit="memo.onSaveClick()">\n' +
    '\n' +
    '      <div class="row margin-bottom-40">\n' +
    '        <div class="col-md-2">\n' +
    '          <label>Crew ID  :</label>\n' +
    '        </div>\n' +
    '        <div class="col-md-10">\n' +
    '          <label>{{memo.model.params.crewId + \' ( Group : \' + (memo.model.params.group==null ? \'- \' : (memo.model.params.group) + \' \') + \'| Batch : \' + (memo.model.params.batch==null ? \'- )\' : (memo.model.params.batch)+\' )\')}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '        <div class="row margin-bottom-10">\n' +
    '\n' +
    '            <div class="col-md-2">\n' +
    '                <label>Category<span class="required-star">*</span></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-10">\n' +
    '                <select-component is-required="true" is-disable="(!!memo.model.params.memoId && !memo.model.params.status) || memo.model.params.readOnly" component-name="Memo Category" label-field-name="categoryDescription" value-field-name="categoryCode" menu-data-source="memo.model.memoCategoryTypes" selected-value="memo.model.params.memoCategory"></select-component>\n' +
    '            </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row margin-bottom-20">\n' +
    '\n' +
    '            <div class="col-md-2">\n' +
    '                <label>Message<span class="required-star">*</span></label>\n' +
    '            </div>\n' +
    '            <div class="col-md-10">\n' +
    '                <textarea data-ng-model="memo.model.params.message" required="" ng-disabled="(!!memo.model.params.memoId && !memo.model.params.status) ||memo.model.params.readOnly"></textarea>\n' +
    '            </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row margin-bottom-10" ng-if="!memo.model.params.readOnly">\n' +
    '\n' +
    '            <div class="col-md-5">\n' +
    '                <label class="normal-label">Show Memo on Crew Schedule</label>\n' +
    '            </div>\n' +
    '            <div class="col-md-7">\n' +
    '                <input type="checkbox" ng-disabled="!!memo.model.params.memoId && !memo.model.params.status" id="test11" ng-model="memo.model.params.showOnCrewScheduleFlag"><label for="test11" class="margin-top-5"></label>\n' +
    '            </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row margin-bottom-10" ng-if="!memo.model.params.readOnly">\n' +
    '            <div class="col-md-12">\n' +
    '                <button class="btn btn-delete" type="button" data-ng-click="memo.onDeleteClick()" ng-show="memo.model.params.memoId">Delete\n' +
    '                </button>\n' +
    '                <button class="btn btn-blue pull-right" type="submit">Save</button>\n' +
    '                <button class="btn btn-grey" type="button" data-ng-click="memo.closeMe()">Close</button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </form>\n' +
    '\n' +
    '</div>');
	a.put('add_edit_distance.tpl.html', '<div class="modal-header">\n' +
    '    <h4 class="modal-title">{{distance.model.modalTitle}} Great Circle Distance</h4>\n' +
    '    <button type="button" class="close" data-dismiss="modal" data-ng-click="distance.closeMe()" aria-hidden="true"><i class="material-icons">clear</i>\n' +
    '    </button>\n' +
    '</div>\n' +
    '<form name="distance.searchAny" novalidate="" ng-submit="distance.onSaveDistance()">\n' +
    '	<div class="modal-body add-distance">\n' +
    '\n' +
    '	    <div class="row">\n' +
    '\n' +
    '	        <div class="col-md-2 col-xs-2 col-sm-2">\n' +
    '	            <label>Origin</label>\n' +
    '	        </div>\n' +
    '	        <div class="col-md-10">\n' +
    '	        	<div class="group">\n' +
    '	                <input ng-disabled="distance.model.request.gridCircleId" type="text" ng-model="distance.model.request.origin" typeahead="" ng-required="true" name="origin" uib-typeahead="airport as airport.airPortCode for airport in distance.model.airportList | filter:$viewValue" typeahead-is-open="true" typeahead-editable="false">\n' +
    '	                <span class="bar"></span>\n' +
    '	                <div ng-messages="distance.searchAny.$submitted && distance.searchAny.origin.$error" role="alert">\n' +
    '	                    <div ng-message="required" class="validation-error">Origin is required.</div>\n' +
    '	                </div>\n' +
    '				</div>\n' +
    '	        </div>\n' +
    '	    </div>\n' +
    '\n' +
    '	    <div class="row">\n' +
    '	        <div class="col-md-2 col-xs-2 col-sm-2">\n' +
    '	            <label>Destination</label>\n' +
    '	        </div>\n' +
    '	        <div class="col-md-10">\n' +
    '	        	<div class="group">\n' +
    '	                <input ng-disabled="distance.model.request.gridCircleId" type="text" ng-model="distance.model.request.destination" typeahead="" ng-required="true" name="destination" uib-typeahead="airport as airport.airPortCode for airport in distance.model.airportList | filter:$viewValue" typeahead-is-open="true" typeahead-editable="false">\n' +
    '	                <span class="bar"></span>\n' +
    '	                <div ng-messages="distance.searchAny.$submitted && distance.searchAny.destination.$error" role="alert">\n' +
    '	                    <div ng-message="required" class="validation-error">Destination is required.</div>\n' +
    '	                </div>\n' +
    '				</div>\n' +
    '	        </div>\n' +
    '\n' +
    '	    </div>\n' +
    '\n' +
    '	    <div class="row">\n' +
    '\n' +
    '	        <div class="col-md-2 col-xs-2 col-sm-2">\n' +
    '	            <label>Distance(km)</label>\n' +
    '	        </div>\n' +
    '	        <div class="col-md-10">\n' +
    '	           <input type="number" ng-required="true" ng-model="distance.model.request.distance" name="distance">\n' +
    '	           <div ng-messages="distance.searchAny.$submitted && distance.searchAny.distance.$error" role="alert">\n' +
    '                   <div ng-message="required" class="validation-error">Distance is required.</div>\n' +
    '	           </div>\n' +
    '	        </div>\n' +
    '\n' +
    '	    </div>\n' +
    '\n' +
    '	    <div class="row margin-top-30">\n' +
    '			<div class="col-md-2 col-xs-2 col-sm-2">\n' +
    '				<button class="btn btn-grey" type="button" data-ng-click="distance.closeMe()">Cancel</button>\n' +
    '			</div>\n' +
    '			<div class="col-md-10">\n' +
    '				<button class="btn btn-blue pull-right" type="submit">Save</button>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '	</div>\n' +
    '</form>');
	 }]);